webpackJsonp([6],{

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cloneObj = undefined;

var _stringify = __webpack_require__(51);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(77);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.getNowTime = getNowTime;
exports.routeMap = routeMap;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getNowTime(format) {
    var d = new Date(),
        year = d.getFullYear(),
        month = d.getMonth() + 1,
        date = d.getDate(),
        hours = d.getHours(),
        minutes = d.getMinutes(),
        seconds = d.getSeconds();
    if (format !== 'yyyy-mm-dd hh:mm:ss') {
        return year + '-' + month + '-' + date;
    }
    return year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds;
}

function routeMap(url) {
    return '/beltline' + url;
}

var cloneObj = exports.cloneObj = function cloneObj(obj) {
    var str,
        newobj = obj.constructor === Array ? [] : {};
    if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
        return;
    } else if (window.JSON) {
        str = (0, _stringify2.default)(obj), newobj = JSON.parse(str);
    } else {
        for (var i in obj) {
            newobj[i] = (0, _typeof3.default)(obj[i]) === 'object' ? cloneObj(obj[i]) : obj[i];
        }
    }
    return newobj;
};

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds() };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return fmt;
};

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(754),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.headerOption = exports.routerType = exports.eventType = exports.searchOptions = exports.roleTypeId = exports.roleType = exports.auditFullType = exports.auditType = exports.newsPlatformType = exports.newsListAddr = exports.newsPlatform = exports.hotsType = exports.newsType = exports.ACCOUNT = exports.TOKEN = exports.QUERY_HOST = exports.API_HOST = exports.CONSOLE_HOST = exports.MOCK_DEBUG = undefined;

var _assign = __webpack_require__(122);

var _assign2 = _interopRequireDefault(_assign);

exports.setParams = setParams;

var _store = __webpack_require__(169);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOCK_DEBUG = exports.MOCK_DEBUG = false;

var CONSOLE_HOST = exports.CONSOLE_HOST = MOCK_DEBUG === true ? '' : window.location.host === 'localhost:8000' || window.location.host === 'test.banma.jizhuoyangqing.com' ? '//59.110.240.142:8080' : '//be.banma.jizhuoyangqing.com:8080';
console.debug("config>" + window.location.host);
var API_HOST = exports.API_HOST = MOCK_DEBUG === true ? '' : window.location.host === 'localhost:8000' || window.location.host === 'test.banma.jizhuoyangqing.com' ? '//59.110.240.142:80' : '//api.banma.jizhuoyangqing.com';

var QUERY_HOST = exports.QUERY_HOST = MOCK_DEBUG === true ? '' : window.location.host === 'localhost:8000' || window.location.host === 'test.banma.jizhuoyangqing.com' ? '//be.banma.jizhuoyangqing.com' : '//be.banma.jizhuoyangqing.com';

var TOKEN = exports.TOKEN = _store2.default.getters.getToken;
var ACCOUNT = exports.ACCOUNT = _store2.default.getters.getAccount;

var newsType = exports.newsType = {
    "2": "时政",
    "3": "社会",
    "4": "国际",
    "5": "科技",
    "6": "财经",
    "7": "娱乐",
    "8": "体育",
    "9": "军事",
    "10": "时尚"
};

var hotsType = exports.hotsType = {
    "0": "头条",
    "1": "HOT 1",
    "2": "HOT 2",
    "3": "HOT 3",
    "4": "HOT 4",
    "5": "HOT 5",
    "6": "HOT 6",
    "7": "HOT 7"
};

var newsPlatform = exports.newsPlatform = {
    "1": "腾讯新闻",
    "2": "新浪新闻",
    "3": "中新网",
    "4": "凤凰网",
    "5": "人民网",
    "6": "网易新闻",
    "7": "今日头条"
};

var newsListAddr = exports.newsListAddr = [{ "value": "腾讯新闻", "address": "qq.com" }, { "value": "新浪新闻", "address": "sina.com.cn" }, { "value": "中新网", "address": "chinanews.com" }, { "value": "凤凰网", "address": "ifeng.com" }, { "value": "人民网", "address": "people.com.cn/" }, { "value": "网易新闻", "address": "163.com" }, { "value": "今日头条", "address": "toutiao.com" }];

var newsPlatformType = exports.newsPlatformType = {
    "腾讯新闻": "1",
    "百度新闻": "2"
};

var auditType = exports.auditType = {
    "1": "编辑端",
    "2": "录音端",
    "5": "回收站"
};

var auditFullType = exports.auditFullType = {
    "1": "编辑中",
    "2": "录音中",
    "3": "审核中",
    "4": "已发布",
    "5": "回收站",
    "6": "待发布"
};

var roleType = exports.roleType = {
    "": "unknown",
    "1": "ieditor",
    "2": "irecord",
    "3": "audit",
    "4": "stats",
    "5": ""
};
var roleTypeId = exports.roleTypeId = {
    "ieditor": "1",
    "irecord": "2",
    "audit": "3",
    "stats": "4",
    "unknown": ""
};

var searchOptions = exports.searchOptions = {
    "标签": "1",
    "标题": "2",
    "内容": "4"
};

var eventType = exports.eventType = {
    "1": "增加新闻",
    "2": "编辑新闻",
    "3": "发布新闻",
    "4": "上传录音",
    "5": "发布录音",
    "6": "审核打回",
    "7": "审核通过",
    "8": "自动发布新闻"
};

var routerType = exports.routerType = {
    "ieditor": "编辑端",
    "irecord": "录音端",
    "audit": "审核端",
    "press": "班玛",
    "stats": "监控端"
};

function setParams(param) {
    var token = {
        token: _store2.default.getters.getToken,
        name: _store2.default.getters.getAccount
    };

    var params = (0, _assign2.default)(token, param);

    return params;
}

var headerOption = exports.headerOption = {
    title: {
        text: '新闻产出分布',
        subtext: '',
        x: 'center',
        align: 'right'
    },
    toolbox: {
        show: true,
        feature: {
            dataZoom: {
                yAxisIndex: 'none'
            },
            dataView: {
                show: true,
                readOnly: false
            },
            magicType: {
                show: false,
                type: ["bar"]
            },
            restore: {
                show: false
            },
            saveAsImage: {
                show: true
            }
        }
    },
    legend: {
        data: ['新闻数量'],
        x: 'left'
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            animation: false,
            label: {
                backgroundColor: '#505765'
            }
        }
    },
    dataZoom: {
        show: true,
        realtime: true,
        start: 0 },
    grid: {
        y2: 80
    },
    xAxis: [{
        type: 'time',
        splitNumber: 6
    }],
    yAxis: [{
        name: '数量(条/每小时)',
        type: 'value'
    }],
    series: [{
        name: '新闻数量',
        type: 'line',
        showAllSymbol: true,
        data: null
    }]

};

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(24);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(17);

var _vuex2 = _interopRequireDefault(_vuex);

var _logger = __webpack_require__(777);

var _logger2 = _interopRequireDefault(_logger);

var _navmenu = __webpack_require__(354);

var _navmenu2 = _interopRequireDefault(_navmenu);

var _common = __webpack_require__(350);

var _common2 = _interopRequireDefault(_common);

var _login = __webpack_require__(353);

var _login2 = _interopRequireDefault(_login);

var _ieditor = __webpack_require__(351);

var _ieditor2 = _interopRequireDefault(_ieditor);

var _irecord = __webpack_require__(352);

var _irecord2 = _interopRequireDefault(_irecord);

var _press = __webpack_require__(355);

var _press2 = _interopRequireDefault(_press);

var _audit = __webpack_require__(349);

var _audit2 = _interopRequireDefault(_audit);

var _stats = __webpack_require__(356);

var _stats2 = _interopRequireDefault(_stats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var debug = "production" !== 'production';

var store = new _vuex2.default.Store({
    modules: {
        login: _login2.default,
        ieditor: _ieditor2.default,
        irecord: _irecord2.default,
        audit: _audit2.default,
        press: _press2.default,
        stats: _stats2.default,
        navmenu: _navmenu2.default,
        common: _common2.default
    },
    strict: debug,
    plugins: debug ? [(0, _logger2.default)()] : []
});

exports.default = store;

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(760),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(24);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(775);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _com = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COM_LOGIN = function COM_LOGIN() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 819));
};

var COM_PRESS_INDEX = function COM_PRESS_INDEX() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 259));
};
var COM_PRESS_LIST = function COM_PRESS_LIST() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 820));
};
var COM_PRESS_SEARCH = function COM_PRESS_SEARCH() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 822));
};
var COM_PRESS_REVIEW = function COM_PRESS_REVIEW() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 821));
};

var COM_404 = function COM_404() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 818));
};

_vue2.default.use(_vueRouter2.default);

var routes = [{
    name: 'home',
    path: (0, _com.routeMap)('/'),
    redirect: (0, _com.routeMap)('/ieditor')
}, { path: '/userlogin/:type?',
    redirect: function redirect(to) {
        var params = to.params;

        console.debug("to:%o, params:%o", to, params);

        if (params.type) {
            return (0, _com.routeMap)('/login?type=:type');
        } else {
            return (0, _com.routeMap)('/login');
        }
    }
}, {
    name: 'login',
    path: (0, _com.routeMap)('/login'),
    component: COM_LOGIN }, {
    name: 'ieditor',
    path: (0, _com.routeMap)('/ieditor'),
    redirect: (0, _com.routeMap)('/ieditor/list'),
    component: __webpack_require__(737),
    children: [{
        name: 'ieditorlist',
        path: 'list',
        component: __webpack_require__(738)
    }, {
        name: 'ieditoredit',
        path: 'edit',
        component: __webpack_require__(736)
    }, {
        name: 'ieditorreview',
        path: 'review',
        component: __webpack_require__(740)
    }, {
        name: 'ieditorquery',
        path: 'query',
        component: __webpack_require__(739)
    }]
}, {
    name: 'irecord',
    path: (0, _com.routeMap)('/irecord'),
    redirect: (0, _com.routeMap)('/irecord/list'),
    component: __webpack_require__(742),
    children: [{
        name: 'irecordlist',
        path: 'list',
        component: __webpack_require__(743)
    }, {
        name: 'irecordedit',
        path: 'edit',
        component: __webpack_require__(741)
    }]
}, {
    name: 'audit',
    path: (0, _com.routeMap)('/audit'),
    redirect: (0, _com.routeMap)('/audit/list'),
    component: __webpack_require__(733),
    children: [{
        name: 'auditlist',
        path: 'list',
        component: __webpack_require__(734)
    }, {
        name: 'auditreview',
        path: 'review',
        component: __webpack_require__(735)
    }]
}, {
    name: 'press',
    path: (0, _com.routeMap)('/press'),
    redirect: (0, _com.routeMap)('/press/list'),
    component: __webpack_require__(259),
    children: [{
        name: 'presslist',
        path: 'list',
        component: COM_PRESS_LIST }, {
        name: 'presssearch',
        path: 'search',
        component: COM_PRESS_SEARCH }, {
        name: 'pressreview',
        path: 'review',
        component: COM_PRESS_REVIEW }]
}, {
    name: 'stats',
    path: (0, _com.routeMap)('/stats'),
    redirect: (0, _com.routeMap)('/stats/list'),
    component: __webpack_require__(746),
    children: [{
        name: 'statslist',
        path: 'list',
        component: __webpack_require__(749)
    }, {
        name: 'statsevents',
        path: 'events',
        component: __webpack_require__(745)
    }, {
        name: 'statsinterface',
        path: 'interface',
        component: __webpack_require__(747)
    }, {
        name: 'statsreview',
        path: 'review',
        component: __webpack_require__(750)
    }, {
        name: 'statsedit',
        path: 'edit',
        component: __webpack_require__(744)
    }, {
        name: 'statslabels',
        path: 'labels',
        component: __webpack_require__(748)
    }]
}, {
    name: 'notfound',
    path: (0, _com.routeMap)('/404'),
    component: COM_404 }, {
    path: '*',
    redirect: (0, _com.routeMap)('/404')
}];

var router = new _vueRouter2.default({
    mode: 'history',
    base: __dirname,
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    routes: routes
});

exports.default = router;
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(753),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 283:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACQCAMAAADQmBKKAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABy1BMVEX4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4Jlf4JVf4JVb4J1j4Gk73DUP3ATr3Ajv3BDz3BD34GEz4LFv4K1v3FEn3FUr3ADn3Bj74JFX5SXL6cJD7iqT8obf8rb/6X4P3DkX3EUb6bY74KFj3CUH4LV36b5D8r8H+4+n////8kKj3ADX3ADf9rcD4KVn3DEP5QWz8n7T/8PT7gJz3ADr8mbD4KVr4HVD4MmD8pbn4K1r3BT37eZf/+fr4J1f4Klr3ATv4HlH9usn5NmP+5ev5P2r4NWP/+fv4NWL4G07+7PH+7PD9ydX2ADP7hKD3C0P4MV/3ADb9t8f3CED5RW/8rsD4MF//+/z3BT79u8r3GU3+8PP3CkH5UXj7dZT8kqr8prr3Bz/9scP9tMX9s8T9rL/3E0j6ZYj8o7j8nbP+zNf7fZv6XoL3EEYAAACuk+08AAAAMnRSTlMAG1WHtM3k7/GzhhVuvftvIJEBhD3WdJaio5hxM+ODlZQN/GnHFleLjLXR8PLQapfX5VA8QlQAAAABYktHRJh20QY+AAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4QwEERwgm6OsAwAAA8xJREFUeNrt3Odb00AcwPEDoaDIXgooMlVEwdBAWS1l73UQWvYqlLJElL33XjL+XSkQ2kgDvdLrHXjfd+TJk3yaN3l4cvcD4E5u7i88PBVe3ljzUni+fOXuBh7M57WvH+ey/Hz9fe7lBAR6u05znXdggCwnKNiFD8fqMQUH2faEhJLgmAsNseUJI8UxF3bXE07Sw3Hh/3rekPVw3FupJ4K0h+MirD2RpDXmIi2eKNKW66JuQe9IU65TiJ73pCVi729eX6Qdlq5fbNGkGZY+mD0xRF5gtouNuQTFkVZYF3cJiieNsC4egATSBmkJIJE0QVoi+EiaIO0T8CBNkPYZJJEmSEsCCtIEaQrwhTRBmhdIJk2Qlgxc/o/Y/XkzEAMxEAMx0DMDpSmt/1LKJDknDROIV6ZnqDKzsnNyxSNqTbZMGrV4Tm5OdlamKiNdyTsXxPN52vyCwqLiktKycvGnV1SWylRZIT6k8rLSkuKiwoJ8bR5vl8kuUBVXra2prauH5hoaRZDQBGVqEkRQY8PVgfq62hpt9eWFnAHidXptc0ureLO2dhGU1SEH6sgSQe1t4rHWlmatXvfgU3oY1NnV2N1jdTNHQZf1dDd2dT4W1Ks39PVD54Bgf59B3/sokHHANDgkvdljQBAODZoGjI6DjDpheAQ6EwRHhgWd0WHQgDDaD50Lgv2jwoCjILXqxxh0NgiO/VSpHQN16sd/QeeD4O9xfacjIL7LNAFxgOCEqot3AKSbnIJ4QHBqUocOqpqegbhAcGa6ChnEzc7hA83NIj8hfn4B4gPBhXkeEWQUFnGCFgUjIkiztIwTtLykQQPxQh/ECYJ9Ao8EUq6s4gWtriiRQGu6dbygdd0aEmhjU+5mTgLBzQ0kkHYLN2hLiwJKU23jBm2r0hBASsMObtCOQYkC2t3DDdrbRQPt4wbtI4IOcIMOGIiBGIiBGIiBGIiBGOjZg4RDuXMOBRIg7uj45I/NTo6POBIgtcZg++uUwfJ5yqUgez7guRj0cAzEQAzEQAzEQAzEQE8VZDqVu9Dtch27ulmuY6NTExLo6ExusdJ5OYdQ+bncdc6OUECc+kJuOZdlyZc95ebIXefC9vIG+a/S9ix4syfE6zz5ZYMMRDwGYiAG+g9B1G1Wom47F3Ub3ijbEviVvk2T1G0rpW7jLXVbk6nbvE3X9vZv5gEAsaQVlq4GANA0IiGaziES1I3ZALS8zxT0jmqhbpgNfeN+6BuIBEAKWU8K/UO1AAhJJcVJtTl2jL7BbIC60XVXLzZ/qob7XeWa8YffZcYf/gWDHM7nAfGxnQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headernav = __webpack_require__(88);

var _headernav2 = _interopRequireDefault(_headernav);

var _elmenu = __webpack_require__(113);

var _elmenu2 = _interopRequireDefault(_elmenu);

__webpack_require__(696);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    components: {
        headernav: _headernav2.default,
        elmenu: _elmenu2.default
    }
};

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _com = __webpack_require__(11);

__webpack_require__(697);

var _config = __webpack_require__(13);

var _elementUi = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyCont = function emptyCont() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 76));
};
var contentList = function contentList() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 75));
};
exports.default = {
    data: function data() {
        return {
            filters: {
                fsdate: '',
                hotindex: '',
                category: ''
            },
            bodyloading: true,
            show: true,
            currentDate: new Date(),
            date: (0, _com.getNowTime)(),
            page: 1,
            limit: 10,
            state: 3,
            clientid: 1,
            label: '已修改',
            linkpath: './review'
        };
    },
    created: function created() {
        console.debug("created> page:%o", this.$route.query.page);
        var curpage = this.$route.query.page || 1;
        this.page = parseInt(curpage);
        this.filters.category = this.$route.query.category || '';
        this.reqNewsListData();
    },
    mounted: function mounted() {
        console.debug("mounted");
    },

    watch: {
        '$route': function $route(to, from) {
            console.debug("watch>route start to:%o, from:%o", to, from);

            console.debug("watch>route category:%o, page:%o", this.$route.query.category, this.transitionName, this.$route.query.page);
            var curpage = this.$route.query.page || 1;
            this.page = parseInt(curpage);
            this.filters.category = this.$route.query.category || '';
            this.reqNewsListData();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        newsdata: 'newsdata',
        newstotal: 'newstotal',
        getToken: 'getToken',
        getAccount: 'getAccount',
        getRole: 'getRole',
        newsprop: 'newsprop'
    }), {
        getNewsdataLen: function getNewsdataLen() {
            return this.newsdata.length;
        },
        formatCategory: function formatCategory() {
            var typelists = [];
            for (var i in _config.newsType) {
                var typelist = {};
                typelist.value = i;
                typelist.label = _config.newsType[i];
                typelists.push(typelist);
            }
            console.debug("formatCategory> typelists:%o", typelists);
            return typelists;
        },

        formatNewsData: function formatNewsData() {
            var lists = [];
            console.debug("formatNewsData> newsdata:%o", this.newsdata);
            for (var i in this.newsdata) {
                var l = {};
                var newdata = this.newsdata[i];
                l = (0, _com.cloneObj)(newdata);
                var hi = newdata.hotindex + '' || '7';
                l.hotindex = _config.hotsType[hi];

                var cat = newdata.category || '1';
                l.category = _config.newsType[cat];
                var ls = newdata.labels || '#';
                l.labels = ls.split('#');
                var ss = newdata.state || '1';
                l.state = _config.auditFullType[ss];

                l.labels = ls.split('#');
                lists.push(l);
            }
            console.debug("formatMarkers> lists:%o", lists);
            return lists;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        getAuditData: 'getAuditData',
        updateNewsContent: 'updateNewsContent',
        getAuditDataII: 'getAuditDataII',
        getNewsData: 'getNewsData',
        updateLoadingStatus: 'updateLoadingStatus'
    }), {
        reqNewsListData: function reqNewsListData() {
            var that = this;
            var param = {
                state: that.state,
                category: that.filters.category,
                page: that.page,
                limit: that.limit
            };
            console.debug("reqNewsListData> param:%o", param);
            that.updateLoadingStatus(true);
            that.getNewsData(param).then(function (resp) {
                that.updateLoadingStatus(false);
                console.debug("reqNewsListData> resp:%o", resp);
                if (resp && resp.code !== 0) {
                    that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                }
            });
        },
        handlePageChange: function handlePageChange(val) {
            console.debug("handlePageChange> val:%o", val);
            this.$router.push({ path: (0, _com.routeMap)('/audit/list'), query: { page: this.page, category: this.filters.category } });

            console.debug("handlePageChange> query:%o, category:%o", this.$route.query, this.filters.category);
        },
        handleCategoryChange: function handleCategoryChange(val) {
            console.debug("handleCategoryChange> val:%o, category:%o", val, this.filters.category);

            this.$router.push({ path: (0, _com.routeMap)('/audit/list'), query: { page: this.page, category: this.filters.category } });
            console.debug("handlePageChange> query:%o, category:%o", this.$route.query, this.filters.category);
        },
        goEdit: function goEdit(item) {
            if (!item) {
                return false;
            }
            item.labels = item.labels.join('#');
            for (var i in _config.newsType) {
                if (_config.newsType[i] === item.category) {
                    item.category = i;
                    break;
                }
            }

            for (var _i in _config.hotsType) {
                if (_config.hotsType[_i] === item.hotindex) {
                    item.hotindex = _i;
                    break;
                }
            }
            console.debug("goto> item:%o", item);
            this.updateNewsContent(item);
            this.$router.push({ path: './review', query: { id: item.id } });
        }
    }),
    components: {
        emptyCont: emptyCont,
        contentList: contentList
    }
};

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(51);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _elementUi = __webpack_require__(25);

var _config = __webpack_require__(13);

var _com = __webpack_require__(11);

__webpack_require__(698);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      editForm: {
        done: false,
        mediaurl: '',
        loading: false
      },
      auditFormVisible: false,
      auditFormTitle: '驳回',
      auditFormBtn: '提 交',
      editLoading: false,
      auditForm: {
        id: null,
        state: null,
        tip: null
      },
      auditFormRules: {
        state: [{ required: true, message: '请选择驳回至哪一端', trigger: 'change' }],
        tip: [{ required: true, message: '请选择驳回理由', trigger: 'blur' }, { min: 5, max: 80, message: '长度在 5 到 80 个字符', trigger: 'blur' }]
      },
      id: null,
      index: null,
      urladdr: './review'
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    newContent: 'newContent',
    newsdata: 'newsdata',
    newstotal: 'newstotal'
  }), {
    formatCategory: function formatCategory() {
      return _config.newsType[this.newContent.category] || '';
    },
    formatLabels: function formatLabels() {
      return this.newContent.labels.split('#') || [];
    },
    formatLabels2: function formatLabels2() {
      return this.newContent.labels.split('#').join(' / ') || '';
    },
    formatHotIndex: function formatHotIndex() {
      return _config.hotsType[this.newContent.hotindex + ''];
    },
    formatSourcefrom: function formatSourcefrom() {
      return this.newContent.sourcefrom || '';
    },
    formatAuditType: function formatAuditType() {
      var typelists = [];
      for (var i in _config.auditType) {
        var typelist = {};
        typelist.value = i;
        typelist.label = _config.auditType[i];
        typelists.push(typelist);
      }
      console.debug("formatCategory> typelists:%o", typelists);
      return typelists;
    },
    preNewsId: function preNewsId() {
      if (this.newsdata.length && this.newsdata.length > 0 && this.index > 0) {
        console.debug("preNewsId> index:%o, pre:%o", this.index, this.index - 1);
        return this.index - 1;
      } else {
        console.debug("preNewsId> -1");
        return -1;
      }
    },
    nextNewsId: function nextNewsId() {
      if (this.newsdata.length && this.newsdata.length > 0 && this.index < this.newsdata.length - 1) {
        console.debug("nextNewsId> index:%o, next:%o", this.index, this.index + 1);
        return this.index + 1;
      } else {
        console.debug("nextNewsId> -1");
        return -1;
      }
    }
  }),
  created: function created() {
    this.updateNewsConten();

    console.debug("created> newContent:%o", this.newContent);
  },
  destroyed: function destroyed() {
    _elementUi.Message.closeAll();
  },

  watch: {
    '$route': function $route(to, from) {
      console.debug("watch>route start to:%o, from:%o", to, from);
      console.debug("watch route> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);

      this.updateNewsConten();
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    editNewsContent: 'editNewsContent',
    transferNewsState: 'transferNewsState',
    updateNewsContent: 'updateNewsContent',
    updateNewsDataDone: 'updateNewsDataDone'
  }), {
    updateNewsConten: function updateNewsConten() {
      this.id = this.$route.query.id || '';
      var index = this.$route.query.index || 0;
      this.index = parseInt(index);

      var item = this.reqNewsContent(this.id, this.newsdata);

      this.updateNewsContent(item);

      if (this.newContent.tip) {
        (0, _elementUi.Message)({
          showClose: true,
          duration: 0,
          message: '\u9A73\u56DE\u7406\u7531: ' + this.newContent.tip,
          type: 'warning'
        });
      } else {
        _elementUi.Message.closeAll();
      }
    },
    reqNewsContent: function reqNewsContent(id, datalist) {
      console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
      var data = null;
      var hasUser = datalist.some(function (u) {
        if (u.id === id) {
          data = JSON.parse((0, _stringify2.default)(u));
          return true;
        }
      });
      console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
      return data;
    },
    releaseNews: function releaseNews(id) {
      var _this = this;

      console.debug("releaseNews> id:%o", id);
      var param = {};
      param.id = id;

      param.state = 6;
      param.tip = '';
      this.transferNewsState(param).then(function (resp) {
        console.debug("editNewsContent> resp:%o", resp);
        if (resp.code === 0) {
          _this.$message({
            message: resp.msg,
            type: 'success'
          });
          _this.editForm.done = true;
          var para = {
            id: param.id,
            done: true
          };
          _this.updateNewsDataDone(para);
          _this.updateNewsConten();
          console.debug("transferNewsState>updateNewsDataDone para:%o", para);
        } else {
          _this.$message({
            message: resp.msg,
            type: 'error'
          });
        }
      });
    },
    handleCategoryChange: function handleCategoryChange(e) {
      console.debug("handleCategoryChange> e:%o", e);
    },
    handleAuditFormEdit: function handleAuditFormEdit(item) {
      console.debug("handleAuditFormEdit> item:%o", item);
      this.auditFormVisible = true;
      this.auditForm.id = item.id;
      this.auditForm.state = null;
      this.auditForm.tip = '';
    },

    editSubmit: function editSubmit() {
      var _this2 = this;

      var that = this;

      that.$refs.auditForm.validate(function (valid) {
        if (valid) {
          that.$confirm('\u8BF7\u786E\u8BA4\u79FB\u52A8\u81F3  ' + _config.auditType[_this2.auditForm.state] + '  \u5417\uFF1F', '提示', {}).then(function () {
            that.editLoading = true;
            that.auditFormBtn = '提交中';
            console.debug("editSubmit> auditForm:%o", that.auditForm);
            var param = {};
            param.id = that.auditForm.id;
            param.state = that.auditForm.state;
            param.tip = that.auditForm.tip;
            that.transferNewsState(param).then(function (resp) {
              console.debug("editNewsContent> resp:%o", resp);
              if (resp.code === 0) {
                that.$message({
                  message: resp.msg,
                  type: 'success'
                });
                that.editLoading = false;
                that.btnEditText = '提 交';
                that.editForm.done = true;
                var para = {
                  id: param.id,
                  done: true
                };
                that.updateNewsDataDone(para);
                that.updateNewsConten();
                console.debug("transferNewsState>updateNewsDataDone para:%o", para);
                that.auditFormVisible = false;
              } else {
                that.$message({
                  message: resp.msg,
                  type: 'error'
                });
              }
            });
          });
        }
      });
    }

  }),
  components: {}
};

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

__webpack_require__(700);

var _vuex = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    model: {
        prop: ['newsdata', 'labelname', 'tipshow', 'goUrl', 'limit', 'total', 'handlePageChange', 'urladdr']
    },
    props: {
        newsdata: Array,
        labelname: String,
        tipshow: Boolean,
        goUrl: Function,
        limit: Number,
        total: Number,
        handlePageChange: Function,
        urladdr: String
    },
    data: function data() {
        return {};
    },
    created: function created() {},
    mounted: function mounted() {},

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({})),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({}))
};

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

__webpack_require__(701);

var _vuex = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['show', 'loading'],
    data: function data() {
        return {};
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        getLoadingStatus: 'getLoadingStatus'
    }), {
        loadingStatus: function loadingStatus() {
            return this.getLoadingStatus;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({}))
};

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(699);

exports.default = {
  name: 'ibroadcast'
};

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(51);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _elementUi = __webpack_require__(25);

var _config = __webpack_require__(13);

var _com = __webpack_require__(11);

__webpack_require__(702);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultRcmdBtnName = '点击获取推荐标签',
    loadingRcmdBtnName = '标签获取中……';
exports.default = {
  data: function data() {
    return {
      rules: {
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        hotindex: [{ required: true, message: '请选择热度', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }, { min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }],
        content: [{ required: true, message: '请填写内容', trigger: 'blur' }],
        sourcefrom: [{ required: true, message: '请选择来源' }, { type: 'array', message: '来源必须为列表' }],
        sourceurl: [{ required: true, message: '请填写来源地址', trigger: 'blur' }, { type: 'url', message: '来源地址必须为url' }],
        cover: [{ type: 'url', message: '来源地址必须为url' }, { min: 0, max: 256, message: '长度必须在 256 个字符以内', trigger: 'blur' }]
      },

      value: '',
      editForm: {
        labels: [],
        newlabels: [],
        id: '',
        category: '',
        title: '',
        content: '',
        hotindex: '',
        cover: '',
        sourcefrom: [],
        sourceurl: '',
        editor: null,
        date: null,
        edittime: null,
        tip: ''
      },

      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      rcmdLabelsText: defaultRcmdBtnName,
      rcmdBtnLoading: false,
      inputMinSize: 2,
      tag: '',
      newtag: '',
      oldCategory: '',
      restaurants: []
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    newContent: 'newContent',
    newsdata: 'newsdata',
    newstotal: 'newstotal'
  }), {
    formatCategory: function formatCategory() {
      var typelists = [];
      for (var i in _config.newsType) {
        var typelist = {};
        typelist.value = i;
        typelist.label = _config.newsType[i];
        typelists.push(typelist);
      }
      console.debug("formatCategory> typelists:%o", typelists);
      return typelists;
    },
    formatHotlist: function formatHotlist() {
      var hotlists = [];
      for (var i in _config.hotsType) {
        var hotlist = {};
        hotlist.value = i;
        hotlist.label = _config.hotsType[i];
        hotlists.push(hotlist);
      }
      console.debug("formatHotlist> hotlists:%o", hotlists);
      return hotlists;
    },
    formatSourcefromlist: function formatSourcefromlist() {
      var _this = this;

      var sflists = [];
      for (var i in _config.newsPlatform) {
        var sflist = {};
        sflist.value = _config.newsPlatform[i];
        sflist.label = _config.newsPlatform[i];
        sflists.push(sflist);
      }
      if (this.newContent.sourcefrom && this.newContent.sourcefrom !== '1' && this.newContent.sourcefrom != '2') {
        var users = sflists.filter(function (user) {
          if (_this.newContent.sourcefrom && user.label.indexOf(_this.newContent.sourcefrom) === -1) return false;
          return true;
        });

        if (users.length === 0) {
          var sl = {};
          sl.value = this.newContent.sourcefrom;
          sl.label = this.newContent.sourcefrom;
          sflists.push(sl);
        }
      }

      return sflists;
    }
  }),
  mounted: function mounted() {
    this.restaurants = this.loadAll();
  },
  created: function created() {
    this.id = this.$route.query.id || '';
    var index = this.$route.query.index || 0;
    this.index = parseInt(index);
    console.debug("created> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);
    if (this.id && this.newsdata) {
      var item = this.reqNewsContent(this.id, this.newsdata);
      console.debug("created> item:%o", item);
      if (item) {
        this.updateNewsContent(item);
      }
    }

    console.debug("created> newContent:%o", this.newContent);
    if (this.newContent && this.$store.state.route.query.id && this.$store.state.route.query.id === this.newContent.id) {
      this.editForm = (0, _com.cloneObj)(this.newContent);

      var nl = this.newContent.labels.split('#') || [];
      nl = nl.filter(function (t) {
        return t != undefined && t !== null && t !== '';
      });
      this.editForm.labels = nl;
      this.editForm.newlabels = [];
      this.editForm.id = this.newContent.id;

      this.editForm.category = this.newContent.category + '';
      this.editForm.title = this.newContent.title;
      this.editForm.content = this.newContent.content;
      this.editForm.hotindex = this.newContent.hotindex + '';
      this.editForm.cover = this.newContent.cover;

      console.debug("created> before editForm:%o, newContent:%o", this.editForm, this.newContent);
      this.editForm.sourcefrom = [];

      this.newContent.sourcefrom === '1' || this.newContent.sourcefrom === '2' ? this.editForm.sourcefrom.push(_config.newsPlatform[this.newContent.sourcefrom]) : this.editForm.sourcefrom.push(this.newContent.sourcefrom);

      console.debug("created> after editForm:%o, newContent:%o", this.editForm, this.newContent);
      this.editForm.sourceurl = this.newContent.sourceurl;
      this.editForm.editor = this.newContent.editor;
      this.editForm.date = this.newContent.date;
      this.editForm.edittime = this.newContent.edittime;
      this.editForm.tip = this.newContent.tip;
      this.oldCategory = this.editForm.category;
      console.debug("created> editForm:%o, dynamicTags:%o, oldCategory:%o", this.editForm, this.dynamicTags, this.oldCategory);
    } else {
      this.editForm.tip = '';
    }
    console.debug("created> editForm:%o", this.editForm);
    if (this.editForm.tip) {
      (0, _elementUi.Message)({
        showClose: true,
        duration: 0,
        message: '\u9A73\u56DE\u7406\u7531: ' + this.editForm.tip,
        type: 'warning'
      });
    }
  },
  destroyed: function destroyed() {
    _elementUi.Message.closeAll();
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    editNewsContent: 'editNewsContent',
    addNewsContent: 'addNewsContent',
    getNewLables: 'getNewLables',
    updateNewsContent: 'updateNewsContent'
  }), {
    handleSfChange: function handleSfChange(item) {
      console.log("handleSfChange> item:%o, sourcefrom:%o", item, this.editForm.sourcefrom);
    },
    handleSelect: function handleSelect(item) {
      console.log(item);
      this.editForm.sourceurl = item.sourceurl;
      this.editForm.sourcefrom = [];
      this.editForm.sourcefrom.push(item.value);
    },
    querySearch: function querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

      console.debug("querySearch> results:%o, queryString:%o", results, queryString);
      if (results.length > 0) {
        results[0].sourceurl = queryString;
      }
      cb(results);
      console.debug("querySearch> sourceurl:%o", this.editForm.sourceurl);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        console.debug("createFilter> %o", queryString.indexOf(restaurant.address));
        return queryString.indexOf(restaurant.address) >= 0;
      };
    },
    loadAll: function loadAll() {
      return _config.newsListAddr;
    },
    reqNewsContent: function reqNewsContent(id, datalist) {
      console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
      if (!id || !datalist) {
        return false;
      }
      var data = null;
      var hasUser = datalist.some(function (u) {
        if (u.id === id) {
          data = JSON.parse((0, _stringify2.default)(u));
          return true;
        }
      });
      console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
      return data;
    },
    handleCategoryChange: function handleCategoryChange(val) {
      var _this2 = this;

      console.debug("handleCategoryChange> val:%o, category:%o", val, this.editForm.category);

      console.debug("handleCategoryChange> editForm.labels:%o, newsType[%o]:%o", this.editForm.labels, this.oldCategory, _config.newsType[this.oldCategory]);

      console.debug("handleCategoryChange> before labels:%o", this.editForm.labels);
      this.editForm.labels = this.editForm.labels.filter(function (t) {
        return t !== _config.newsType[_this2.oldCategory];
      });
      this.editForm.labels.push(_config.newsType[this.editForm.category]);
      console.debug("handleCategoryChange> after labels:%o", this.editForm.labels);

      this.oldCategory = this.editForm.category;
    },
    handleHotChange: function handleHotChange(val) {
      console.debug("handleHotChange> val:%o, hotindex:%o", val, this.editForm.hotindex);
    },
    handleSourcefromChange: function handleSourcefromChange(val) {
      console.debug("handleSourcefromChange> val:%o", val);
    },
    handleSourceurlChange: function handleSourceurlChange(val) {
      console.debug("handleSourceurlChange> val:%o", val);
      this.editForm.sourceurl = '';
    },
    handleCoverChange: function handleCoverChange(val) {
      console.debug("handleCoverChange> val:%o", val);
      this.editForm.cover = '';
    },
    reqRcmdLabels: function reqRcmdLabels() {
      var _this3 = this;

      if (!this.editForm.title || !this.editForm.content) {
        var msg = '标题 或 内容 不能为空。';
        this.$message({
          message: msg,
          type: 'warning'
        });
        return false;
      }
      var that = this;
      var param = {
        content: this.editForm.title + this.editForm.content
      };
      this.rcmdBtnLoading = true;
      this.rcmdLabelsText = loadingRcmdBtnName;
      console.debug("reqRcmdLabels> getNewLables> param:%o", param);
      this.getNewLables(param).then(function (resp) {
        console.debug("reqRcmdLabels> getNewLables> resp:%o", resp);
        that.rcmdBtnLoading = false;
        that.rcmdLabelsText = defaultRcmdBtnName;
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        } else {
          var nl = [],
              rnl = [];

          nl = _this3.editForm.labels;

          if (resp.data.labels) {
            rnl = resp.data.labels.split('#');
            rnl = rnl.filter(function (t) {
              return t != undefined && t !== null && t !== '';
            });
          }

          if (_this3.editForm.category) {
            nl.push(_config.newsType[_this3.editForm.category]);
          }
          nl = nl.concat(rnl);
          console.debug("reqRcmdLabels> before nl:%o", nl);
          nl = _this3.arryDerep(nl);
          console.debug("reqRcmdLabels> after nl:%o", nl);
          _this3.editForm.labels = nl;
        }
      });
    },
    handleLabelClose: function handleLabelClose(tag) {
      this.editForm.labels.splice(this.editForm.labels.indexOf(tag), 1);
    },
    handleClose: function handleClose(tag) {
      this.editForm.newlabels.splice(this.editForm.newlabels.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this4 = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this4.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.editForm.newlabels.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    cancelForm: function cancelForm() {
      this.$router.go(-1);
    },
    submitForm: function submitForm(formName) {
      var _this5 = this;

      console.debug("submitForm> formName:%o, editForm:%o", formName, this.editForm);
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var params = (0, _com.cloneObj)(_this5.editForm);
          var nl = params.newlabels;
          var l = params.labels;
          l = l.concat(nl);
          l.push(_config.newsType[params.category]);
          console.debug("submitForm> before l:%o", l);
          l = _this5.arryDerep(l);
          console.debug("submitForm> after l:%o", l);

          params.newlabels = params.newlabels.join('#');
          params.labels = l.join('#');
          params.sourcefrom = params.sourcefrom[0];

          console.debug("submitForm> id:%o, newlabels:%o, labels:%o", params.id, params.newlabels, params.labels);
          if (params.id) {
            _this5.editNewsContent(params).then(function (resp) {
              console.debug("editNewsContent> resp:%o", resp);
              if (resp.code === 0) {
                _this5.$message({
                  message: resp.msg,
                  type: 'success'
                });
                console.debug("editNewsContent> newContent:%o", _this5.newContent);
                _this5.$router.push({ path: './review', query: { id: _this5.newContent.id } });
              } else {
                _this5.$message({
                  message: resp.msg,
                  type: 'error'
                });
              }
            });
          } else {
            params.edittime = (0, _com.getNowTime)('yyyy-mm-dd hh:mm:ss');
            _this5.addNewsContent(params).then(function (resp) {
              console.debug("addNewsContent> resp:%o", resp);
              if (resp.code === 0) {
                _this5.$message({
                  message: resp.msg,
                  type: 'success'
                });
                console.debug("addNewsContent> newContent:%o", _this5.newContent);
                _this5.$router.push({ path: './review', query: { id: _this5.newContent.id } });
              } else {
                _this5.$message({
                  message: resp.msg,
                  type: 'error'
                });
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reviewText: function reviewText(id) {
      this.$router.push({ path: './review', query: { id: id } });
    },
    handleTitleIconClick: function handleTitleIconClick() {
      this.editForm.title = '';
    },
    arryDerep: function arryDerep(arry) {
      var res = [];
      var json = {};
      for (var i = 0; i < arry.length; i++) {
        if (!json[arry[i]]) {
          res.push(arry[i]);
          json[arry[i]] = 1;
        }
      }
      return res;
    }
  }),
  components: {}
};

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headernav = __webpack_require__(88);

var _headernav2 = _interopRequireDefault(_headernav);

var _elmenu = __webpack_require__(113);

var _elmenu2 = _interopRequireDefault(_elmenu);

__webpack_require__(703);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    components: {
        headernav: _headernav2.default,
        elmenu: _elmenu2.default
    }
};

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _com = __webpack_require__(11);

__webpack_require__(704);

var _config = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyCont = function emptyCont() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 76));
};
var contentList = function contentList() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 75));
};
exports.default = {
    data: function data() {
        return {
            filters: {
                category: ''
            },
            currentDate: new Date(),
            date: (0, _com.getNowTime)(),
            page: 1,
            limit: 10,
            state: 1,
            linkpath: './edit'
        };
    },
    created: function created() {
        var curpage = this.$route.query.page || 1;
        this.page = parseInt(curpage);
        this.filters.category = this.$route.query.category || '';
        this.reqNewsListData();
    },

    watch: {
        '$route': function $route(to, from) {
            console.debug("watch>route start to:%o, from:%o", to, from);
            console.debug("watch>route category:%o, page:%o", this.$route.query.category, this.transitionName, this.$route.query.page);
            var curpage = this.$route.query.page || 1;
            this.page = parseInt(curpage);
            this.filters.category = this.$route.query.category || '';
            this.reqNewsListData();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        newsdata: 'newsdata',
        newstotal: 'newstotal',
        getToken: 'getToken',
        getAccount: 'getAccount',
        getRole: 'getRole'
    }), {
        getNewsdataLen: function getNewsdataLen() {
            return this.newsdata.length;
        },
        formatCategory: function formatCategory() {
            var typelists = [];
            for (var i in _config.newsType) {
                var typelist = {};
                typelist.value = i;
                typelist.label = _config.newsType[i];
                typelists.push(typelist);
            }
            console.debug("formatCategory> typelists:%o", typelists);
            return typelists;
        },

        formatNewsData: function formatNewsData() {
            var lists = [];

            for (var i in this.newsdata) {
                var l = {};
                var newdata = this.newsdata[i];

                l = (0, _com.cloneObj)(newdata);
                var hi = newdata.hotindex + '' || '7';
                l.hotindex = _config.hotsType[hi];

                var cat = newdata.category || '1';
                l.category = _config.newsType[cat];
                var ls = newdata.labels || '#';
                l.labels = ls.split('#');
                var ss = newdata.state || '1';
                l.state = _config.auditFullType[ss];

                l.labels = ls.split('#');
                lists.push(l);
            }

            return lists;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        getEditorData: 'getEditorData',
        updateNewsContent: 'updateNewsContent',
        getNewsData: 'getNewsData',
        updateLoadingStatus: 'updateLoadingStatus'
    }), {
        reqNewsListData: function reqNewsListData() {
            var that = this;
            var param = {
                state: that.state,
                category: that.filters.category,
                page: that.page,
                limit: that.limit
            };
            console.debug("reqNewsListData> param:%o", param);
            that.updateLoadingStatus(true);
            that.getNewsData(param).then(function (resp) {
                that.updateLoadingStatus(false);
                console.debug("reqNewsListData> resp:%o", resp);
                if (resp && resp.code !== 0) {
                    that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                }
            });
        },
        goEdit: function goEdit(item) {
            console.debug("goto> item:%o", item);
            if (!item) {
                return false;
            }
            item.labels = item.labels.join('#');
            for (var i in _config.newsType) {
                if (_config.newsType[i] === item.category) {
                    item.category = i;
                    break;
                }
            }

            for (var _i in _config.hotsType) {
                if (_config.hotsType[_i] === item.hotindex) {
                    item.hotindex = _i;
                    break;
                }
            }

            this.updateNewsContent(item);
            this.$router.push({ path: './edit', query: { id: item.id } });
        },
        handleCategoryChange: function handleCategoryChange(val) {
            console.debug("handleCategoryChange> val:%o", val);

            this.$router.push({ path: (0, _com.routeMap)('/ieditor/list'), query: { page: this.page, category: this.filters.category } });
            console.debug("handlePageChange> query:%o, category:%o", this.$route.query, this.filters.category);
        },
        handlePageChange: function handlePageChange(val) {
            console.debug("handlePageChange> val:%o", val);

            this.$router.push({ path: (0, _com.routeMap)('/ieditor/list'), query: { page: this.page, category: this.filters.category } });
            console.debug("handlePageChange> query:%o, category:%o", this.$route.query, this.filters.category);
        }
    }),
    components: {
        emptyCont: emptyCont,
        contentList: contentList
    }
};

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(51);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _elementUi = __webpack_require__(25);

var _config = __webpack_require__(13);

var _com = __webpack_require__(11);

__webpack_require__(705);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultRcmdBtnName = '点击获取推荐标签',
    loadingRcmdBtnName = '标签获取中……';
exports.default = {
  data: function data() {
    return {
      rules: {
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        hotindex: [{ required: true, message: '请选择热度', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }, { min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }],
        content: [{ required: true, message: '请填写内容', trigger: 'blur' }],
        sourcefrom: [{ required: true, message: '请选择来源' }, { type: 'array', message: '来源必须为列表' }],
        sourceurl: [{ required: true, message: '请填写来源地址', trigger: 'blur' }, { type: 'url', message: '来源地址必须为url' }],
        cover: [{ type: 'url', message: '来源地址必须为url' }, { min: 0, max: 256, message: '长度必须在 256 个字符以内', trigger: 'blur' }]
      },

      value: '',
      editForm: {
        labels: [],
        newlabels: [],
        id: '',
        category: '',
        title: '',
        content: '',
        hotindex: '',
        cover: '',
        sourcefrom: [],
        sourceurl: '',
        editor: null,
        date: null,
        edittime: null,
        tip: ''

      },

      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      rcmdLabelsText: defaultRcmdBtnName,
      rcmdBtnLoading: false,
      inputMinSize: 2,
      tag: '',
      newtag: '',
      oldCategory: '',
      restaurants: []
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    newContent: 'newContent',
    newsdata: 'newsdata',
    newstotal: 'newstotal'
  }), {
    formatCategory: function formatCategory() {
      var typelists = [];
      for (var i in _config.newsType) {
        var typelist = {};
        typelist.value = i;
        typelist.label = _config.newsType[i];
        typelists.push(typelist);
      }
      console.debug("formatCategory> typelists:%o", typelists);
      return typelists;
    },
    formatHotlist: function formatHotlist() {
      var hotlists = [];
      for (var i in _config.hotsType) {
        var hotlist = {};
        hotlist.value = i;
        hotlist.label = _config.hotsType[i];
        hotlists.push(hotlist);
      }
      console.debug("formatHotlist> hotlists:%o", hotlists);
      return hotlists;
    },
    formatSourcefromlist: function formatSourcefromlist() {
      var _this = this;

      var sflists = [];
      for (var i in _config.newsPlatform) {
        var sflist = {};
        sflist.value = _config.newsPlatform[i];
        sflist.label = _config.newsPlatform[i];
        sflists.push(sflist);
      }
      if (this.newContent.sourcefrom && this.newContent.sourcefrom !== '1' && this.newContent.sourcefrom != '2') {
        var users = sflists.filter(function (user) {
          if (_this.newContent.sourcefrom && user.label.indexOf(_this.newContent.sourcefrom) === -1) return false;
          return true;
        });

        if (users.length === 0) {
          var sl = {};
          sl.value = this.newContent.sourcefrom;
          sl.label = this.newContent.sourcefrom;
          sflists.push(sl);
        }
      }

      return sflists;
    }
  }),
  mounted: function mounted() {
    this.restaurants = this.loadAll();
  },
  created: function created() {
    var _this2 = this;

    this.queryUnusedContent().then(function () {
      console.debug("queryUnusedContent> pass");

      console.debug("created> newContent:%o", _this2.newContent);
      if (_this2.newContent) {
          _this2.editForm = (0, _com.cloneObj)(_this2.newContent);

          var nl = _this2.newContent.labels.split('#') || [];
          nl = nl.filter(function (t) {
            return t != undefined && t !== null && t !== '';
          });
          _this2.editForm.labels = nl;
          _this2.editForm.newlabels = [];
          _this2.editForm.id = _this2.newContent.id;

          _this2.editForm.category = _this2.newContent.category + '';
          _this2.editForm.title = _this2.newContent.title;
          _this2.editForm.content = _this2.newContent.content;
          _this2.editForm.hotindex = _this2.newContent.hotindex + '';
          _this2.editForm.cover = _this2.newContent.cover;

          console.debug("created> before editForm:%o, newContent:%o", _this2.editForm, _this2.newContent);
          _this2.editForm.sourcefrom = [];

          _this2.newContent.sourcefrom === '1' || _this2.newContent.sourcefrom === '2' ? _this2.editForm.sourcefrom.push(_config.newsPlatform[_this2.newContent.sourcefrom]) : _this2.editForm.sourcefrom.push(_this2.newContent.sourcefrom);

          console.debug("created> after editForm:%o, newContent:%o", _this2.editForm, _this2.newContent);
          _this2.editForm.sourceurl = _this2.newContent.sourceurl;
          _this2.editForm.editor = _this2.newContent.editor;
          _this2.editForm.date = _this2.newContent.date;
          _this2.editForm.edittime = _this2.newContent.edittime;
          _this2.editForm.tip = _this2.newContent.tip;
          _this2.oldCategory = _this2.editForm.category;
          console.debug("created> editForm:%o, dynamicTags:%o, oldCategory:%o", _this2.editForm, _this2.dynamicTags, _this2.oldCategory);
        } else {
        _this2.editForm.tip = '';
      }
      console.debug("created> editForm:%o", _this2.editForm);
      if (_this2.editForm.tip) {
        (0, _elementUi.Message)({
          showClose: true,
          duration: 0,
          message: '\u9A73\u56DE\u7406\u7531: ' + _this2.editForm.tip,
          type: 'warning'
        });
      }
    }, function () {
      "queryUnusedContent> error";
    });
  },
  destroyed: function destroyed() {
    _elementUi.Message.closeAll();
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    editNewsContent: 'editNewsContent',
    addNewsContent: 'addNewsContent',
    getNewLables: 'getNewLables',
    updateNewsContent: 'updateNewsContent',
    queryUnusedContent: 'queryUnusedContent'
  }), {
    handleSfChange: function handleSfChange(item) {
      console.log("handleSfChange> item:%o, sourcefrom:%o", item, this.editForm.sourcefrom);
    },
    handleSelect: function handleSelect(item) {
      console.log(item);
      this.editForm.sourceurl = item.sourceurl;
      this.editForm.sourcefrom = [];
      this.editForm.sourcefrom.push(item.value);
    },
    querySearch: function querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

      console.debug("querySearch> results:%o, queryString:%o", results, queryString);
      if (results.length > 0) {
        results[0].sourceurl = queryString;
      }
      cb(results);
      console.debug("querySearch> sourceurl:%o", this.editForm.sourceurl);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        console.debug("createFilter> %o", queryString.indexOf(restaurant.address));
        return queryString.indexOf(restaurant.address) >= 0;
      };
    },
    loadAll: function loadAll() {
      return _config.newsListAddr;
    },
    reqNewsContent: function reqNewsContent(id, datalist) {
      console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
      if (!id || !datalist) {
        return false;
      }
      var data = null;
      var hasUser = datalist.some(function (u) {
        if (u.id === id) {
          data = JSON.parse((0, _stringify2.default)(u));
          return true;
        }
      });
      console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
      return data;
    },
    handleCategoryChange: function handleCategoryChange(val) {
      var _this3 = this;

      console.debug("handleCategoryChange> val:%o, category:%o", val, this.editForm.category);

      console.debug("handleCategoryChange> editForm.labels:%o, newsType[%o]:%o", this.editForm.labels, this.oldCategory, _config.newsType[this.oldCategory]);

      console.debug("handleCategoryChange> before labels:%o", this.editForm.labels);
      this.editForm.labels = this.editForm.labels.filter(function (t) {
        return t !== _config.newsType[_this3.oldCategory];
      });
      this.editForm.labels.push(_config.newsType[this.editForm.category]);
      console.debug("handleCategoryChange> after labels:%o", this.editForm.labels);

      this.oldCategory = this.editForm.category;
    },
    handleHotChange: function handleHotChange(val) {
      console.debug("handleHotChange> val:%o, hotindex:%o", val, this.editForm.hotindex);
    },
    handleSourcefromChange: function handleSourcefromChange(val) {
      console.debug("handleSourcefromChange> val:%o", val);
    },
    handleSourceurlChange: function handleSourceurlChange(val) {
      console.debug("handleSourceurlChange> val:%o", val);
      this.editForm.sourceurl = '';
    },
    handleCoverChange: function handleCoverChange(val) {
      console.debug("handleCoverChange> val:%o", val);
      this.editForm.cover = '';
    },
    reqRcmdLabels: function reqRcmdLabels() {
      var _this4 = this;

      if (!this.editForm.title || !this.editForm.content) {
        var msg = '标题 或 内容 不能为空。';
        this.$message({
          message: msg,
          type: 'warning'
        });
        return false;
      }
      var that = this;
      var param = {
        content: this.editForm.title + this.editForm.content
      };
      this.rcmdBtnLoading = true;
      this.rcmdLabelsText = loadingRcmdBtnName;
      console.debug("reqRcmdLabels> getNewLables> param:%o", param);
      this.getNewLables(param).then(function (resp) {
        console.debug("reqRcmdLabels> getNewLables> resp:%o", resp);
        that.rcmdBtnLoading = false;
        that.rcmdLabelsText = defaultRcmdBtnName;
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        } else {
          var nl = [],
              rnl = [];

          nl = _this4.editForm.labels;

          if (resp.data.labels) {
            rnl = resp.data.labels.split('#');
            rnl = rnl.filter(function (t) {
              return t != undefined && t !== null && t !== '';
            });
          }

          if (_this4.editForm.category) {
            nl.push(_config.newsType[_this4.editForm.category]);
          }
          nl = nl.concat(rnl);
          console.debug("reqRcmdLabels> before nl:%o", nl);
          nl = _this4.arryDerep(nl);
          console.debug("reqRcmdLabels> after nl:%o", nl);
          _this4.editForm.labels = nl;
        }
      });
    },
    handleLabelClose: function handleLabelClose(tag) {
      this.editForm.labels.splice(this.editForm.labels.indexOf(tag), 1);
    },
    handleClose: function handleClose(tag) {
      this.editForm.newlabels.splice(this.editForm.newlabels.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this5 = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this5.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.editForm.newlabels.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    submitForm: function submitForm(formName) {
      var _this6 = this;

      console.debug("submitForm> formName:%o, editForm:%o", formName, this.editForm);
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var params = (0, _com.cloneObj)(_this6.editForm);
          var nl = params.newlabels;
          var l = params.labels;
          l = l.concat(nl);
          l.push(_config.newsType[params.category]);
          console.debug("submitForm> before l:%o", l);
          l = _this6.arryDerep(l);
          console.debug("submitForm> after l:%o", l);

          params.newlabels = params.newlabels.join('#');
          params.labels = l.join('#');
          params.sourcefrom = params.sourcefrom[0];

          console.debug("submitForm> id:%o, newlabels:%o, labels:%o", params.id, params.newlabels, params.labels);
          if (params.id) {
            _this6.editNewsContent(params).then(function (resp) {
              console.debug("editNewsContent> resp:%o", resp);
              if (resp.code === 0) {
                _this6.$message({
                  message: resp.msg,
                  type: 'success'
                });
                console.debug("editNewsContent> newContent:%o", _this6.newContent);
                _this6.$router.push({ path: './review', query: { id: _this6.newContent.id } });
              } else {
                _this6.$message({
                  message: resp.msg,
                  type: 'error'
                });
              }
            });
          } else {
            params.edittime = (0, _com.getNowTime)('yyyy-mm-dd hh:mm:ss');
            _this6.addNewsContent(params).then(function (resp) {
              console.debug("addNewsContent> resp:%o", resp);
              if (resp.code === 0) {
                _this6.$message({
                  message: resp.msg,
                  type: 'success'
                });
                console.debug("addNewsContent> newContent:%o", _this6.newContent);
                _this6.$router.push({ path: './review', query: { id: _this6.newContent.id } });
              } else {
                _this6.$message({
                  message: resp.msg,
                  type: 'error'
                });
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reviewText: function reviewText(id) {
      this.$router.push({ path: './review', query: { id: id } });
    },
    handleTitleIconClick: function handleTitleIconClick() {
      this.editForm.title = '';
    },
    arryDerep: function arryDerep(arry) {
      var res = [];
      var json = {};
      for (var i = 0; i < arry.length; i++) {
        if (!json[arry[i]]) {
          res.push(arry[i]);
          json[arry[i]] = 1;
        }
      }
      return res;
    }
  }),
  components: {}
};

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _config = __webpack_require__(13);

var _com = __webpack_require__(11);

__webpack_require__(706);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filters: {
        done: false,
        name: '15 Tips To Increase Your Adwords Profits',
        content: '055型驱逐舰（英语：Type 055 destroyer，北约代号：Renhai-class [1]  ，中文名：刃海级）是中国船舶重工集团701研究所设计、江南造船厂与大连造船厂共同承建的、装备新型有源相控阵雷达的新型舰队防空驱逐舰。',
        type: '',
        hot: '',
        source: '',
        sourceurl: ''
      },
      typelist: [{
        name: '娱乐',
        id: '1'
      }, {
        name: '电影',
        id: '2'
      }],
      hotlist: [{
        name: 'HOT 1',
        id: '1'
      }, {
        name: 'HOT 2',
        id: '2'
      }],
      sourcelist: [{
        name: '腾讯新闻',
        id: '1'
      }, {
        name: '百度新闻',
        id: '2'
      }],

      dynamicTags: ['标签一', '标签二', '标签三'],
      inputVisible: false,
      inputValue: ''

    };
  },
  components: {},
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    newContent: 'newContent',
    newsdata: 'newsdata'
  }), {
    formatCategory: function formatCategory() {
      return _config.newsType[this.newContent.category] || '';
    },
    formatLabels: function formatLabels() {
      return this.newContent.labels.split('#') || [];
    },
    formatLabels2: function formatLabels2() {
      return this.newContent.labels.split('#').join(' / ') || '';
    },
    formatHotIndex: function formatHotIndex() {
      return _config.hotsType[this.newContent.hotindex + ''];
    },
    formatSourcefrom: function formatSourcefrom() {
      return this.newContent.sourcefrom || '';
    }
  }),
  created: function created() {
    console.debug("created> newContent:%o", this.newContent);
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    saveNewsContent: 'saveNewsContent',
    transferNewsState: 'transferNewsState',
    updateNewsData: 'updateNewsData'
  }), {
    handleTypeChange: function handleTypeChange(val) {
      console.debug("handleTypeChange> val:%o", val);
    },
    handleHotChange: function handleHotChange(val) {
      console.debug("handleHotChange> val:%o", val);
    },
    handleUrlClick: function handleUrlClick(val) {
      console.debug("handleUrlClick> val:%o", val);
    },
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    reedit: function reedit(id) {
      this.updateNewsDataList(this.newContent);
      this.$router.push({ path: './edit', query: { id: id } });
    },
    updateNewsDataList: function updateNewsDataList(param) {
      if (!param || !param.id) {
        return false;
      }
      var datalist = (0, _com.cloneObj)(this.newsdata);

      var userdata = datalist.some(function (u, index) {
        if (u.id === param.id) {
          datalist[index] = param;

          return true;
        }
      });
      this.updateNewsData(datalist);

      return userdata;
    },
    releaseNews: function releaseNews(id) {
      var _this2 = this;

      console.debug("releaseNews> id:%o", id);
      var param = {};
      param.id = id;
      param.state = 2;
      param.tip = '';
      this.transferNewsState(param).then(function (resp) {
        console.debug("releaseNews> resp:%o", resp);
        if (resp.code === 0) {
          _this2.$message({
            message: resp.msg,
            type: 'success'
          });
          _this2.filters.done = true;
          console.debug("releaseNews> done:%o", _this2.filters.done);
        } else {
          _this2.$message({
            message: resp.msg,
            type: 'error'
          });
        }
      });
    }
  })
};

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(711);

exports.default = {
    props: ['type'],
    data: function data() {
        return {
            defaultElmenu: this.$route.path
        };
    },
    created: function created() {
        this.$store.dispatch('elmenuSwitch', this.type);
    },

    computed: {
        elmenu: function elmenu() {
            return this.$store.getters.elmenu;
        }
    },
    methods: {}

};

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(357);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

__webpack_require__(707);

var _com = __webpack_require__(11);

var _config = __webpack_require__(13);

var _vuex = __webpack_require__(17);

var _echarts = __webpack_require__(195);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['type'],
  data: function data() {
    return {
      activeIndex: '',
      page: 1,
      limit: 10,
      clientid: 1,
      dialogTableVisible: false,
      dialogTableLoading: true,
      activeName: "first",

      setOption: _config.headerOption,
      querytext: '点击获取一条新闻',
      newtext: '点击创建一条新闻'
    };
  },
  created: function created() {
    this.$store.dispatch('headernavSwitch', this.type);

    var active = this.$store.state.route.path.split('/');
    this.activeIndex = active[active.length - 1] || 'list';
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    getAccount: 'getAccount',
    getToken: 'getToken',
    getRole: 'getRole',
    getAppid: 'getAppid',
    getAccesstoken: 'getAccesstoken',
    newstats: 'newstats',
    newstatstotal: 'newstatstotal'
  }), {
    headernav: function headernav() {
      return this.$store.getters.headernav;
    },
    account: function account() {
      return this.$store.getters.getAccount;
    },
    keypath: function keypath() {
      var patarry = this.$store.state.route.path.split('/');

      return patarry[patarry.length - 1];
    },
    headurl: function headurl() {},
    readMenuItemName: function readMenuItemName() {
      return _config.newsType[this.activeIndex] || '分类';
    },
    ComputerRouterName: function ComputerRouterName() {
      return _config.routerType[this.type] || '班玛资讯';
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    getEditorData: 'getEditorData',
    getPressData: 'getPressData',
    getNewsData: 'getNewsData',
    updateLoadingStatus: 'updateLoadingStatus',
    getNewStatis: 'getNewStatis',
    updateNewsContent: 'updateNewsContent',
    queryUnusedContent: 'queryUnusedContent'
  }), {
    handleClose: function handleClose(done) {
      this.$confirm('确认关闭？').then(function (_) {
        done();
      }).catch(function (_) {});
    },
    handleAddClick: function handleAddClick() {
      var param = {};
      this.updateNewsContent(param);
      this.$router.push({ path: (0, _com.routeMap)('/ieditor/edit') });
    },
    handleQueryClick: function handleQueryClick() {
      var param = {};
      this.updateNewsContent(param);

      this.$router.push({ path: (0, _com.routeMap)('/ieditor/query'), query: { id: -1 } });
    },
    handlelogoclick: function handlelogoclick(type) {

      if (type === 'press') {
        this.activeIndex = this.activeIndex || 'list';

        this.$router.push({ path: (0, _com.routeMap)('/' + type + '/' + this.activeIndex), query: { page: 1 } });
      } else {
          this.$router.push({ path: (0, _com.routeMap)('/' + type + '/list'), query: { page: 1 } });
        }
    },
    GetRequest: function GetRequest(url) {
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1).split('?');

        var strs = str[str.length - 1].split("&");

        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    handleSelect: function handleSelect(key, keyPath) {
      var _this = this;

      this.activeIndex = key;


      if (this.type === 'ieditor') {
        var request = new Object();
        request = this.GetRequest(key);
        var type = request['type'] || '';


        var param = {
          state: 1,
          category: type,
          page: this.page,
          limit: this.limit
        };

        this.updateLoadingStatus(true);
        this.getNewsData(param).then(function (resp) {
          _this.updateLoadingStatus(false);
        }, function (err) {
          _this.updateLoadingStatus(false);
          console.error("handleSelect> getNewsData> err:%o", err);
        });
      }
    },
    genData: function genData() {
      var d = [];
      var len = 0;

      var value;
      while (len++ < 50) {
        d.push([new Date(2014, 9, 1, 0, len * 10000), (Math.random() * 30).toFixed(2) - 0]);
      }

      return d;
    },
    showDiag: function showDiag() {
      var that = this;
      that.activeName = 'first';
      that.dialogTableVisible = true;
      var param = {};


      that.dialogTableLoading = true;
      that.getNewStatis(param).then(function (resp) {
        that.dialogTableLoading = false;

        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        } else {

          var _data = resp.data.process,
              _legendData = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(_data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              var serialData = [];

              var tarr = item.time.split(":");
              var pt = new Date().setHours(tarr[0], tarr[1]);

              serialData.push(pt);
              serialData.push(item.count);

              _legendData.push(serialData);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          for (var i = 1; i < _legendData.length; i++) {
            var key = _legendData[i];
            var j = i - 1;
            while (j >= 0 && _legendData[j][0] > key[0]) {
              _legendData[j + 1] = _legendData[j];
              j--;
            }
            _legendData[j + 1] = key;
          }

          that.setOption.series[0].data = _legendData;
          that.setOption.dataZoom.start = resp.data.total < 3 ? 0 : 16;
          if (resp.data.total !== 0) {
            that.setOption.title.text = '新闻产出分布';
            that.setOption.title.subtext = '总数:' + resp.data.total;
          } else {
            that.setOption.title.text = '暂无数据';
            that.setOption.title.subtext = '';
          }

          var myChart = _echarts2.default.init(document.getElementById('salesTime'));

          myChart.setOption(that.setOption);
        }
      });
    },
    handleCommand: function handleCommand(command) {
      switch (command) {
        case 'workstats':
          this.showDiag();
          break;
        case 'outLogin':
          this.$store.dispatch('outLogin');
          this.$router.push({ path: (0, _com.routeMap)('/login'), query: { type: this.type } });
          break;
      }
    }
  })
};

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(122);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(51);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _elementUi = __webpack_require__(25);

var _config = __webpack_require__(13);

var _com = __webpack_require__(11);

__webpack_require__(708);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditType = {
  "1": "编辑端"
};

exports.default = {
  data: function data() {
    return {

      fileList3: [],

      headerFolder: 'news/',
      postbFolder: '',
      postUrl: '//res-banma.oss-cn-shanghai.aliyuncs.com/',
      cdnPostUrl: '//res.banma.jizhuoyangqing.com/',
      editForm: {
        done: false,
        fileList: [],
        name: '',
        singer: '',
        mediaurl: null,
        mediasize: null,
        mediaduration: null,
        tags: '华语流行',
        music_id: 0,
        fileMd5: '',
        uploadloading: false,
        data: {
          "Filename": "${filename}",
          "key": "${filename}",
          "policy": "",
          "OSSAccessKeyId": "",
          "success_action_status": "200",
          "signature": "" }
      },

      auditFormVisible: false,
      auditFormTitle: '驳回',
      auditFormBtn: '提 交',
      editLoading: false,
      auditForm: {
        id: null,
        state: null,
        tip: null
      },
      auditFormRules: {
        state: [{ required: true, message: '请选择驳回至哪一端', trigger: 'change' }],
        tip: [{ required: false, message: '请选择驳回理由', trigger: 'blur' }, { min: 0, max: 80, message: '长度在 0 到 80 个字符', trigger: 'blur' }]
      },

      dynamicTags: ['标签一', '标签二', '标签三'],
      inputVisible: false,
      inputValue: '',

      content: '12314214'
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    newContent: 'newContent',
    getOsspolicy: 'getOsspolicy',
    getOsskeyid: 'getOsskeyid',
    getOsssign: 'getOsssign',
    newsdata: 'newsdata',
    newstotal: 'newstotal'
  }), {
    formatCategory: function formatCategory() {
      return _config.newsType[this.newContent.category] || '';
    },
    formatLabels: function formatLabels() {
      return this.newContent.labels.split('#') || [];
    },
    formatLabels2: function formatLabels2() {
      return this.newContent.labels.split('#').join(' / ') || '';
    },
    formatHotIndex: function formatHotIndex() {
      return _config.hotsType[this.newContent.hotindex + ''];
    },
    formatSourcefrom: function formatSourcefrom() {
      return this.newContent.sourcefrom || '';
    },
    formatAuditType: function formatAuditType() {
      var typelists = [];
      for (var i in auditType) {
        var typelist = {};
        typelist.value = i;
        typelist.label = auditType[i];
        typelists.push(typelist);
      }
      console.debug("formatCategory> typelists:%o", typelists);
      return typelists;
    },

    showMusicFileList: function showMusicFileList() {
      if (!this.editForm.mediaurl) {
        return [];
      }
      var fo = {};
      fo.url = this.editForm.mediaurl;
      fo.name = fo.url.split('/')[fo.url.split('/').length - 1];

      return [fo];
    }
  }),
  created: function created() {
    this.id = this.$route.query.id || '';
    var index = this.$route.query.index || 0;
    this.index = parseInt(index);
    console.debug("created> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);
    var item = this.reqNewsContent(this.id, this.newsdata);
    console.debug("created> item:%o", item);
    this.updateNewsContent(item);

    console.debug("created> newContent:%o, getOsspolicy:%o, getOsskeyid:%o, getOsssign:%o", this.newContent, this.getOsspolicy, this.getOsskeyid, this.getOsssign);
    if (this.newContent.mediaurl) {
      this.editForm.mediaurl = this.newContent.mediaurl;
      this.editForm.mediasize = this.newContent.mediasize;
      this.editForm.mediaduration = this.newContent.mediaduration;
    }
    this.editForm.data['policy'] = this.getOsspolicy;
    this.editForm.data['OSSAccessKeyId'] = this.getOsskeyid;
    this.editForm.data['signature'] = this.getOsssign;
    console.debug("created> editForm:%o", this.editForm);
    if (this.newContent.tip) {
      (0, _elementUi.Message)({
        showClose: true,
        duration: 0,
        message: '\u9A73\u56DE\u7406\u7531: ' + this.newContent.tip,
        type: 'warning'
      });
    }
    if (_config.API_HOST !== '//api.banma.jizhuoyangqing.com') {
      this.headerFolder = 'news_test/';
    }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {
    _elementUi.Message.closeAll();
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    editNewsContent: 'editNewsContent',
    transferNewsState: 'transferNewsState',
    updateNewsContent: 'updateNewsContent',
    updateNewsDataDone: 'updateNewsDataDone'
  }), {
    reqNewsContent: function reqNewsContent(id, datalist) {
      console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
      var data = null;
      var hasUser = datalist.some(function (u) {
        if (u.id === id) {
          data = JSON.parse((0, _stringify2.default)(u));
          return true;
        }
      });
      console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
      return data;
    },
    getAudioDuration: function getAudioDuration(file) {
      console.debug("getAudioDuration> file:%o", file);
      var that = this;

      var audio = that.$refs['audioTag'];
      if (/^audio/i.test(file.raw.type)) {
        var _g = function _g() {
          if (isNaN(audio.duration)) {
            requestAnimationFrame(_g);
          } else {
            console.info("该歌曲的总时间为：" + audio.duration + "秒");
            that.editForm.mediaduration = audio.duration;
            that.postEditform();
          }
        };

        audio.src = file.url;
        audio.load();

        requestAnimationFrame(_g);
      } else {
        audio.pause();

        this.$message({
          message: "请选择音乐文件！",
          type: 'error'
        });
      }
    },
    postEditform: function postEditform() {
      var _this = this;

      var that = this;
      var param = (0, _assign2.default)({}, this.newContent);
      console.info("postEditform> editForm:%o", this.editForm);
      param.mediaurl = this.editForm.mediaurl;
      param.mediasize = this.editForm.mediasize;
      param.mediaduration = this.editForm.mediaduration;
      console.debug("postEditform> param:%o, newContent:%o", param, this.newContent);
      this.editNewsContent(param).then(function (resp) {
        console.debug("editNewsContent> resp:%o", resp);
        that.editForm.uploadloading = false;
        if (resp.code === 0) {
          that.$message({
            message: resp.msg,
            type: 'success'
          });
          console.debug("editNewsContent> newContent:%o", _this.newContent);
        } else {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        }
      });
    },
    handleSuccess: function handleSuccess(file, fileList) {
      console.debug("handleSuccess> file:%o, fileList:%o", file, fileList);
      var filetype = fileList.name.split(".")[fileList.name.split(".").length - 1];
      console.log("filetype:%o", filetype);
      this.editForm.mediaurl = "http:" + this.cdnPostUrl + this.headerFolder + this.postbFolder + this.newContent.id + '.' + filetype;
      this.editForm.mediasize = fileList.raw.size;
      console.log("handleSuccess> mediaurl:%s, mediasize:%o", this.editForm.mediaurl, this.editForm.mediasize);
      this.getAudioDuration(fileList);
    },
    handleError: function handleError(file, fileList) {
      this.editForm.uploadloading = false;
      this.$message({
        message: '文件上传失败!',
        type: 'error'
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      this.editForm.mediaurl = '';
      this.editForm.uploadloading = false;
    },
    handlePreview: function handlePreview(file) {},
    calFileMd5: function calFileMd5(err, md5) {
      if (!err) {
        this.editForm.fileMd5 = md5;
        console.log("record md5:%o", this.editForm.fileMd5);
      }
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      console.debug("handleBeforeUpload> file:%o", file);
      var filetype = file.name.split(".")[file.name.split(".").length - 1];
      if (this.newContent.mediaurl) {
        var curFolder = this.newContent.mediaurl.split('/');
        console.debug("handleBeforeUpload> curFolder:%o", curFolder);
        this.postbFolder = curFolder[curFolder.length - 2] + '/';
      } else {
        var _curFolder = (0, _com.getNowTime)();
        this.postbFolder = _curFolder + '/';
      }
      this.editForm.data["key"] = this.headerFolder + this.postbFolder + this.newContent.id + '.' + filetype;
      console.debug("handleBeforeUpload> headerFolder:%o, postbFolder:%o, key:%o", this.headerFolder, this.postbFolder, this.editForm.data["key"]);

      var isMusic = file.type === 'audio/mp3' || file.type === 'audio/wma' || file.type === 'audio/wav';
      var isLt2M = file.size / 1024 / 1024 < 8;
      var judge = false;

      if (!isMusic) {
        this.$message.error('上传音乐文件只能是 mp3/wma/wav 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传音乐文件大小不能超过 8MB!');
      }
      judge = isMusic && isLt2M;
      if (judge) {
        this.editForm.uploadloading = true;
        console.debug("handleBeforeUpload> uploadloading:%o", this.editForm.uploadloading);
      }
      return judge;
    },
    releaseNews: function releaseNews(id) {
      var _this2 = this;

      console.debug("releaseNews> id:%o", id);
      var param = {};
      param.id = id;
      param.state = 3;
      param.tip = '';
      this.transferNewsState(param).then(function (resp) {
        console.debug("transferNewsState> resp:%o", resp);
        if (resp.code === 0) {
          _this2.$message({
            message: resp.msg,
            type: 'success'
          });
          _this2.editForm.done = true;
        } else {
          _this2.$message({
            message: resp.msg,
            type: 'error'
          });
        }
      });
    },
    updateNewsConten: function updateNewsConten() {
      this.id = this.$route.query.id || '';
      var index = this.$route.query.index || 0;
      this.index = parseInt(index);

      var item = this.reqNewsContent(this.id, this.newsdata);

      this.updateNewsContent(item);
    },
    handleCategoryChange: function handleCategoryChange(e) {
      console.debug("handleCategoryChange> e:%o", e);
    },
    handleAuditFormEdit: function handleAuditFormEdit(item) {
      console.debug("handleAuditFormEdit> item:%o", item);
      this.auditFormVisible = true;
      this.auditForm.id = item.id;
      this.auditForm.state = '1';
      this.auditForm.tip = '';
    },

    editSubmit: function editSubmit() {
      var _this3 = this;

      var that = this;

      that.$refs.auditForm.validate(function (valid) {
        if (valid) {
          that.$confirm('\u8BF7\u786E\u8BA4\u79FB\u52A8\u81F3  ' + auditType[_this3.auditForm.state] + '  \u5417\uFF1F', '提示', {}).then(function () {
            that.editLoading = true;
            that.auditFormBtn = '提交中';
            console.debug("editSubmit> auditForm:%o", that.auditForm);
            var param = {};
            param.id = that.auditForm.id;
            param.state = that.auditForm.state;
            param.tip = that.auditForm.tip;
            that.transferNewsState(param).then(function (resp) {
              console.debug("editNewsContent> resp:%o", resp);
              if (resp.code === 0) {
                that.$message({
                  message: resp.msg,
                  type: 'success'
                });
                that.editLoading = false;
                that.btnEditText = '提 交';
                that.editForm.done = true;
                var para = {
                  id: param.id,
                  done: true
                };
                that.updateNewsDataDone(para);
                that.updateNewsConten();
                console.debug("transferNewsState>updateNewsDataDone para:%o", para);
                that.auditFormVisible = false;
              } else {
                that.$message({
                  message: resp.msg,
                  type: 'error'
                });
              }
            });
          });
        }
      });
    }

  }),
  components: {}
};

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headernav = __webpack_require__(88);

var _headernav2 = _interopRequireDefault(_headernav);

var _elmenu = __webpack_require__(113);

var _elmenu2 = _interopRequireDefault(_elmenu);

__webpack_require__(709);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    components: {
        headernav: _headernav2.default,
        elmenu: _elmenu2.default
    }
};

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _reactCookie = __webpack_require__(257);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _com = __webpack_require__(11);

__webpack_require__(710);

var _config = __webpack_require__(13);

var _emptycontent = __webpack_require__(76);

var _emptycontent2 = _interopRequireDefault(_emptycontent);

var _contentlist = __webpack_require__(75);

var _contentlist2 = _interopRequireDefault(_contentlist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                category: '',
                editor: _reactCookie2.default.load('ibroadcasteditor') || ''
            },
            currentDate: new Date(),
            date: (0, _com.getNowTime)(),
            page: 1,
            limit: 10,
            state: 2,
            label: '录音已上传',
            linkpath: './edit',
            type: 2,
            users: null
        };
    },
    created: function created() {
        var curpage = this.$route.query.page || 1;
        this.page = parseInt(curpage);
        this.filters.category = this.$route.query.category || '';
        this.filters.editor = _reactCookie2.default.load('ibroadcasteditor') || this.$route.query.editor || '';
        this.reqNewsListData();
        this.reqUserListData();
    },

    watch: {
        '$route': function $route(to, from) {
            console.debug("watch>route start to:%o, from:%o", to, from);

            console.debug("watch>route category:%o, page:%o", this.$route.query.category, this.transitionName, this.$route.query.page);
            var curpage = this.$route.query.page || 1;
            this.page = parseInt(curpage);
            this.filters.category = this.$route.query.category || '';
            this.filters.editor = _reactCookie2.default.load('ibroadcasteditor') || this.$route.query.editor || '';
            this.reqNewsListData();
        }
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        newsdata: 'newsdata',
        newstotal: 'newstotal',
        getToken: 'getToken',
        getAccount: 'getAccount',
        getRole: 'getRole'
    }), {
        getNewsdataLen: function getNewsdataLen() {
            return this.newsdata.length;
        },
        formatCategory: function formatCategory() {
            var typelists = [];
            for (var i in _config.newsType) {
                var typelist = {};
                typelist.value = i;
                typelist.label = _config.newsType[i];
                typelists.push(typelist);
            }
            console.debug("formatCategory> typelists:%o", typelists);
            return typelists;
        },
        formatUsers: function formatUsers() {
            var userlists = [];
            for (var i in this.users) {
                var userlist = {};
                userlist.value = this.users[i].user_name;
                userlist.label = this.users[i].user_name;
                userlists.push(userlist);
            }
            console.debug("formatUsers> userlists:%o", userlists);
            return userlists;
        },

        formatNewsData: function formatNewsData() {
            var lists = [];

            for (var i in this.newsdata) {
                var l = {};
                var newdata = this.newsdata[i];
                l = (0, _com.cloneObj)(newdata);
                var hi = newdata.hotindex + '' || '7';
                l.hotindex = _config.hotsType[hi];

                var cat = newdata.category || '1';
                l.category = _config.newsType[cat];
                var ls = newdata.labels || '#';
                l.labels = ls.split('#');
                var ss = newdata.state || '1';
                l.state = _config.auditFullType[ss];

                l.labels = ls.split('#');
                lists.push(l);
            }

            return lists;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        getEditorData: 'getEditorData',
        updateNewsContent: 'updateNewsContent',
        getNewsData: 'getNewsData',
        updateLoadingStatus: 'updateLoadingStatus',
        getUserList: 'getUserList'
    }), {
        reqNewsListData: function reqNewsListData() {
            var that = this;
            var param = {
                state: that.state,
                category: that.filters.category,
                page: that.page,
                limit: that.limit,
                editor: that.filters.editor
            };
            console.debug("reqNewsListData> param:%o", param);
            that.updateLoadingStatus(true);
            that.getNewsData(param).then(function (resp) {
                that.updateLoadingStatus(false);
                console.debug("reqNewsListData> resp:%o", resp);
                if (resp && resp.code !== 0) {
                    that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                }
            });
        },
        goEdit: function goEdit(item) {
            if (!item) {
                return false;
            }
            item.labels = item.labels.join('#');
            for (var i in _config.newsType) {
                if (_config.newsType[i] === item.category) {
                    item.category = i;
                    break;
                }
            }

            for (var _i in _config.hotsType) {
                if (_config.hotsType[_i] === item.hotindex) {
                    item.hotindex = _i;
                    break;
                }
            }
            console.debug("goto> item:%o", item);
            this.updateNewsContent(item);
            this.$router.push({ path: './edit', query: { id: item.id } });
        },
        handleCategoryChange: function handleCategoryChange(val) {
            console.debug("handleCategoryChange> val:%o", val);

            this.$router.push({ path: (0, _com.routeMap)('/irecord/list'), query: { page: this.page, category: this.filters.category, editor: this.filters.editor } });
            console.debug("handlePageChange> query:%o, category:%o", this.$route.query, this.filters.category);
        },
        handlePageChange: function handlePageChange(val) {
            console.debug("handlePageChange> val:%o", val);

            this.$router.push({ path: (0, _com.routeMap)('/irecord/list'), query: { page: this.page, category: this.filters.category, editor: this.filters.editor } });
            console.debug("handlePageChange> query:%o, category:%o", this.$route.query, this.filters.category);
        },
        handleUserChange: function handleUserChange(val) {
            console.debug("handleUserChange> val:%o", val);
            var exp = new Date();
            exp.setTime(exp.getTime() + 1 * 24 * 60 * 60 * 1000);

            _reactCookie2.default.save('ibroadcasteditor', this.filters.editor, {
                path: '/',
                expires: exp
            });

            this.$router.push({ path: (0, _com.routeMap)('/irecord/list'), query: { page: this.page, category: this.filters.category, editor: this.filters.editor } });
            console.debug("handlePageChange> query:%o, user:%o", this.$route.query, this.filters.editor);
        },
        reqUserListData: function reqUserListData() {
            var that = this;
            var param = {
                type: that.type
            };
            console.debug("reqUserListData> param:%o", param);
            that.updateLoadingStatus(true);
            that.getUserList(param).then(function (resp) {
                that.updateLoadingStatus(false);
                console.debug("reqUserListData> resp:%o, users:%o", resp, that.users);
                if (resp && resp.code !== 0) {
                    that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                } else {
                    that.users = resp.data.users;
                }
            });
        }
    }),
    components: {
        emptyCont: _emptycontent2.default,
        contentList: _contentlist2.default
    }
};

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headernav = __webpack_require__(88);

var _headernav2 = _interopRequireDefault(_headernav);

__webpack_require__(712);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    components: {
        headernav: _headernav2.default
    }
};

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(51);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _elementUi = __webpack_require__(25);

var _config = __webpack_require__(13);

var _com = __webpack_require__(11);

__webpack_require__(713);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultRcmdBtnName = '点击获取推荐标签',
    loadingRcmdBtnName = '标签获取中……';
exports.default = {
  data: function data() {
    return {
      rules: {
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        hotindex: [{ required: true, message: '请选择热度', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }, { min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }],
        content: [{ required: true, message: '请填写内容', trigger: 'blur' }],
        sourcefrom: [{ required: true, message: '请选择来源' }, { type: 'array', message: '来源必须为列表' }],
        sourceurl: [{ required: true, message: '请填写来源地址', trigger: 'blur' }, { type: 'url', message: '来源地址必须为url' }],
        cover: [{ type: 'url', message: '来源地址必须为url' }, { min: 0, max: 256, message: '长度必须在 256 个字符以内', trigger: 'blur' }]
      },

      value: '',
      editForm: {
        labels: [],
        newlabels: [],
        id: '',
        category: '',
        title: '',
        content: '',
        hotindex: '',
        cover: '',
        sourcefrom: [],
        sourceurl: '',
        editor: null,
        date: null,
        edittime: null,
        tip: '',
        state: null
      },

      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      rcmdLabelsText: defaultRcmdBtnName,
      rcmdBtnLoading: false,
      inputMinSize: 2,
      tag: '',
      newtag: '',
      oldCategory: '',
      restaurants: []
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    newContent: 'newContent',
    statsdata: 'statsdata',
    statstotal: 'statstotal'
  }), {
    formatCategory: function formatCategory() {
      var typelists = [];
      for (var i in _config.newsType) {
        var typelist = {};
        typelist.value = i;
        typelist.label = _config.newsType[i];
        typelists.push(typelist);
      }
      console.debug("formatCategory> typelists:%o", typelists);
      return typelists;
    },
    formatHotlist: function formatHotlist() {
      var hotlists = [];
      for (var i in _config.hotsType) {
        var hotlist = {};
        hotlist.value = i;
        hotlist.label = _config.hotsType[i];
        hotlists.push(hotlist);
      }
      console.debug("formatHotlist> hotlists:%o", hotlists);
      return hotlists;
    },
    formatSourcefromlist: function formatSourcefromlist() {
      var _this = this;

      var sflists = [];
      for (var i in _config.newsPlatform) {
        var sflist = {};
        sflist.value = _config.newsPlatform[i];
        sflist.label = _config.newsPlatform[i];
        sflists.push(sflist);
      }
      if (this.newContent.sourcefrom && this.newContent.sourcefrom !== '1' && this.newContent.sourcefrom != '2') {
        var users = sflists.filter(function (user) {
          if (_this.newContent.sourcefrom && user.label.indexOf(_this.newContent.sourcefrom) === -1) return false;
          return true;
        });

        if (users.length === 0) {
          var sl = {};
          sl.value = this.newContent.sourcefrom;
          sl.label = this.newContent.sourcefrom;
          sflists.push(sl);
        }
      }

      return sflists;
    }
  }),
  mounted: function mounted() {
    this.restaurants = this.loadAll();
  },
  created: function created() {
    this.id = this.$route.query.id || '';
    var index = this.$route.query.index || 0;
    this.index = parseInt(index);
    console.debug("created> id:%o, index:%o, statsdata:%o, statstotal:%o", this.id, this.index, this.statsdata, this.statstotal);
    if (this.id && this.statsdata) {
      var item = this.reqNewsContent(this.id, this.statsdata);
      console.debug("created> item:%o", item);
      if (item) {
        this.updateNewsContent(item);
      }
    }

    console.debug("created> newContent:%o", this.newContent);
    if (this.newContent && this.$store.state.route.query.id && this.$store.state.route.query.id === this.newContent.id) {
      this.editForm = (0, _com.cloneObj)(this.newContent);

      var nl = this.newContent.labels.split('#') || [];
      nl = nl.filter(function (t) {
        return t != undefined && t !== null && t !== '';
      });
      this.editForm.labels = nl;
      this.editForm.newlabels = [];
      this.editForm.id = this.newContent.id;

      this.editForm.category = this.newContent.category + '';
      this.editForm.title = this.newContent.title;
      this.editForm.content = this.newContent.content;
      this.editForm.hotindex = this.newContent.hotindex + '';
      this.editForm.cover = this.newContent.cover;

      console.debug("created> before editForm:%o, newContent:%o", this.editForm, this.newContent);
      this.editForm.sourcefrom = [];

      this.newContent.sourcefrom === '1' || this.newContent.sourcefrom === '2' ? this.editForm.sourcefrom.push(_config.newsPlatform[this.newContent.sourcefrom]) : this.editForm.sourcefrom.push(this.newContent.sourcefrom);

      console.debug("created> after editForm:%o, newContent:%o", this.editForm, this.newContent);
      this.editForm.sourceurl = this.newContent.sourceurl;
      this.editForm.editor = this.newContent.editor;
      this.editForm.date = this.newContent.date;
      this.editForm.edittime = this.newContent.edittime;
      this.editForm.tip = this.newContent.tip;
      this.oldCategory = this.editForm.category;
      this.editForm.state = this.newContent.state;
      console.debug("created> editForm:%o, dynamicTags:%o, oldCategory:%o", this.editForm, this.dynamicTags, this.oldCategory);
    } else {
      this.editForm.tip = '';
    }
    console.debug("created> editForm:%o", this.editForm);
    if (this.editForm.tip) {
      (0, _elementUi.Message)({
        showClose: true,
        duration: 0,
        message: '\u9A73\u56DE\u7406\u7531: ' + this.editForm.tip,
        type: 'warning'
      });
    }
  },
  destroyed: function destroyed() {
    _elementUi.Message.closeAll();
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    editNewsContent: 'editNewsContent',
    addNewsContent: 'addNewsContent',
    getNewLables: 'getNewLables',
    updateNewsContent: 'updateNewsContent',
    updateNewsData: 'updateNewsData',
    updateStatsData: 'updateStatsData',
    transferNewsState: 'transferNewsState'
  }), {
    handleSfChange: function handleSfChange(item) {
      console.log("handleSfChange> item:%o, sourcefrom:%o", item, this.editForm.sourcefrom);
    },
    handleSelect: function handleSelect(item) {
      console.log(item);
      this.editForm.sourceurl = item.sourceurl;
      this.editForm.sourcefrom = [];
      this.editForm.sourcefrom.push(item.value);
    },
    querySearch: function querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;

      console.debug("querySearch> results:%o, queryString:%o", results, queryString);
      if (results.length > 0) {
        results[0].sourceurl = queryString;
      }
      cb(results);
      console.debug("querySearch> sourceurl:%o", this.editForm.sourceurl);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        console.debug("createFilter> %o", queryString.indexOf(restaurant.address));
        return queryString.indexOf(restaurant.address) >= 0;
      };
    },
    loadAll: function loadAll() {
      return _config.newsListAddr;
    },
    reqNewsContent: function reqNewsContent(id, datalist) {
      console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
      if (!id || !datalist) {
        return false;
      }
      var data = null;
      var hasUser = datalist.some(function (u) {
        if (u.id === id) {
          data = JSON.parse((0, _stringify2.default)(u));
          return true;
        }
      });
      console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
      return data;
    },
    handleCategoryChange: function handleCategoryChange(val) {
      var _this2 = this;

      console.debug("handleCategoryChange> val:%o, category:%o", val, this.editForm.category);

      console.debug("handleCategoryChange> editForm.labels:%o, newsType[%o]:%o", this.editForm.labels, this.oldCategory, _config.newsType[this.oldCategory]);

      console.debug("handleCategoryChange> before labels:%o", this.editForm.labels);
      this.editForm.labels = this.editForm.labels.filter(function (t) {
        return t !== _config.newsType[_this2.oldCategory];
      });
      this.editForm.labels.push(_config.newsType[this.editForm.category]);
      console.debug("handleCategoryChange> after labels:%o", this.editForm.labels);

      this.oldCategory = this.editForm.category;
    },
    handleHotChange: function handleHotChange(val) {
      console.debug("handleHotChange> val:%o, hotindex:%o", val, this.editForm.hotindex);
    },
    handleSourcefromChange: function handleSourcefromChange(val) {
      console.debug("handleSourcefromChange> val:%o", val);
    },
    handleSourceurlChange: function handleSourceurlChange(val) {
      console.debug("handleSourceurlChange> val:%o", val);
      this.editForm.sourceurl = '';
    },
    handleCoverChange: function handleCoverChange(val) {
      console.debug("handleCoverChange> val:%o", val);
      this.editForm.cover = '';
    },
    reqRcmdLabels: function reqRcmdLabels() {
      var _this3 = this;

      if (!this.editForm.title || !this.editForm.content) {
        var msg = '标题 或 内容 不能为空。';
        this.$message({
          message: msg,
          type: 'warning'
        });
        return false;
      }
      var that = this;
      var param = {
        content: this.editForm.title + this.editForm.content
      };
      this.rcmdBtnLoading = true;
      this.rcmdLabelsText = loadingRcmdBtnName;
      console.debug("reqRcmdLabels> getNewLables> param:%o", param);
      this.getNewLables(param).then(function (resp) {
        console.debug("reqRcmdLabels> getNewLables> resp:%o", resp);
        that.rcmdBtnLoading = false;
        that.rcmdLabelsText = defaultRcmdBtnName;
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        } else {
          var nl = [],
              rnl = [];

          nl = _this3.editForm.labels;

          if (resp.data.labels) {
            rnl = resp.data.labels.split('#');
            rnl = rnl.filter(function (t) {
              return t != undefined && t !== null && t !== '';
            });
          }

          if (_this3.editForm.category) {
            nl.push(_config.newsType[_this3.editForm.category]);
          }
          nl = nl.concat(rnl);
          console.debug("reqRcmdLabels> before nl:%o", nl);
          nl = _this3.arryDerep(nl);
          console.debug("reqRcmdLabels> after nl:%o", nl);
          _this3.editForm.labels = nl;
        }
      });
    },
    handleLabelClose: function handleLabelClose(tag) {
      this.editForm.labels.splice(this.editForm.labels.indexOf(tag), 1);
    },
    handleClose: function handleClose(tag) {
      this.editForm.newlabels.splice(this.editForm.newlabels.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this4 = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this4.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.editForm.newlabels.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    cancelForm: function cancelForm() {
      this.$router.go(-1);
    },
    updateNewsDataList: function updateNewsDataList(param) {
      console.debug('updateNewsDataList> id:%o, param:%o', param.id, param);
      if (!param || !param.id) {
        return false;
      }
      var datalist = (0, _com.cloneObj)(this.statsdata);
      console.debug("updateNewsDataList> datalist:%o", datalist);
      var userdata = datalist.some(function (u, index) {
        if (u.id === param.id) {
          datalist[index] = param;
          console.debug("updateNewsDataList> u:%o", u);
          return true;
        }
      });
      this.updateStatsData(datalist);
      console.debug("updateStatsData> datalist:%o", datalist);
      return userdata;
    },
    submitForm: function submitForm(formName) {
      var _this5 = this;

      console.debug("submitForm> formName:%o, editForm:%o", formName, this.editForm);
      var that = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var params = (0, _com.cloneObj)(_this5.editForm);
          var nl = params.newlabels;
          var l = params.labels;
          l = l.concat(nl);
          l.push(_config.newsType[params.category]);
          console.debug("submitForm> before l:%o", l);
          l = _this5.arryDerep(l);
          console.debug("submitForm> after l:%o", l);

          params.newlabels = params.newlabels.join('#');
          params.labels = l.join('#');
          params.sourcefrom = params.sourcefrom[0];

          console.debug("submitForm> id:%o, newlabels:%o, labels:%o", params.id, params.newlabels, params.labels);
          if (params.id) {
            _this5.editNewsContent(params).then(function (resp) {
              console.debug("editNewsContent> resp:%o", resp);
              if (resp.code === 0) {
                console.debug("editNewsContent> newContent:%o, params:%o", that.newContent, params);

                var param = {};
                param.id = params.id;
                param.state = params.state;
                param.tip = params.tip;
                that.transferNewsState(param).then(function (resp) {
                  console.debug("editNewsContent> resp:%o", resp);
                  if (resp.code === 0) {
                    that.$message({
                      message: resp.msg,
                      type: 'success'
                    });
                    that.updateNewsDataList(params);
                    that.$router.push({ path: './review', query: { id: that.newContent.id } });
                  } else {
                    that.$message({
                      message: resp.msg,
                      type: 'error'
                    });
                  }
                });
              } else {
                that.$message({
                  message: resp.msg,
                  type: 'error'
                });
              }
            });
          } else {
            params.edittime = (0, _com.getNowTime)('yyyy-mm-dd hh:mm:ss');
            _this5.addNewsContent(params).then(function (resp) {
              console.debug("addNewsContent> resp:%o", resp);
              if (resp.code === 0) {
                _this5.$message({
                  message: resp.msg,
                  type: 'success'
                });
                console.debug("addNewsContent> newContent:%o", _this5.newContent);
                _this5.$router.push({ path: './review', query: { id: _this5.newContent.id } });
              } else {
                _this5.$message({
                  message: resp.msg,
                  type: 'error'
                });
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reviewText: function reviewText(id) {
      this.$router.push({ path: './review', query: { id: id } });
    },
    handleTitleIconClick: function handleTitleIconClick() {
      this.editForm.title = '';
    },
    arryDerep: function arryDerep(arry) {
      var res = [];
      var json = {};
      for (var i = 0; i < arry.length; i++) {
        if (!json[arry[i]]) {
          res.push(arry[i]);
          json[arry[i]] = 1;
        }
      }
      return res;
    }
  }),
  components: {}
};

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _com = __webpack_require__(11);

__webpack_require__(256);

var _config = __webpack_require__(13);

var _elementUi = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        },

        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      filters: {
        event: '',
        daterange: '',
        start: '',
        end: '',
        user: ''
      },
      newloading: false,
      show: true,
      currentDate: new Date(),
      date: (0, _com.getNowTime)(),
      page: 1,
      limit: 10,
      clientid: 1,
      type: null,
      users: null
    };
  },
  created: function created() {

    var curpage = this.$route.query.page || 1;
    this.page = parseInt(curpage);
    this.filters.event = this.$route.query.event || '';
    this.filters.start = this.$route.query.start || '';
    this.filters.end = this.$route.query.end || '';
    this.filters.user = this.$route.query.user || '';
    this.reqEventsChange();
    this.reqUserListData();
  },
  mounted: function mounted() {
    console.debug("mounted");
  },

  watch: {
    '$route': function $route(to, from) {
      var curpage = this.$route.query.page || 1;
      this.page = parseInt(curpage);
      this.filters.event = this.$route.query.event || '';
      this.filters.start = this.$route.query.start || '';
      this.filters.end = this.$route.query.end || '';
      this.filters.user = this.$route.query.user || '';
      this.reqEventsChange();
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    eventdata: 'eventdata',
    eventtotal: 'eventtotal',
    getLoadingStatus: 'getLoadingStatus'
  }), {
    getStatsDataLen: function getStatsDataLen() {
      console.debug("getStatsDataLen> eventdata.length:%o", this.eventdata.length);
      return this.eventdata.length;
    },
    formatEvent: function formatEvent() {
      var typelists = [];
      for (var i in _config.eventType) {
        var typelist = {};
        typelist.value = i;
        typelist.label = _config.eventType[i];
        typelists.push(typelist);
      }
      console.debug("formatEvent> typelists:%o", typelists);
      return typelists;
    },
    formatUsers: function formatUsers() {
      var userlists = [{ value: 'publisher', label: 'publisher' }];
      for (var i in this.users) {
        var userlist = {};
        userlist.value = this.users[i].user_name;
        userlist.label = this.users[i].user_name;
        userlists.push(userlist);
      }
      console.debug("formatUsers> userlists:%o", userlists);
      return userlists;
    },
    formatEventData: function formatEventData() {
      var lists = [];

      for (var i in this.eventdata) {
        var l = {};
        var newdata = this.eventdata[i];

        l.id = newdata.id || 0;
        l.date = newdata.date || '';
        l.subject = newdata.subject || '';
        l.object = newdata.object || '';
        var sf = newdata.event || '';
        l.event = _config.eventType[sf];
        l.detail = l.subject + ' ' + l.event + ' ' + l.object;
        lists.push(l);
      }
      console.debug("formatEventData> lists:%o", lists);
      return lists;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    updateLoadingStatus: 'updateLoadingStatus',
    getConsoleEvent: 'getConsoleEvent',
    getUserList: 'getUserList'
  }), {
    reqEventsChange: function reqEventsChange() {
      var _this = this;

      var that = this;
      var param = {
        page: this.page,
        limit: this.limit,
        event: this.filters.event,
        start: this.filters.start,
        end: this.filters.end,
        user: this.filters.user
      };
      console.debug("created> getConsoleEvent> param:%o", param);
      this.updateLoadingStatus(true);
      this.getConsoleEvent(param).then(function (resp) {
        _this.updateLoadingStatus(false);
        console.debug("created> getConsoleEvent> resp:%o", resp);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        }
      });
    },
    reqUserListData: function reqUserListData() {
      var that = this;
      var param = {
        type: that.type
      };
      console.debug("reqUserListData> param:%o", param);
      that.updateLoadingStatus(true);
      that.getUserList(param).then(function (resp) {
        that.updateLoadingStatus(false);
        console.debug("reqUserListData> resp:%o, users:%o", resp, that.users);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        } else {
          that.users = resp.data.users;
        }
      });
    },
    handleDateRangeChange: function handleDateRangeChange(val) {
      var _this2 = this;

      console.debug("handleDateRangeChange> val:%o, daterange:%o, start:%o, end:%o", val, this.filters.daterange, this.filters.start, this.filters.end);
      var datarange = val.split(' - ');
      this.filters.start = datarange[0];
      this.filters.end = datarange[1];
      console.debug("handleDateRangeChange> start:%o, end:%o", this.filters.start, this.filters.end);
      this.$router.push({ path: (0, _com.routeMap)('/stats/events'), query: { page: this.page, event: this.filters.event, start: this.filters.start, end: this.filters.end, user: this.filters.user } });
      return;

      var that = this;
      var param = {
        page: this.page,
        limit: this.limit,
        event: this.filters.event,
        start: this.filters.start,
        end: this.filters.end,
        user: this.filters.user
      };
      console.debug("created> getConsoleEvent> param:%o", param);
      this.updateLoadingStatus(true);
      this.getConsoleEvent(param).then(function (resp) {
        _this2.updateLoadingStatus(false);
        console.debug("created> getConsoleEvent> resp:%o", resp);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        }
      });
    },
    handlePageChange: function handlePageChange(val) {
      var _this3 = this;

      console.debug("handlePageChange> val:%o", val);
      this.$router.push({ path: (0, _com.routeMap)('/stats/events'), query: { page: this.page, event: this.filters.event, start: this.filters.start, end: this.filters.end, user: this.filters.user } });
      return;

      if (this.page !== val) {
        this.page = val;

        var param = {
          page: this.page,
          limit: this.limit,
          event: this.filters.event,
          start: this.filters.start,
          end: this.filters.end,
          user: this.filters.user
        };
        console.debug("created> getConsoleEvent> param:%o", param);
        this.updateLoadingStatus(true);
        this.getConsoleEvent(param).then(function (resp) {
          _this3.updateLoadingStatus(false);
          console.debug("created> getConsoleEvent> resp:%o", resp);
          if (resp && resp.code !== 0) {
            that.$message({
              message: resp.msg,
              type: 'error'
            });
          }
        });
      }
    },
    handleEventChange: function handleEventChange(val) {
      var _this4 = this;

      console.debug("handleEventChange> val:%o, event:%o", val, this.filters.event);
      this.$router.push({ path: (0, _com.routeMap)('/stats/events'), query: { page: this.page, event: this.filters.event, start: this.filters.start, end: this.filters.end, user: this.filters.user } });
      return;

      var param = {
        page: this.page,
        limit: this.limit,
        event: this.filters.event,
        start: this.filters.start,
        end: this.filters.end,
        user: this.filters.user
      };
      console.debug("created> getConsoleEvent> param:%o", param);
      this.updateLoadingStatus(true);
      this.getConsoleEvent(param).then(function (resp) {
        _this4.updateLoadingStatus(false);
        console.debug("created> getConsoleEvent> resp:%o", resp);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        }
      });
    },
    handleUserChange: function handleUserChange(val) {
      console.debug("handleUserChange> val:%o", val);
      this.$router.push({ path: (0, _com.routeMap)('/stats/events'), query: { page: this.page, event: this.filters.event, start: this.filters.start, end: this.filters.end, user: this.filters.user } });
      return;

      var exp = new Date();
      exp.setTime(exp.getTime() + 1 * 24 * 60 * 60 * 1000);

      cookie.save('ibroadcasteditor', this.filters.editor, {
        path: '/',
        expires: exp
      });

      this.$router.push({ path: (0, _com.routeMap)('/irecord/list'), query: { page: this.page, category: this.filters.category, editor: this.filters.editor } });
      console.debug("handlePageChange> query:%o, user:%o", this.$route.query, this.filters.editor);
    }
  })
};

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headernav = __webpack_require__(88);

var _headernav2 = _interopRequireDefault(_headernav);

var _elmenu = __webpack_require__(113);

var _elmenu2 = _interopRequireDefault(_elmenu);

__webpack_require__(714);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },

    components: {
        headernav: _headernav2.default,
        elmenu: _elmenu2.default
    }
};

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _com = __webpack_require__(11);

__webpack_require__(715);

var _config = __webpack_require__(13);

var _elementUi = __webpack_require__(25);

var _echarts = __webpack_require__(195);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            pickerOptions2: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > Date.now();
                },

                shortcuts: [{
                    text: '最近一周',
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            filters: {
                event: '',
                daterange: '',
                start: '',
                end: ''
            },
            newloading: false,
            show: true,
            currentDate: new Date(),
            date: (0, _com.getNowTime)(),
            page: 1,
            limit: 10,
            clientid: 1,
            setOption: {

                title: {
                    text: 'list & search 接口调用频率',
                    subtext: '',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        animation: false
                    }
                },
                legend: {
                    data: ['list', 'search'],
                    x: 'left'
                },
                toolbox: {
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                axisPointer: {
                    link: { xAxisIndex: 'all' }
                },
                dataZoom: [{
                    show: true,
                    realtime: true,
                    start: 0,
                    end: 100,
                    xAxisIndex: [0, 1]
                }, {
                    type: 'inside',
                    realtime: true,
                    start: 0,
                    end: 100,
                    xAxisIndex: [0, 1]
                }],
                grid: [{
                    left: 50,
                    right: 50,
                    height: '35%'
                }, {
                    left: 50,
                    right: 50,
                    top: '55%',
                    height: '35%'
                }],
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    axisLine: { onZero: true },
                    data: null
                }, {
                    gridIndex: 1,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: { onZero: true },
                    data: null,
                    position: 'top',
                    show: false
                }],
                yAxis: [{
                    name: 'list(time/h)',
                    type: 'value'
                }, {
                    gridIndex: 1,
                    name: 'search',
                    type: 'value',
                    inverse: true
                }],
                series: [{
                    name: 'list',
                    type: 'line',
                    symbolSize: 8,
                    hoverAnimation: false,
                    data: null
                }, {
                    name: 'search',
                    type: 'line',
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    symbolSize: 8,
                    hoverAnimation: false,
                    data: null
                }]
            }
        };
    },
    created: function created() {
        var _this = this;

        var that = this;
        var param = {
            appid: this.filters.event,
            start: this.filters.start,
            end: this.filters.end
        };
        console.debug("created> getConsoleApi> param:%o", param);
        this.updateLoadingStatus(true);
        this.getConsoleApi(param).then(function (resp) {
            _this.updateLoadingStatus(false);
            console.debug("created> getConsoleApi> resp:%o", resp);
            if (resp && resp.code !== 0) {
                that.$message({
                    message: resp.msg,
                    type: 'error'
                });
            } else {
                _this.handleDataChange();
            }
        });
    },
    mounted: function mounted() {
        console.debug("mounted");
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        eventdata: 'eventdata',
        eventtotal: 'eventtotal',
        loadingStatus: 'loadingStatus',
        apidata: 'apidata',
        appidlist: 'appidlist',
        apitotal: 'apitotal',
        getLoadingStatus: 'getLoadingStatus'
    }), {
        getStatsDataLen: function getStatsDataLen() {
            console.debug("getStatsDataLen> eventdata.length:%o", this.eventdata.length);
            return this.apidata.length;
        },
        formatEvent: function formatEvent() {
            var typelists = [];
            for (var i in this.appidlist) {
                var typelist = {};
                typelist.value = this.appidlist[i];
                typelist.label = this.appidlist[i];
                typelists.push(typelist);
            }
            console.debug("formatEvent> typelists:%o", typelists);
            return typelists;
        },

        formatEventData: function formatEventData() {
            var lists = [];

            for (var i in this.apidata) {
                var l = {};
                var newdata = this.apidata[i];

                l.id = newdata.id || 0;
                l.date = newdata.date || '';
                l.appid = newdata.appid || '';
                l.list = newdata.list || '';
                l.search = newdata.search || '';

                lists.push(l);
            }

            console.debug("formatEventData> before sort> lists:%o", lists);
            for (var _i = 1; _i < lists.length; _i++) {
                var key = lists[_i];
                var j = _i - 1;
                while (j >= 0 && new Date(lists[j].date).getTime() / 1000 > new Date(key.date).getTime() / 1000) {
                    lists[j + 1] = lists[j];

                    j--;
                }
                lists[j + 1] = key;
            }
            console.debug("formatEventData> lists:%o", lists);
            return lists;
        }
    }),
    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        updateLoadingStatus: 'updateLoadingStatus',
        getConsoleEvent: 'getConsoleEvent',
        getConsoleApi: 'getConsoleApi'
    }), {
        handleDateRangeChange: function handleDateRangeChange(val) {
            var _this2 = this;

            console.debug("handleDateRangeChange> val:%o, daterange:%o, start:%o, end:%o", val, this.filters.daterange, this.filters.start, this.filters.end);
            var datarange = val.split(' - ');
            this.filters.start = datarange[0];
            this.filters.end = datarange[1];
            console.debug("handleDateRangeChange> start:%o, end:%o", this.filters.start, this.filters.end);

            var that = this;
            var param = {
                appid: this.filters.event,
                start: this.filters.start,
                end: this.filters.end
            };
            console.debug("created> getConsoleApi> param:%o", param);
            this.updateLoadingStatus(true);
            this.getConsoleApi(param).then(function (resp) {
                _this2.updateLoadingStatus(false);
                console.debug("created> getConsoleApi> resp:%o", resp);
                if (resp && resp.code !== 0) {
                    that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                } else {
                    _this2.handleDataChange();
                }
            });
        },
        handleDataChange: function handleDataChange() {
            console.debug("handleDateChange> ");
            var that = this;

            var lists = [];

            for (var i in this.apidata) {
                var l = {};
                var newdata = this.apidata[i];

                l.id = newdata.id || 0;
                l.date = newdata.date || '';
                l.appid = newdata.appid || '';
                l.list = newdata.list || '';
                l.search = newdata.search || '';

                lists.push(l);
            }

            console.debug("formatEventData> before sort> lists:%o", lists);
            for (var _i2 = 1; _i2 < lists.length; _i2++) {
                var key = lists[_i2];
                var j = _i2 - 1;
                while (j >= 0 && new Date(lists[j].date).getTime() / 1000 > new Date(key.date).getTime() / 1000) {
                    lists[j + 1] = lists[j];

                    j--;
                }
                lists[j + 1] = key;
            }

            var _legendData = [],
                _legendData1 = [],
                _legendData2 = [];
            for (var _i3 in lists) {
                _legendData.push(lists[_i3].date.replace('2017-', ''));
                _legendData1.push(lists[_i3].list);
                _legendData2.push(lists[_i3].search);
            }

            this.setOption.xAxis[0].data = _legendData;
            this.setOption.xAxis[1].data = _legendData;
            this.setOption.series[0].data = _legendData1;
            this.setOption.series[1].data = _legendData2;
            this.setOption.title.text = this.filters.event + ' 接口调用频次';
            console.debug("getNewStatis> setOption:%o", this.setOption);
            var myChart = _echarts2.default.init(document.getElementById('ifcharts'));
            console.debug("getNewStatis> setOption:%o", that.setOption);
            myChart.setOption(that.setOption);
            console.debug("formatEventData> lists:%o", lists);
        },
        handlePageChange: function handlePageChange(val) {
            console.debug("handlePageChange> val:%o", val);
            if (this.page !== val) {
                this.page = val;
            }
        },
        handleEventChange: function handleEventChange(val) {
            var _this3 = this;

            console.debug("handleEventChange> val:%o, event:%o", val, this.filters.event);

            var that = this;
            var param = {
                appid: this.filters.event,
                start: this.filters.start,
                end: this.filters.end
            };
            console.debug("created> getConsoleApi> param:%o", param);
            this.updateLoadingStatus(true);
            this.getConsoleApi(param).then(function (resp) {
                _this3.updateLoadingStatus(false);
                console.debug("created> getConsoleApi> resp:%o", resp);
                if (resp && resp.code !== 0) {
                    that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                } else {
                    _this3.handleDataChange();
                }
            });
        },
        handleHotChange: function handleHotChange(val) {
            console.debug("handleHotChange> val:%o, event:%o", val, this.filters.event);
        }
    })
};

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(42);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(17);

var _com = __webpack_require__(11);

__webpack_require__(716);

var _config = __webpack_require__(13);

var _elementUi = __webpack_require__(25);

var _emptycontent = __webpack_require__(76);

var _emptycontent2 = _interopRequireDefault(_emptycontent);

var _contentlist = __webpack_require__(75);

var _contentlist2 = _interopRequireDefault(_contentlist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      pickerOptions2: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        },

        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      filters: {
        daterange: '',
        start: '',
        end: ''
      },
      newloading: false,
      show: true,
      currentDate: new Date(),
      date: (0, _com.getNowTime)(),
      page: 1,
      limit: 10,
      clientid: 1,

      editFormVisible: false,
      editFormTtile: '编辑',
      editForm: {
        name: ''
      },
      editLoading: false,
      btnEditText: '提 交',
      editFormRules: {
        name: [{
          required: true,
          message: '请输入房间名称',
          trigger: 'blur'
        }]
      },

      inputVisible: false,
      inputValue: '',

      dynamicTags: ['标签一', '标签二', '标签三']
    }, (0, _defineProperty3.default)(_ref, 'inputVisible', false), (0, _defineProperty3.default)(_ref, 'inputValue', ''), (0, _defineProperty3.default)(_ref, 'autofocusVal', true), _ref;
  },
  created: function created() {
    this.reqLabelList();
  },

  watch: {
    '$route': function $route(to, from) {
      console.debug("watch>route start to:%o, from:%o", to, from);
      console.debug("watch>route limit:%o, page:%o, start:%o, end:%o", this.$route.query.limit, this.$route.query.page, this.$route.query.start, this.$route.query.end);
      var curpage = this.$route.query.page || 1;
      this.page = parseInt(curpage);
      var limit = this.$route.query.limit || 10;
      this.limit = parseInt(limit);
      this.filters.start = this.$route.query.start || '';
      this.filters.end = this.$route.query.end || '';
      this.reqLabelList();
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    statsdata: 'statsdata',
    statstotal: 'statstotal',
    getAccesstoken: 'getAccesstoken',
    getAppid: 'getAppid',
    getRole: 'getRole',
    labellist: 'labellist',
    labeltotal: 'labeltotal',
    getLoadingStatus: 'getLoadingStatus'
  }), {
    formatListData: function formatListData() {
      var lists = [];

      for (var i in this.labellist) {
        var l = {};
        var newdata = this.labellist[i];

        l = (0, _com.cloneObj)(newdata);
        l.inputVal = '';
        l.inputVisible = false;

        lists.push(l);
      }
      console.debug("formatListData> lists:%o", lists);
      return lists;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    getConsoleNews: 'getConsoleNews',
    updateLoadingStatus: 'updateLoadingStatus',
    getNewStatis: 'getNewStatis',
    getConsoleEvent: 'getConsoleEvent',
    updateNewsContent: 'updateNewsContent',
    getLabelList: 'getLabelList',
    updateLabel: 'updateLabel',
    deleteLabel: 'deleteLabel',
    delLabel: 'delLabel'
  }), {
    reqLabelList: function reqLabelList() {
      var that = this;
      var param = {
        start: that.filters.start,
        end: that.filters.end,
        page: that.page,
        limit: that.limit
      };
      console.debug("reqLabelList> param:%o", param);
      that.updateLoadingStatus(true);
      that.getLabelList(param).then(function (resp) {
        that.updateLoadingStatus(false);
        console.debug("reqLabelList> resp:%o", resp);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        }
      });
    },
    reqUpdateLabel: function reqUpdateLabel(id, labelname) {
      var that = this;
      var param = {
        id: id,
        labelname: labelname
      };
      console.debug("updateLabel> param:%o", param);
      that.updateLoadingStatus(true);
      that.updateLabel(param).then(function (resp) {
        that.updateLoadingStatus(false);
        console.debug("updateLabel> resp:%o", resp);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        } else if (resp && resp.code === 0) {
          that.$message({
            message: resp.msg,
            type: 'success'
          });
        }
      });
    },
    reqDelLabel: function reqDelLabel(id) {
      var that = this;
      var param = {
        id: id
      };
      console.debug("reqDelLabel> param:%o", param);
      that.updateLoadingStatus(true);
      that.delLabel(param).then(function (resp) {
        that.updateLoadingStatus(false);
        console.debug("reqDelLabel> resp:%o", resp);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        } else if (resp && resp.code === 0) {
          that.$message({
            message: resp.msg,
            type: 'success'
          });

          that.reqLabelList();
        }
      });
    },
    handleEditClick: function handleEditClick(index, rows) {
      console.debug("handleEditClick> index:%o, rows:%o", index, rows);
    },
    handleDelClick: function handleDelClick(index, rows) {
      var _this2 = this;

      console.debug("handleDelClick> index:%o, rows:%o", index, rows);
      var _this = this;
      this.$confirm('您确认 删除 此条标签吗?', '提示', {}).then(function () {
        _this2.reqDelLabel(rows[index].id);
      }).catch(function () {});
    },
    showInput: function showInput(index, rows) {
      console.debug("showInput> index:%o, rows:%o", index, rows);
      rows.inputVisible = true;
      this.inputValue = rows.name;

      this.$nextTick(function (_) {
        var x = document.getElementById(rows.id);

        x.getElementsByTagName("input")[0].focus();
      });
      console.debug("showInput> inputVisible:%o, inputValue:%o", rows.inputVisible, rows.inputValue);
    },
    handleNameInputConfirm: function handleNameInputConfirm(index, rows) {
      rows.inputVisible = false;
      rows.inputValue = '';
      this.inputValue = '';
      console.debug("handleNameInputConfirm> inputVisible:%o, inputValue:%o", rows.inputVisible, rows.inputValue);
    },
    handleNameInputBlur: function handleNameInputBlur(index, rows) {
      console.debug("handleNameInputBlur> index:%o, rows:%o", index, rows);
      if (this.inputValue !== rows.name) {
        console.debug("handleNameInputBlur> value change, old:%s, new:%s", this.inputValue, rows.name);
        this.reqUpdateLabel(rows.id, rows.name);
      } else {
        console.debug("handleNameInputBlur> nothing change");
      }
      rows.inputVisible = false;
      rows.inputValue = '';
      this.inputValue = '';
      console.debug("handleNameInputBlur> inputVisible:%o, inputValue:%o", rows.inputVisible, rows.inputValue);
    },
    handleDateRangeChange: function handleDateRangeChange(val) {
      console.debug("handleDateRangeChange> val:%o, daterange:%o", val, this.filters.daterange);
      this.filters.start = val.split(' - ')[0];
      this.filters.end = val.split(' - ')[1];

      this.$router.push({ path: (0, _com.routeMap)('/stats/labels'), query: { page: this.page, limit: this.limit, start: this.filters.start, end: this.filters.end } });
    },
    handlePageChange: function handlePageChange(val) {
      console.debug("handlePageChange> val:%o, page", val, this.page);

      this.$router.push({ path: (0, _com.routeMap)('/stats/labels'), query: { page: this.page, limit: this.limit, start: this.filters.start, end: this.filters.end } });
    }
  }),
  components: {
    emptyCont: _emptycontent2.default,
    contentList: _contentlist2.default
  }
};

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _com = __webpack_require__(11);

__webpack_require__(256);

var _config = __webpack_require__(13);

var _elementUi = __webpack_require__(25);

var _emptycontent = __webpack_require__(76);

var _emptycontent2 = _interopRequireDefault(_emptycontent);

var _contentlist = __webpack_require__(75);

var _contentlist2 = _interopRequireDefault(_contentlist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        },

        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      filters: {
        fsdate: '',
        searchterm: '',
        state: ''
      },
      newloading: false,
      show: true,
      currentDate: new Date(),
      date: (0, _com.getNowTime)(),
      page: 1,
      limit: 10,
      clientid: 1,
      linkpath: './review'
    };
  },
  created: function created() {
    var curpage = this.$route.query.page || 1;
    this.page = parseInt(curpage);
    this.filters.fsdate = this.$route.query.fsdate || '';
    this.filters.searchterm = this.$route.query.searchterm || '';
    this.filters.state = this.$route.query.state || '';
    this.reqConsoleNewsData();
    console.debug("list> created> linkpath:%o", this.linkpath);
  },

  watch: {
    '$route': function $route(to, from) {
      console.debug("watch>route start to:%o, from:%o", to, from);
      console.debug("watch>route category:%o, page:%o", this.$route.query.category, this.transitionName, this.$route.query.page);
      var curpage = this.$route.query.page || 1;
      this.page = parseInt(curpage);
      this.filters.fsdate = this.$route.query.fsdate || '';
      this.filters.searchterm = this.$route.query.searchterm || '';
      this.filters.state = this.$route.query.state || '';
      this.reqConsoleNewsData();
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    statsdata: 'statsdata',
    statstotal: 'statstotal',
    getAccesstoken: 'getAccesstoken',
    getAppid: 'getAppid',
    getRole: 'getRole'
  }), {
    getStatsDataLen: function getStatsDataLen() {
      console.debug("getStatsDataLen> statsdata.length:%o", this.statsdata.length);
      return this.statsdata.length;
    },
    formatCategory: function formatCategory() {
      var typelists = [];
      for (var i in _config.newsType) {
        var typelist = {};
        typelist.value = i;
        typelist.label = _config.newsType[i];
        typelists.push(typelist);
      }
      console.debug("formatCategory> typelists:%o", typelists);
      return typelists;
    },
    formatState: function formatState() {
      var statelists = [];
      for (var i in _config.auditFullType) {
        var statelist = {};
        statelist.value = i;
        statelist.label = _config.auditFullType[i];
        statelists.push(statelist);
      }
      console.debug("formatState> statelists:%o", statelists);
      return statelists;
    },

    formatNewsData: function formatNewsData() {
      var lists = [];

      for (var i in this.statsdata) {
        var l = {};
        var newdata = this.statsdata[i];


        l = (0, _com.cloneObj)(newdata);
        var hi = newdata.hotindex + '' || '7';
        l.hotindex = _config.hotsType[hi];

        var cat = newdata.category || '1';
        l.category = _config.newsType[cat];
        var ls = newdata.labels || '#';
        l.labels = ls.split('#');
        var ss = newdata.state || '1';
        l.state = _config.auditFullType[ss];

        lists.push(l);
      }
      console.debug("formatMarkers> lists:%o", lists);
      return lists;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    getConsoleNews: 'getConsoleNews',
    updateLoadingStatus: 'updateLoadingStatus',
    getNewStatis: 'getNewStatis',
    getConsoleEvent: 'getConsoleEvent',
    updateNewsContent: 'updateNewsContent'
  }), {
    reqConsoleNewsData: function reqConsoleNewsData() {
      var that = this;
      var param = {
        date: that.filters.fsdate,
        keyword: that.filters.searchterm,
        state: that.filters.state,
        page: that.page,
        limit: that.limit
      };
      console.debug("reqConsoleNewsData> param:%o", param);
      that.updateLoadingStatus(true);
      that.getConsoleNews(param).then(function (resp) {
        that.updateLoadingStatus(false);
        console.debug("reqConsoleNewsData> resp:%o", resp);
        if (resp && resp.code !== 0) {
          that.$message({
            message: resp.msg,
            type: 'error'
          });
        }
      });
    },
    handleClearClick: function handleClearClick(ev) {
      console.debug("handleClearClick> ev:%o", ev);
      var that = this;
      this.filters.searchterm = '';
      this.filters.fsdate = '';
      this.page = '1';

      this.$router.push({ path: (0, _com.routeMap)('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state } });
    },
    handleSearchClick: function handleSearchClick(ev) {
      this.filters.searchterm = typeof this.filters.searchterm === 'string' ? this.filters.searchterm.replace(/(^\s*)|(\s*$)/g, "") : '';
      this.$router.push({ path: (0, _com.routeMap)('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state } });
    },
    handleDateChange: function handleDateChange(val) {
      console.debug("handleDateChange> val:%o, fsdate:%o", val, this.filters.fsdate);
      if (this.filters.fsdate !== val) {
        this.filters.fsdate = val;
      }
      this.$router.push({ path: (0, _com.routeMap)('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state } });
    },
    handleStateChange: function handleStateChange(val) {
      console.debug("handleStateChange> val:%o, state:%o", val, this.filters.state);

      this.$router.push({ path: (0, _com.routeMap)('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state } });
    },
    handlePageChange: function handlePageChange(val) {
      console.debug("handlePageChange> val:%o", val);
      if (this.page !== val) {
        this.page = val;
      }
      this.$router.push({ path: (0, _com.routeMap)('/stats/list'), query: { page: this.page, fsdate: this.filters.fsdate, searchterm: this.filters.searchterm, state: this.filters.state } });
    },
    goEdit: function goEdit(item) {

      if (!item) {
        return false;
      }
      item.labels = item.labels.join('#');
      for (var i in _config.newsType) {
        if (_config.newsType[i] === item.category) {
          item.category = i;
          break;
        }
      }

      item.hotindex = item.hotindex + '';
      console.debug("goto> item:%o", item);

      this.$router.push({ path: './review', query: { id: item.id } });
    }
  }),
  components: {
    emptyCont: _emptycontent2.default,
    contentList: _contentlist2.default
  }
};

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(51);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(15);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(17);

var _elementUi = __webpack_require__(25);

var _config = __webpack_require__(13);

var _com = __webpack_require__(11);

__webpack_require__(717);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      editForm: {
        done: false,
        mediaurl: '',
        loading: false
      },

      auditFormVisible: false,
      auditFormTitle: '驳回',
      auditFormBtn: '提 交',
      editLoading: false,
      auditForm: {
        id: null,
        state: null,
        tip: null
      },
      auditFormRules: {
        state: [{ required: true, message: '请选择驳回至哪一端', trigger: 'change' }],
        tip: [{ required: false, message: '请选择驳回理由', trigger: 'blur' }, { min: 5, max: 80, message: '长度在 5 到 80 个字符', trigger: 'blur' }]

      },

      id: null,
      index: null,
      urladdr: './review'
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    newContent: 'newContent',
    statsdata: 'statsdata',
    statstotal: 'statstotal'
  }), {
    formatCategory: function formatCategory() {
      return _config.newsType[this.newContent.category] || '';
    },
    formatLabels: function formatLabels() {
      return this.newContent.labels.split('#') || [];
    },
    formatLabels2: function formatLabels2() {
      return this.newContent.labels.split('#').join(' / ') || '';
    },
    formatHotIndex: function formatHotIndex() {
      return _config.hotsType[this.newContent.hotindex + ''];
    },
    formatSourcefrom: function formatSourcefrom() {
      return this.newContent.sourcefrom || '';
    },
    formatAuditType: function formatAuditType() {
      var typelists = [];
      for (var i in _config.auditFullType) {
        var typelist = {};
        typelist.value = i;
        typelist.label = _config.auditFullType[i];
        typelists.push(typelist);
      }
      console.debug("formatCategory> typelists:%o", typelists);
      return typelists;
    },
    preNewsId: function preNewsId() {
      if (this.statsdata.length && this.statsdata.length > 0 && this.index > 0) {
        console.debug("preNewsId> index:%o, pre:%o", this.index, this.index - 1);
        return this.index - 1;
      } else {
        console.debug("preNewsId> -1");
        return -1;
      }
    },
    nextNewsId: function nextNewsId() {
      if (this.statsdata.length && this.statsdata.length > 0 && this.index < this.statsdata.length - 1) {
        console.debug("nextNewsId> index:%o, next:%o", this.index, this.index + 1);
        return this.index + 1;
      } else {
        console.debug("nextNewsId> next:-1");
        return -1;
      }
    }
  }),
  created: function created() {
    this.updateNewsConten();
  },
  destroyed: function destroyed() {
    _elementUi.Message.closeAll();
  },

  watch: {
    '$route': function $route(to, from) {
      console.debug("watch>route start to:%o, from:%o", to, from);
      console.debug("watch route> id:%o, index:%o, statsdata:%o, statstotal:%o", this.id, this.index, this.statsdata, this.statstotal);

      this.updateNewsConten();
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
    editNewsContent: 'editNewsContent',
    transferNewsState: 'transferNewsState',
    updateNewsContent: 'updateNewsContent',
    updateConsoleNewsDone: 'updateConsoleNewsDone'
  }), {
    updateNewsConten: function updateNewsConten() {
      this.id = this.$route.query.id || '';
      var index = this.$route.query.index || 0;
      this.index = parseInt(index);

      var item = this.reqNewsContent(this.id, this.statsdata);

      this.updateNewsContent(item);

      if (this.newContent.tip) {
        (0, _elementUi.Message)({
          showClose: true,
          duration: 0,
          message: '\u9A73\u56DE\u7406\u7531: ' + this.newContent.tip,
          type: 'warning'
        });
      } else {
        _elementUi.Message.closeAll();
      }
    },
    reedit: function reedit(newContent) {
      var nid = this.$route.query.id || '';
      this.$router.push({ path: './edit', query: { id: nid } });
    },
    reqNewsContent: function reqNewsContent(id, datalist) {
      console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
      var data = null;
      var hasUser = datalist.some(function (u) {
        if (u.id === id) {
          data = JSON.parse((0, _stringify2.default)(u));
          return true;
        }
      });
      console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
      return data;
    },
    handleCategoryChange: function handleCategoryChange(e) {
      console.debug("handleCategoryChange> e:%o", e);
    },
    handleAuditFormEdit: function handleAuditFormEdit(item) {
      console.debug("handleAuditFormEdit> item:%o", item);
      this.auditFormVisible = true;
      this.auditForm.id = item.id;
      this.auditForm.state = null;
      this.auditForm.tip = '';
    },

    editSubmit: function editSubmit() {
      var _this = this;

      var that = this;
      that.$refs.auditForm.validate(function (valid) {
        if (valid) {
          that.$confirm('\u8BF7\u786E\u8BA4\u79FB\u52A8\u81F3  ' + _config.auditFullType[_this.auditForm.state] + '  \u5417\uFF1F', '提示', {}).then(function () {
            that.editLoading = true;
            that.auditFormBtn = '提交中';
            console.debug("editSubmit> auditForm:%o", that.auditForm);
            var param = {};
            param.id = that.auditForm.id;
            param.state = that.auditForm.state;
            param.tip = that.auditForm.tip;
            that.transferNewsState(param).then(function (resp) {
              console.debug("editNewsContent> resp:%o", resp);
              if (resp.code === 0) {
                that.$message({
                  message: resp.msg,
                  type: 'success'
                });
                that.editLoading = false;
                that.btnEditText = '提 交';
                that.editForm.done = true;
                var para = {
                  id: param.id,
                  done: true
                };
                that.updateConsoleNewsDone(para);
                that.updateNewsConten();
                console.debug("transferNewsState>updateConsoleNewsDone para:%o", para);
                that.auditFormVisible = false;
              } else {
                that.$message({
                  message: resp.msg,
                  type: 'error'
                });
              }
            });
          });
        }
      });
    }

  }),
  components: {}
};

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(74);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(24);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(279);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(169);

var _store2 = _interopRequireDefault(_store);

var _elementUi = __webpack_require__(25);

var _elementUi2 = _interopRequireDefault(_elementUi);

var _vuexRouterSync = __webpack_require__(282);

var _ibroadcast = __webpack_require__(281);

var _ibroadcast2 = _interopRequireDefault(_ibroadcast);

var _axios = __webpack_require__(168);

var _axios2 = _interopRequireDefault(_axios);

__webpack_require__(280);

var _com = __webpack_require__(11);

var _config = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_config.MOCK_DEBUG) {}

_vue2.default.use(_elementUi2.default);

_router2.default.beforeEach(function (to, from, next) {
    var token = _store2.default.getters.getToken || _store2.default.getters.getAccesstoken;
    var role = _store2.default.getters.getRole || '';

    if (token != null && to.path == (0, _com.routeMap)('/login')) {
        next((0, _com.routeMap)('/'));
    }

    if (token === null && to.path !== (0, _com.routeMap)('/login') && to.path !== (0, _com.routeMap)('/404')) {
        next({
            path: (0, _com.routeMap)('/login'),
            query: to.query
        });
    } else {
        if (role && _config.roleType[role] && !new RegExp("^" + _config.roleType[role], "gim").test(to.name)) {
            next((0, _com.routeMap)('/' + _config.roleType[role] + '/'));
        } else {
            next();
        }
    }
});

_vue2.default.filter('enableStatus', function (value) {
    return value === '1' ? '启用中' : '已禁用';
});

_axios2.default.interceptors.response.use(function (response) {
    if (response.status === 200) {
        var request = response.request || { responseURL: '' };
        var urlarr = request.responseURL.split('/') || [];

        if (parseInt(response.data.code) === 9 && urlarr[urlarr.length - 1] !== 'login') {
            console.warn("token过期，执行退出登录");
            _elementUi.MessageBox.alert("token过期，执行退出登录", { confirmButtonText: '确定', type: 'error' });
            _store2.default.dispatch('outLogin');

            var type = urlarr[urlarr.length - 2];
            vm.$router.push({ path: (0, _com.routeMap)('/login'), query: { type: type } });
        } else {
            return response.data;
        }
    } else {
        _elementUi.MessageBox.alert(response.data.msg, { confirmButtonText: '确定', type: 'error' });
    }
}, function (error) {
    _elementUi.MessageBox.alert('接口通讯失败，请尝试刷新页面或者重新登录。如果还是存在问题，请联系管理员', '系统通知', { confirmButtonText: '确定', type: 'error' });
    return _promise2.default.reject(error);
});

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

var vm = new _vue2.default({
    el: '#ibroadcast',
    router: _router2.default,
    store: _store2.default,
    render: function render(h) {
        return h(_ibroadcast2.default);
    }
});

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(42);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(74);

var _promise2 = _interopRequireDefault(_promise);

var _api = __webpack_require__(52);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(41);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    auditdata: {},
    audittotal: 0
};

var getters = {
    auditdata: function auditdata(state) {
        return state.auditdata;
    },
    audittotal: function audittotal(state) {
        return state.audittotal;
    }
};

var actions = {
    getAuditData: function getAuditData(_ref, param) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        console.debug("getAuditData> param:%o", param);
        _api2.default.apiCommunication('/api/news/list', param, function (response) {
            console.debug("getAuditData /api/news/list> response:%o", response);

            commit(types.GET_AUDIT_LIST_SUCCESS, { response: response });
        });
    },
    getAuditDataII: function getAuditDataII(_ref2, param) {
        var commit = _ref2.commit,
            state = _ref2.state,
            rootState = _ref2.rootState;

        console.debug("getAuditDataII> param:%o", param);
        var response = {};
        response.code = 1;
        commit(types.GET_AUDIT_LIST_SUCCESS, { response: response });

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/list', param, function (response) {
                console.debug("getAuditDataII ok response:%o", response);
                commit(types.GET_AUDIT_LIST_SUCCESS, { response: response });
                resolve(response);
            }, function (err) {
                console.error("getAuditDataII err:%o", err);

                reject(err);
            });
        });
    }
};

var mutations = (0, _defineProperty3.default)({}, types.GET_AUDIT_LIST_SUCCESS, function (state, _ref3) {
    var response = _ref3.response;

    var _data = {};
    var total = 0;

    if (response.code === 0) {
        _data = response.data.news;
        total = Number(response.data.total);
    }
    state.auditdata = _data;
    state.audittotal = total;
});

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(42);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = __webpack_require__(52);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(41);

var types = _interopRequireWildcard(_mutation);

var _package = __webpack_require__(815);

var pi = _interopRequireWildcard(_package);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VERSION = pi.version;

var state = {
    appVer: VERSION,
    loadingStatus: false
};

var getters = {
    getAppVer: function getAppVer(state) {
        return state.appVer;
    },
    getLoadingStatus: function getLoadingStatus(state) {
        return state.loadingStatus;
    }
};

var actions = {
    updateLoadingStatus: function updateLoadingStatus(_ref, loading_status) {
        var commit = _ref.commit;

        commit(types.COM_LOADING_STATUS, { loading_status: loading_status });
    }
};

var mutations = (0, _defineProperty3.default)({}, types.COM_LOADING_STATUS, function (state, _ref2) {
    var loading_status = _ref2.loading_status;

    var status = false;

    if (loading_status === true) {
        status = true;
    }
    state.loadingStatus = status;
});

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(42);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(74);

var _promise2 = _interopRequireDefault(_promise);

var _mutations;

var _api = __webpack_require__(52);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(41);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(11);

var _config = __webpack_require__(13);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    newsdata: {},
    newstotal: 0,
    newContent: {},
    userlist: []
};

var getters = {
    newsdata: function newsdata(state) {
        return state.newsdata;
    },
    newstotal: function newstotal(state) {
        return state.newstotal;
    },
    newContent: function newContent(state) {
        return state.newContent;
    },
    userlist: function userlist(state) {
        return state.userlist;
    }
};

var actions = {
    getEditorData: function getEditorData(_ref, param) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        _api2.default.apiCommunication('/api/news/list', param, function (response) {
            commit(types.GET_NEWS_LIST_SUCCESS, { response: response });
        });
    },
    getNewsData: function getNewsData(_ref2, param) {
        var commit = _ref2.commit,
            state = _ref2.state,
            rootState = _ref2.rootState;

        commit(types.GET_NEWS_LIST_SUCCESS, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/list', param, function (response) {
                commit(types.GET_NEWS_LIST_SUCCESS, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getNewsData err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    updateNewsData: function updateNewsData(_ref3, param) {
        var commit = _ref3.commit;

        var response = {};
        response.code = 0;
        commit(types.UPDATE_NEWS_DATA, { response: response, param: param });
    },
    updateNewsDataDone: function updateNewsDataDone(_ref4, param) {
        var commit = _ref4.commit;

        commit(types.ADD_NEWS_DATA_DONE, { param: param });
    },
    addNewsContent: function addNewsContent(_ref5, param) {
        var commit = _ref5.commit;


        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/add', param, function (response) {

                commit(types.ADD_NEWS_CONTENT, { response: response, param: param });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    editNewsContent: function editNewsContent(_ref6, param) {
        var commit = _ref6.commit;

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/edit', param, function (response) {

                commit(types.UPDATE_NEWS_CONTENT, { response: response, param: param });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    queryUnusedContent: function queryUnusedContent(_ref7, param) {
        var commit = _ref7.commit;

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/news/query/unused', param, function (response) {

                commit(types.QUERY_NEWS_CONTENT, { response: response, param: param });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("queryUnusedContent err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    updateNewsContent: function updateNewsContent(_ref8, param) {
        var commit = _ref8.commit;

        var response = {};

        response.code = 0;
        commit(types.UPDATE_NEWS_CONTENT, { response: response, param: param });
    },
    transferNewsState: function transferNewsState(_ref9, param) {
        var commit = _ref9.commit;

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/transfer', param, function (resp) {
                if (typeof resolve === 'function') {
                    resolve(resp);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getNewLables: function getNewLables(_ref10, param) {
        var commit = _ref10.commit;

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/label', param, function (resp) {
                if (typeof resolve === 'function') {
                    resolve(resp);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getUserList: function getUserList(_ref11, param) {
        var commit = _ref11.commit;

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/user/list', param, function (resp) {
                if (typeof resolve === 'function') {
                    resolve(resp);
                }
            }, function (err) {
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.GET_NEWS_LIST_SUCCESS, function (state, _ref12) {
    var response = _ref12.response;

    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.news;
        state.newstotal = Number(response.data.total);
    }
    state.newsdata = _data;
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_NEWS_DATA, function (state, _ref13) {
    var response = _ref13.response,
        param = _ref13.param;

    var _data = {};
    if (response.code === 0) {
        _data = param;
        state.newsdata = _data;
    }
}), (0, _defineProperty3.default)(_mutations, types.ADD_NEWS_DATA_DONE, function (state, _ref14) {
    var param = _ref14.param;

    if (param && param.id && param.done) {
        state.newsdata.filter(function (u) {
            if (u.id === param.id) {
                u.done = param.done;
                return true;
            }
        });
    }
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_NEWS_CONTENT, function (state, _ref15) {
    var response = _ref15.response,
        param = _ref15.param;

    var _data = {};
    if (response.code === 0) {
        _data = param;

        state.newContent = _data;
    }
}), (0, _defineProperty3.default)(_mutations, types.QUERY_NEWS_CONTENT, function (state, _ref16) {
    var response = _ref16.response,
        param = _ref16.param;

    var _data = {};
    var news = response.data.news;
    if (response.code === 0 && news) {
        _data.category = 2;
        for (var i in _config.newsType) {
            if (_config.newsType.hasOwnProperty(i) && news.category === _config.newsType[i]) {
                console.log(i, ":", _config.newsType[i]);
                _data.category = i;
            };
        }
        _data.content = news.brief || '';
        _data.cover = news.pic || '';
        _data.hotindex = news.hot + '' || '';
        _data.labels = '';
        _data.sourcefrom = news.source + '' || '';
        _data.sourceurl = news.url || '';
        _data.title = news.title || '';
        _data.origintext = news.content || '';

        state.newContent = _data;
    }
}), (0, _defineProperty3.default)(_mutations, types.ADD_NEWS_CONTENT, function (state, _ref17) {
    var response = _ref17.response,
        param = _ref17.param;

    var _data = {};
    if (response.code === 0) {
        _data = param;
        _data.id = response.data.newsId;
    }
    state.newContent = _data;
}), _mutations);

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(52);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(41);

var types = _interopRequireWildcard(_mutation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {};

var getters = {};

var actions = {};

var mutations = {};

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(42);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _api = __webpack_require__(52);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(41);

var types = _interopRequireWildcard(_mutation);

var _reactCookie = __webpack_require__(257);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _elementUi = __webpack_require__(25);

var _config = __webpack_require__(13);

var _com = __webpack_require__(11);

var _cryptoJs = __webpack_require__(405);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    token: _reactCookie2.default.load('ibroadcasttoken') || null,
    account: _reactCookie2.default.load('ibroadcastaccount') || null,
    role: _reactCookie2.default.load('ibroadcastrole') || null,
    osspolicy: _reactCookie2.default.load('ibroadcastosspolicy') || null,
    osskeyid: _reactCookie2.default.load('ibroadcastosskeyid') || null,
    osssign: _reactCookie2.default.load('ibroadcastosssign') || null,

    appid: _reactCookie2.default.load('ibroadcastappid') || null,
    accesstoken: _reactCookie2.default.load('ibroadcastaccesstoken') || null
};

var getters = {
    getToken: function getToken(state) {
        return state.token;
    },
    getAccount: function getAccount(state) {
        return state.account;
    },
    getRole: function getRole(state) {
        return state.role;
    },
    getOsspolicy: function getOsspolicy(state) {
        return state.osspolicy;
    },
    getOsskeyid: function getOsskeyid(state) {
        return state.osskeyid;
    },
    getOsssign: function getOsssign(state) {
        return state.osssign;
    },

    getAppid: function getAppid(state) {
        return state.appid;
    },
    getAccesstoken: function getAccesstoken(state) {
        return state.accesstoken;
    }
};

var actions = {
    onLogin: function onLogin(_ref, that) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        var param = that.form;
        _api2.default.apiCommunication('/api/user/login', param, function (response) {
            if (response.code !== 0) {
                _elementUi.MessageBox.alert('\u767B\u5F55\u5931\u8D25\uFF0C' + response.msg, '系统通知', { confirmButtonText: '确定', type: 'error' });
                return false;
            }

            var exp = new Date();
            exp.setTime(exp.getTime() + 1 * 24 * 60 * 60 * 1000);

            _reactCookie2.default.save('ibroadcasttoken', response.data.token, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastaccount', param.name, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastrole', response.data.role, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastosspolicy', response.data.osspolicy, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastosskeyid', response.data.osskeyid, {
                path: '/',
                expires: exp
            });
            _reactCookie2.default.save('ibroadcastosssign', response.data.osssign, {
                path: '/',
                expires: exp
            });

            commit(types.USER_LOGIN_SUCCESS, { response: response, param: param });

            var type = null;
            if (state.role) {
                type = _config.roleType[state.role];
            } else {
                type = rootState.route.query.type || '';
            }
            that.$router.push({ path: (0, _com.routeMap)('/' + type) });
        });
    },
    AppIdLogin: function AppIdLogin(_ref2, that) {
        var commit = _ref2.commit,
            state = _ref2.state,
            rootState = _ref2.rootState;

        var param = {};
        param.appid = that.form.name;
        var appsecret = that.form.password;

        var exp = new Date();

        var timestamp = Math.round(exp.getTime() / 60000);

        var tempstr = param.appid + appsecret + timestamp;
        var tmeptoken = _cryptoJs2.default.MD5(tempstr).toString();

        var accesstoken = (timestamp + tmeptoken).toUpperCase();

        param.accesstoken = accesstoken;


        exp.setTime(exp.getTime() + 1 * 2 * 60 * 60 * 1000);

        _reactCookie2.default.save('ibroadcastappid', param.appid, {
            path: '/',
            expires: exp
        });
        _reactCookie2.default.save('ibroadcastaccesstoken', param.accesstoken, {
            path: '/',
            expires: exp
        });
        _reactCookie2.default.save('ibroadcastaccount', param.appid, {
            path: '/',
            expires: exp
        });

        commit(types.APPID_LOGIN_SUCCESS, { param: param });
        var type = rootState.route.query.type || '';
        that.$router.push({ path: (0, _com.routeMap)('/' + type) });
    },
    TokenLogin: function TokenLogin(_ref3, that) {
        var commit = _ref3.commit,
            state = _ref3.state,
            rootState = _ref3.rootState;

        var param = {
            appid: that.form.name,
            accesstoken: that.form.password
        };

        var exp = new Date();
        exp.setTime(exp.getTime() + 1 * 2 * 60 * 60 * 1000);

        _reactCookie2.default.save('ibroadcastappid', param.appid, {
            path: '/',
            expires: exp
        });
        _reactCookie2.default.save('ibroadcastaccesstoken', param.accesstoken, {
            path: '/',
            expires: exp
        });
        _reactCookie2.default.save('ibroadcastaccount', param.appid, {
            path: '/',
            expires: exp
        });

        commit(types.APPID_LOGIN_SUCCESS, { param: param });
        var type = 'press';
        that.$router.push({ path: (0, _com.routeMap)('/' + type) });
    },
    outLogin: function outLogin(_ref4) {
        var commit = _ref4.commit;

        _reactCookie2.default.remove('ibroadcasttoken', { path: '/' });
        _reactCookie2.default.remove('ibroadcastaccount', { path: '/' });
        _reactCookie2.default.remove('ibroadcastrole', { path: '/' });
        _reactCookie2.default.remove('ibroadcastosspolicy', { path: '/' });
        _reactCookie2.default.remove('ibroadcastosskeyid', { path: '/' });
        _reactCookie2.default.remove('ibroadcastosssign', { path: '/' });
        _reactCookie2.default.remove('ibroadcastappid', { path: '/' });
        _reactCookie2.default.remove('ibroadcastaccesstoken', { path: '/' });

        commit(types.USER_OUT_LOGIN);
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.USER_LOGIN_SUCCESS, function (state, _ref5) {
    var response = _ref5.response,
        param = _ref5.param;

    state.account = param.name;
    state.token = response.data.token;
    state.role = response.data.role;
    state.osspolicy = response.data.osspolicy;
    state.osskeyid = response.data.osskeyid;
    state.osssign = response.data.osssign;
}), (0, _defineProperty3.default)(_mutations, types.APPID_LOGIN_SUCCESS, function (state, _ref6) {
    var param = _ref6.param;

    state.appid = param.appid;
    state.accesstoken = param.accesstoken;
    state.account = param.appid;
}), (0, _defineProperty3.default)(_mutations, types.USER_OUT_LOGIN, function (state) {
    state.account = null;
    state.token = null;
    state.role = null;
    state.osspolicy = null;
    state.osskeyid = null;
    state.osssign = null;
    state.appid = null;
    state.accesstoken = null;
}), _mutations);

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(42);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutation = __webpack_require__(41);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    headernav: [],
    elmenu: []
};

var getters = {
    headernav: function headernav(state) {
        return state.headernav;
    },
    elmenu: function elmenu(state) {
        return state.elmenu;
    }
};

var datamentdata = [{
    name: '管理',
    url: '/productment',
    child: [{
        name: '列表',
        url: '/datament/productmgt'
    }]
}];

var ieditordata = [{
    name: '分类',
    url: (0, _com.routeMap)('/ieditor'),
    type: 'ieditor',
    child: [{
        name: '时政',
        url: (0, _com.routeMap)('/ieditor/list?type=2')
    }, {
        name: '社会',
        url: (0, _com.routeMap)('/ieditor/list?type=3')
    }, {
        name: '国际',
        url: (0, _com.routeMap)('/ieditor/list?type=4')
    }, {
        name: '科技',
        url: (0, _com.routeMap)('/ieditor/list?type=5')
    }, {
        name: '财经',
        url: (0, _com.routeMap)('/ieditor/list?type=6')
    }, {
        name: '娱乐',
        url: (0, _com.routeMap)('/ieditor/list?type=7')
    }, {
        name: '体育',
        url: (0, _com.routeMap)('/ieditor/list?type=8')
    }, {
        name: '军事',
        url: (0, _com.routeMap)('/ieditor/list?type=9')
    }, {
        name: '时尚',
        url: (0, _com.routeMap)('/ieditor/list?type=10')
    }]
}];

var pressdata = [{
    name: '列表',
    url: (0, _com.routeMap)('/press/list'),
    type: 'list'
}, {
    name: '搜索',
    url: (0, _com.routeMap)('/press/search'),
    type: 'search'
}];

var statsdata = [{
    name: '新闻列表',
    url: (0, _com.routeMap)('/stats/list'),
    type: 'list'
}, {
    name: '接口统计',
    url: (0, _com.routeMap)('/stats/interface'),
    type: 'interface'
}, {
    name: '事件统计',
    url: (0, _com.routeMap)('/stats/events'),
    type: 'events'
}, {
    name: '标签管理',
    url: (0, _com.routeMap)('/stats/labels'),
    type: 'labels'
}];

var actions = {
    headernavSwitch: function headernavSwitch(_ref, type) {
        var commit = _ref.commit;


        var data = void 0;
        switch (type) {
            case 'ieditor':
                break;
            case 'irecord':
                break;
            case 'press':
                data = pressdata;
                break;
            case 'audit':
                break;
            case 'stats':
                data = statsdata;
                break;

        }

        commit(types.HEADERNAV_SWITCH, { data: data });
    },
    elmenuSwitch: function elmenuSwitch(_ref2, type) {
        var commit = _ref2.commit;

        var data = void 0;
        switch (type) {
            default:
                data = datamentdata;
                break;
        }
        commit(types.ELMENU_SWITCH, { data: data });
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.HEADERNAV_SWITCH, function (state, _ref3) {
    var data = _ref3.data;

    state.headernav = data;
}), (0, _defineProperty3.default)(_mutations, types.ELMENU_SWITCH, function (state, _ref4) {
    var data = _ref4.data;

    state.elmenu = data;
}), _mutations);

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(42);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(74);

var _promise2 = _interopRequireDefault(_promise);

var _api = __webpack_require__(52);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(41);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    pressdata: {},
    presstotal: 0
};

var getters = {
    pressdata: function pressdata(state) {
        return state.pressdata;
    },
    presstotal: function presstotal(state) {
        return state.presstotal;
    }
};

var actions = {
    getPressData: function getPressData(_ref, param) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        commit(types.GET_PRESS_LIST_SUCCESS, {});

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/press/list', param, function (response) {
                commit(types.GET_PRESS_LIST_SUCCESS, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getPressData err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    searchPressData: function searchPressData(_ref2, param) {
        var commit = _ref2.commit,
            state = _ref2.state,
            rootState = _ref2.rootState;

        commit(types.GET_PRESS_LIST_SUCCESS, {});

        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/press/search', param, function (response) {
                commit(types.GET_PRESS_LIST_SUCCESS, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("searchPressData err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    }
};

var mutations = (0, _defineProperty3.default)({}, types.GET_PRESS_LIST_SUCCESS, function (state, _ref3) {
    var response = _ref3.response;

    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.news;
        state.presstotal = Number(response.data.total);
    }
    state.pressdata = _data;
});

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(42);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(74);

var _promise2 = _interopRequireDefault(_promise);

var _mutations;

var _api = __webpack_require__(52);

var _api2 = _interopRequireDefault(_api);

var _mutation = __webpack_require__(41);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    statsdata: {},
    statstotal: 0,
    newstats: {},
    newstatstotal: 0,
    eventdata: {},
    eventtotal: 0,
    apidata: null,
    appidlist: null,
    apitotal: null,
    labellist: null,
    labeltotal: null
};

var getters = {
    statsdata: function statsdata(state) {
        return state.statsdata;
    },
    statstotal: function statstotal(state) {
        return state.statstotal;
    },
    newstats: function newstats(state) {
        return state.newstats;
    },
    newstatstotal: function newstatstotal(state) {
        return state.newstatstotal;
    },
    eventdata: function eventdata(state) {
        return state.eventdata;
    },
    eventtotal: function eventtotal(state) {
        return state.eventtotal;
    },
    apidata: function apidata(state) {
        return state.apidata;
    },
    appidlist: function appidlist(state) {
        return state.appidlist;
    },
    apitotal: function apitotal(state) {
        return state.apitotal;
    },
    labellist: function labellist(state) {
        return state.labellist;
    },
    labeltotal: function labeltotal(state) {
        return state.labeltotal;
    }
};

var actions = {
    getConsoleNews: function getConsoleNews(_ref, param) {
        var commit = _ref.commit,
            state = _ref.state,
            rootState = _ref.rootState;

        console.debug("getConsoleNews> param:%o", param);
        commit(types.GET_CONSOLE_NEWS_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/console/news', param, function (response) {
                console.debug("getConsoleNews ok response:%o", response);
                commit(types.GET_CONSOLE_NEWS_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getConsoleNews err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    updateConsoleNewsDone: function updateConsoleNewsDone(_ref2, param) {
        var commit = _ref2.commit;

        console.debug("updateConsoleNewsDone> param:%o", param);
        commit(types.ADD_CONSOLE_DATA_DONE, { param: param });
    },
    getNewStatis: function getNewStatis(_ref3, param) {
        var commit = _ref3.commit,
            state = _ref3.state,
            rootState = _ref3.rootState;

        console.debug("getNewStatis> param:%o", param);
        commit(types.GET_NEWS_STATIS_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/news/statistics', param, function (response) {
                console.debug("getNewStatis ok response:%o", response);
                commit(types.GET_NEWS_STATIS_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getNewStatis err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getConsoleEvent: function getConsoleEvent(_ref4, param) {
        var commit = _ref4.commit,
            state = _ref4.state,
            rootState = _ref4.rootState;

        console.debug("getConsoleEvent> param:%o", param);
        commit(types.GET_CONSOLE_EVENT_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/console/event', param, function (response) {
                console.debug("getConsoleEvent ok response:%o", response);
                commit(types.GET_CONSOLE_EVENT_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getConsoleEvent err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getConsoleApi: function getConsoleApi(_ref5, param) {
        var commit = _ref5.commit,
            state = _ref5.state,
            rootState = _ref5.rootState;

        console.debug("getConsoleApi> param:%o", param);
        commit(types.GET_CONSOLE_API_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/console/api', param, function (response) {
                console.debug("getConsoleApi ok response:%o", response);
                commit(types.GET_CONSOLE_API_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getConsoleApi err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    getLabelList: function getLabelList(_ref6, param) {
        var commit = _ref6.commit,
            state = _ref6.state,
            rootState = _ref6.rootState;

        console.debug("getLabelList> param:%o", param);
        commit(types.GET_LABELS_LIST, {});
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/label/list', param, function (response) {
                console.debug("getLabelList ok response:%o", response);
                commit(types.GET_LABELS_LIST, { response: response });
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("getLabelList err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    updateLabel: function updateLabel(_ref7, param) {
        var commit = _ref7.commit,
            state = _ref7.state,
            rootState = _ref7.rootState;

        console.debug("updateLabel> param:%o", param);
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/label/update', param, function (response) {
                console.debug("updateLabel ok response:%o", response);
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("updateLabel err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    delLabel: function delLabel(_ref8, param) {
        var commit = _ref8.commit,
            state = _ref8.state,
            rootState = _ref8.rootState;

        console.debug("delLabel> param:%o", param);
        return new _promise2.default(function (resolve, reject) {
            _api2.default.apiCommunication('/api/label/del', param, function (response) {
                console.debug("delLabel ok response:%o", response);
                if (typeof resolve === 'function') {
                    resolve(response);
                }
            }, function (err) {
                console.error("delLabel err:%o", err);
                if (typeof reject === 'function') {
                    reject(err);
                }
            });
        });
    },
    updateStatsData: function updateStatsData(_ref9, param) {
        var commit = _ref9.commit;

        console.debug("updateStatsData> param:%o", param);
        var response = {};
        response.code = 0;
        commit(types.UPDATE_STATS_DATA, { response: response, param: param });
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.GET_CONSOLE_NEWS_LIST, function (state, _ref10) {
    var response = _ref10.response;

    console.debug("GET_CONSOLE_NEWS_LIST> response:%o", response);
    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.news;
        state.statstotal = Number(response.data.total);
    }
    state.statsdata = _data;
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_STATS_DATA, function (state, _ref11) {
    var response = _ref11.response,
        param = _ref11.param;

    console.debug("UPDATE_STATS_DATA> response:%o, param:%o", response, param);
    var _data = {};
    if (response && response.code === 0) {
        _data = param;
    }
    state.statsdata = _data;
}), (0, _defineProperty3.default)(_mutations, types.GET_NEWS_STATIS_LIST, function (state, _ref12) {
    var response = _ref12.response;

    console.debug("GET_NEWS_STATIS_LIST> response:%o", response);
    var _data = {};
    if (response && response.code === 0) {
        _data = response.data;
        state.newstatstotal = Number(response.data.total);
    }
    state.newstats = _data;
}), (0, _defineProperty3.default)(_mutations, types.ADD_CONSOLE_DATA_DONE, function (state, _ref13) {
    var param = _ref13.param;

    console.debug("ADD_CONSOLE_DATA_DONE> param:%o", param);
    if (param && param.id && param.done) {
        state.statsdata.filter(function (u) {
            if (u.id === param.id) {
                u.done = param.done;
                return true;
            }
        });
    }
}), (0, _defineProperty3.default)(_mutations, types.GET_CONSOLE_EVENT_LIST, function (state, _ref14) {
    var response = _ref14.response;

    console.debug("GET_CONSOLE_EVENT_LIST> response:%o", response);
    var _data = {};
    if (response && response.code === 0) {
        _data = response.data.events;
        state.eventtotal = Number(response.data.total);
    }
    state.eventdata = _data;
}), (0, _defineProperty3.default)(_mutations, types.GET_CONSOLE_API_LIST, function (state, _ref15) {
    var response = _ref15.response;

    console.debug("GET_CONSOLE_API_LIST> response:%o", response);
    var _apidata = {},
        _appidlist = [];
    if (response && response.code === 0) {
        _apidata = response.data.statistics;
        _appidlist = response.data.appidlist;
        state.apitotal = Number(response.data.total);
    }
    state.apidata = _apidata;
    state.appidlist = _appidlist;
}), (0, _defineProperty3.default)(_mutations, types.GET_LABELS_LIST, function (state, _ref16) {
    var response = _ref16.response;

    console.debug("GET_LABELS_LIST> response:%o", response);
    var _labellist = [];
    if (response && response.code === 0) {
        _labellist = response.data.label;
        state.labeltotal = Number(response.data.total);
    }
    state.labellist = _labellist;
}), _mutations);

exports.default = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ELMENU_SWITCH = exports.ELMENU_SWITCH = 'ELMENU_SWITCH';
var HEADERNAV_SWITCH = exports.HEADERNAV_SWITCH = 'HEADERNAV_SWITCH';

var USER_LOGIN_SUCCESS = exports.USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
var USER_OUT_LOGIN = exports.USER_OUT_LOGIN = 'USER_OUT_LOGIN';

var COM_LOADING_STATUS = exports.COM_LOADING_STATUS = 'COM_LOADING_STATUS';

var GET_NEWS_LIST_SUCCESS = exports.GET_NEWS_LIST_SUCCESS = 'GET_NEWS_LIST_SUCCESS';
var UPDATE_NEWS_DATA = exports.UPDATE_NEWS_DATA = 'UPDATE_NEWS_DATA';
var UPDATE_NEWS_CONTENT = exports.UPDATE_NEWS_CONTENT = 'UPDATE_NEWS_CONTENT';
var QUERY_NEWS_CONTENT = exports.QUERY_NEWS_CONTENT = 'QUERY_NEWS_CONTENT';
var ADD_NEWS_CONTENT = exports.ADD_NEWS_CONTENT = 'ADD_NEWS_CONTENT';
var GET_NEWS_LABELS_SUCCESS = exports.GET_NEWS_LABELS_SUCCESS = 'GET_NEWS_LABELS_SUCCESS';
var ADD_NEWS_DATA_DONE = exports.ADD_NEWS_DATA_DONE = 'ADD_NEWS_DATA_DONE';
var GET_PRESS_LIST_SUCCESS = exports.GET_PRESS_LIST_SUCCESS = 'GET_PRESS_LIST_SUCCESS';
var APPID_LOGIN_SUCCESS = exports.APPID_LOGIN_SUCCESS = 'APPID_LOGIN_SUCCESS';
var GET_AUDIT_LIST_SUCCESS = exports.GET_AUDIT_LIST_SUCCESS = 'GET_AUDIT_LIST_SUCCESS';
var GET_CONSOLE_NEWS_LIST = exports.GET_CONSOLE_NEWS_LIST = 'GET_CONSOLE_NEWS_LIST';
var GET_NEWS_STATIS_LIST = exports.GET_NEWS_STATIS_LIST = 'GET_NEWS_STATIS_LIST';
var GET_CONSOLE_EVENT_LIST = exports.GET_CONSOLE_EVENT_LIST = 'GET_CONSOLE_EVENT_LIST';
var GET_CONSOLE_API_LIST = exports.GET_CONSOLE_API_LIST = 'GET_CONSOLE_API_LIST';
var GET_LABELS_LIST = exports.GET_LABELS_LIST = 'GET_LABELS_LIST';
var ADD_CONSOLE_DATA_DONE = exports.ADD_CONSOLE_DATA_DONE = 'ADD_CONSOLE_DATA_DONE';
var UPDATE_STATS_DATA = exports.UPDATE_STATS_DATA = 'UPDATE_STATS_DATA';

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(24);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(168);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(13);

var _querystring = __webpack_require__(729);

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    apiCommunication: function apiCommunication(apiname, param, cb, errcb) {
        var params = param;
        var host = _config.CONSOLE_HOST;

        if (apiname) {
            var apinameArr = apiname.split('/');
            apinameArr = apinameArr.filter(function (t) {
                return t != undefined && t !== null && t !== '';
            });
            var arrlen = apinameArr.length;


            if (apinameArr[0] === 'news' && apinameArr[1] === 'query') {
                host = _config.QUERY_HOST;
                params = (0, _config.setParams)(param);
            } else {
                if (apinameArr[1] === 'news' || apinameArr[1] === 'console' || apinameArr[1] === 'label' || apinameArr[1] === 'console' || apinameArr[1] === 'user' && apinameArr[2] !== 'login') {
                    params = (0, _config.setParams)(param);
                } else if (apinameArr[1] === 'press') {
                    host = _config.API_HOST;
                }
            }
        }

        _axios2.default.post(host + apiname, _querystring2.default.stringify(params)).then(function (response) {
            if (typeof cb === 'function') {
                cb(response);
            }
        });
    }
};

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 697:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 703:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 705:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 723:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(756),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(767),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(719)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(755),
  /* scopeId */
  "data-v-149994de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(722)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(766),
  /* scopeId */
  "data-v-6f7ebf68",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(769),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(763),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(724)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(774),
  /* scopeId */
  "data-v-f300274c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(720)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(758),
  /* scopeId */
  "data-v-35c1cf94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(723)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(773),
  /* scopeId */
  "data-v-f2bf15f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(772),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(768),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(721)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(764),
  /* scopeId */
  "data-v-61aa2982",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(771),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(762),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(765),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(757),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(770),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(751),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(718)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(752),
  /* scopeId */
  "data-v-0a6faa4d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contentlist"
    }
  }, _vm._l((_vm.newsdata), function(item, index) {
    return _c('el-row', {
      key: item.id,
      attrs: {
        "type": "flex",
        "justify": "center"
      }
    }, [_c('el-col', {
      staticClass: "el-item",
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 22,
        "lg": 14
      }
    }, [_c('div', {
      staticClass: "box shadow"
    }, [(_vm.labelname === '录音已上传' && item.mediaurl) ? _c('div', {
      staticClass: "box-record-label"
    }, [_c('span', {
      staticClass: "box-label-text"
    }, [_vm._v(_vm._s(_vm.labelname))])]) : (_vm.labelname === '已修改' && item.tip) ? _c('div', {
      staticClass: "box-audit-label"
    }, [_c('span', {
      staticClass: "box-label-text"
    }, [_vm._v(_vm._s(_vm.labelname))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "news-box"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: _vm.urladdr,
          query: {
            id: item.id,
            index: index
          }
        }
      }
    }, [_c('div', {
      staticClass: "box-header fs-catego"
    }, [_c('span', {
      staticClass: "new-type"
    }, [_vm._v(_vm._s(item.category))]), _vm._v(" "), _c('span', {
      staticClass: "hot-level"
    }, [_vm._v(_vm._s(item.hotindex))])]), _vm._v(" "), _c('div', {
      staticClass: "box-title"
    }, [_c('h1', {
      staticClass: "fs-title"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "box-date fs-label"
    }, [_c('span', [_vm._v(_vm._s(item.date))]), _vm._v(" "), (item.editorname) ? _c('span', [_vm._v("编:" + _vm._s(item.editorname))]) : _vm._e(), _vm._v(" "), (item.hostname) ? _c('span', [_vm._v(" 播:" + _vm._s(item.hostname))]) : (item.host) ? _c('span', [_vm._v(" 播:" + _vm._s(item.host))]) : _vm._e(), _vm._v(" "), (item.verifiername) ? _c('span', [_vm._v(" 审:" + _vm._s(item.verifiername))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "box-content"
    }, [(item.cover) ? _c('img', {
      staticClass: "box-image",
      attrs: {
        "src": item.cover
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "box-text fs-text"
    }, [_vm._v(_vm._s(item.content))])]), _vm._v(" "), _c('div', {
      staticClass: "box-foot"
    }, [_c('div', {
      staticClass: "host-name"
    }, [(item.category) ? _c('span', {
      staticClass: "fs-label"
    }, [_c('b', [_vm._v(_vm._s(item.state))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "foot-label fs-label"
    }, _vm._l((item.labels), function(lable, index) {
      return _c('span', {
        key: index
      }, [(index === 0) ? _c('span', [_vm._v(_vm._s(lable))]) : _c('span', [_vm._v(" / " + _vm._s(lable))])])
    }))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tipshow && item.tip),
        expression: "tipshow && item.tip"
      }],
      staticClass: "box-tag"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(732)
      }
    })])])], 1)])])], 1)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 752:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "statsreview"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "header-tips",
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 18,
      "lg": 10
    }
  }, [(_vm.newContent.mediaurl) ? _c('audio', {
    staticClass: "header-tips-audio",
    attrs: {
      "src": _vm.newContent.mediaurl,
      "controls": "controls",
      "controlsList": "nodownload",
      "oncontextmenu": "return false"
    }
  }, [_vm._v("\n      您的浏览器不支持 audio 标签。\n      ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 4,
      "lg": 4
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "disabled": _vm.newContent.done
    },
    on: {
      "click": function($event) {
        _vm.reedit(_vm.newContent)
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.newContent.done
    },
    on: {
      "click": function($event) {
        _vm.handleAuditFormEdit(_vm.newContent)
      }
    }
  }, [_vm._v("移动")])], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "editor-content"
  }, [_c('div', {
    staticClass: "news-box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('span', {
    staticClass: "new-type fs-label"
  }, [_vm._v(_vm._s(_vm.formatCategory))]), _vm._v(" "), _c('span', {
    staticClass: "hot-level fs-label"
  }, [_vm._v(_vm._s(_vm.formatHotIndex))])]), _vm._v(" "), _c('div', {
    staticClass: "box-title"
  }, [_c('h1', {
    staticClass: "fs-title"
  }, [_vm._v(_vm._s(_vm.newContent.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-author fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.newContent.date) + " ")]), _vm._v(" "), (_vm.newContent.editorname) ? _c('span', [_vm._v(" 编:" + _vm._s(_vm.newContent.editorname))]) : _vm._e(), _vm._v(" "), (_vm.newContent.hostname) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.hostname))]) : (_vm.newContent.host) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.host))]) : _vm._e(), _vm._v(" "), (_vm.newContent.verifiername) ? _c('span', [_vm._v(" 审:" + _vm._s(_vm.newContent.verifiername))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 20,
      "sm": 20,
      "md": 12,
      "lg": 10
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newContent.cover),
      expression: "newContent.cover"
    }],
    staticClass: "box-image",
    attrs: {
      "src": _vm.newContent.cover
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('p', {
    staticClass: "box-text fs-text"
  }, [_vm._v(_vm._s(_vm.newContent.content))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-source fs-text"
  }, [_c('span', [_vm._v("新闻来源: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatSourcefrom))])]), _vm._v(" "), _c('div', {
    staticClass: "box-origin fs-text"
  }, [_c('span', [_vm._v("原文地址: ")]), _c('a', {
    attrs: {
      "href": _vm.newContent.sourceurl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "link-url"
  }, [_vm._v(_vm._s(_vm.newContent.sourceurl))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-foot fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatLabels2))])]), _vm._v(" "), _c('el-row', {
    staticClass: "pre-next-page",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', [(_vm.preNewsId !== -1) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.urladdr,
        query: {
          id: _vm.statsdata[_vm.preNewsId].id,
          index: _vm.preNewsId
        }
      }
    }
  }, [_c('p', {
    staticClass: "page-text fs-label"
  }, [_vm._v("上一篇 " + _vm._s(_vm.statsdata[_vm.preNewsId].title))])]) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', [(_vm.nextNewsId !== -1) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.urladdr,
        query: {
          id: _vm.statsdata[_vm.nextNewsId].id,
          index: _vm.nextNewsId
        }
      }
    }
  }, [_c('p', {
    staticClass: "page-text fs-label"
  }, [_vm._v("下一篇 " + _vm._s(_vm.statsdata[_vm.nextNewsId].title))])]) : _vm._e()], 1)])], 1)], 1)])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.auditFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.auditFormVisible),
      callback: function($$v) {
        _vm.auditFormVisible = $$v
      },
      expression: "auditFormVisible"
    }
  }, [_c('el-form', {
    ref: "auditForm",
    attrs: {
      "model": _vm.auditForm,
      "rules": _vm.auditFormRules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "移动至",
      "prop": "state"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.auditForm.state),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "state", $$v)
      },
      expression: "auditForm.state"
    }
  }, _vm._l((_vm.formatAuditType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原因",
      "prop": "tip"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 60
      },
      "placeholder": "请输入驳回理由，最少5个字，最多60个字。"
    },
    model: {
      value: (_vm.auditForm.tip),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "tip", $$v)
      },
      expression: "auditForm.tip"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.auditFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.auditFormBtn))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "elmenu"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.defaultElmenu,
      "unique-opened": true,
      "theme": "dark",
      "router": true
    }
  }, [_vm._l((_vm.elmenu), function(item) {
    return [(item.child) ? [_c('el-submenu', {
      attrs: {
        "index": item.url
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-menu"
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.child), function(childitem) {
      return [_c('el-menu-item', {
        attrs: {
          "index": childitem.url
        }
      }, [_vm._v(_vm._s(childitem.name))])]
    })], 2)] : [_c('el-menu-item', {
      attrs: {
        "index": item.url
      }
    }, [_vm._v(_vm._s(item.name))])]]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "auditreview"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "header-tips",
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 10
    }
  }, [(_vm.newContent.mediaurl) ? _c('audio', {
    staticClass: "header-tips-audio",
    attrs: {
      "src": _vm.newContent.mediaurl,
      "controls": "controls",
      "controlsList": "nodownload",
      "oncontextmenu": "return false"
    }
  }, [_vm._v("\n      您的浏览器不支持 audio 标签。\n      ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.newContent.done
    },
    on: {
      "click": function($event) {
        _vm.handleAuditFormEdit(_vm.newContent)
      }
    }
  }, [_vm._v("驳回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.newContent.done
    },
    on: {
      "click": function($event) {
        _vm.releaseNews(_vm.newContent.id)
      }
    }
  }, [_vm._v("通过")])], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "editor-content"
  }, [_c('div', {
    staticClass: "news-box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('span', {
    staticClass: "new-type fs-label"
  }, [_vm._v(_vm._s(_vm.formatCategory))]), _vm._v(" "), _c('span', {
    staticClass: "hot-level fs-label"
  }, [_vm._v(_vm._s(_vm.formatHotIndex))])]), _vm._v(" "), _c('div', {
    staticClass: "box-title"
  }, [_c('h1', {
    staticClass: "fs-title"
  }, [_vm._v(_vm._s(_vm.newContent.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-author fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.newContent.date) + " ")]), _vm._v(" "), (_vm.newContent.editorname) ? _c('span', [_vm._v(" 编:" + _vm._s(_vm.newContent.editorname))]) : _vm._e(), _vm._v(" "), (_vm.newContent.hostname) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.hostname))]) : (_vm.newContent.host) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.host))]) : _vm._e(), _vm._v(" "), (_vm.newContent.verifiername) ? _c('span', [_vm._v(" 审:" + _vm._s(_vm.newContent.verifiername))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 20,
      "sm": 20,
      "md": 12,
      "lg": 10
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newContent.cover),
      expression: "newContent.cover"
    }],
    staticClass: "box-image",
    attrs: {
      "src": _vm.newContent.cover
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('p', {
    staticClass: "box-text fs-text"
  }, [_vm._v(_vm._s(_vm.newContent.content))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-source fs-text"
  }, [_c('span', [_vm._v("新闻来源:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatSourcefrom))])]), _vm._v(" "), _c('div', {
    staticClass: "box-origin fs-text"
  }, [_c('span', [_vm._v("原文地址:")]), _c('a', {
    attrs: {
      "href": _vm.newContent.sourceurl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "link-url"
  }, [_vm._v(_vm._s(_vm.newContent.sourceurl))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-foot fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatLabels2))])]), _vm._v(" "), _c('el-row', {
    staticClass: "pre-next-page",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', [(_vm.preNewsId !== -1) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.urladdr,
        query: {
          id: _vm.newsdata[_vm.preNewsId].id,
          index: _vm.preNewsId
        }
      }
    }
  }, [_c('p', {
    staticClass: "page-text fs-label"
  }, [_vm._v("上一篇 " + _vm._s(_vm.newsdata[_vm.preNewsId].title))])]) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('div', [(_vm.nextNewsId !== -1) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.urladdr,
        query: {
          id: _vm.newsdata[_vm.nextNewsId].id,
          index: _vm.nextNewsId
        }
      }
    }
  }, [_c('p', {
    staticClass: "page-text fs-label"
  }, [_vm._v("下一篇 " + _vm._s(_vm.newsdata[_vm.nextNewsId].title))])]) : _vm._e()], 1)])], 1)], 1)])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.auditFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.auditFormVisible),
      callback: function($$v) {
        _vm.auditFormVisible = $$v
      },
      expression: "auditFormVisible"
    }
  }, [_c('el-form', {
    ref: "auditForm",
    attrs: {
      "model": _vm.auditForm,
      "rules": _vm.auditFormRules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "移动至",
      "prop": "state"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.auditForm.state),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "state", $$v)
      },
      expression: "auditForm.state"
    }
  }, _vm._l((_vm.formatAuditType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原因",
      "prop": "tip"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 60
      },
      "placeholder": "请输入驳回理由，最少5个字，最多60个字。"
    },
    model: {
      value: (_vm.auditForm.tip),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "tip", $$v)
      },
      expression: "auditForm.tip"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.auditFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.auditFormBtn))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "audit"
    }
  }, [_c('headernav', {
    attrs: {
      "type": "audit"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "statslabels"
    }
  }, [_c('el-form', {
    staticClass: "head-form",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions2
    },
    on: {
      "change": _vm.handleDateRangeChange
    },
    model: {
      value: (_vm.filters.daterange),
      callback: function($$v) {
        _vm.$set(_vm.filters, "daterange", $$v)
      },
      expression: "filters.daterange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 10
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getLoadingStatus),
      expression: "getLoadingStatus"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formatListData,
      "stripe": "",
      "border": "",
      "element-loading-text": "玩命加载中..."
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "240"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "标签名",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.inputVisible) ? _c('el-input', {
          staticClass: "input-new-tag",
          attrs: {
            "id": scope.row.id,
            "size": "mini"
          },
          on: {
            "blur": function($event) {
              _vm.handleNameInputBlur(scope.$index, scope.row)
            }
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              _vm.handleNameInputConfirm(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.name),
            callback: function($$v) {
              _vm.$set(scope.row, "name", $$v)
            },
            expression: "scope.row.name"
          }
        }) : _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.showInput(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birthday",
      "label": "生成日期",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.handleDelClick(scope.$index, _vm.labellist)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-pagin"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "el-item shadow",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.page,
      "page-size": _vm.limit,
      "total": _vm.labeltotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ieditorreview"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "header-tips",
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 10
    }
  }, [(_vm.newContent.edittime) ? _c('span', [_vm._v("上次保存于" + _vm._s(_vm.newContent.edittime))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "disabled": _vm.filters.done
    },
    on: {
      "click": function($event) {
        _vm.reedit(_vm.newContent.id)
      }
    }
  }, [_vm._v("继续编辑")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.filters.done
    },
    on: {
      "click": function($event) {
        _vm.releaseNews(_vm.newContent.id)
      }
    }
  }, [_vm._v("发布")])], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "review-content"
  }, [_c('div', {
    staticClass: "news-box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('span', {
    staticClass: "new-type fs-label"
  }, [_vm._v(_vm._s(_vm.formatCategory))]), _vm._v(" "), _c('span', {
    staticClass: "hot-level fs-label"
  }, [_vm._v(_vm._s(_vm.formatHotIndex))])]), _vm._v(" "), _c('div', {
    staticClass: "box-title"
  }, [_c('h1', {
    staticClass: "fs-title"
  }, [_vm._v(_vm._s(_vm.newContent.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-author fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.newContent.date) + " ")]), _vm._v(" "), (_vm.newContent.editorname) ? _c('span', [_vm._v(" 编:" + _vm._s(_vm.newContent.editorname))]) : _vm._e(), _vm._v(" "), (_vm.newContent.hostname) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.hostname))]) : (_vm.newContent.host) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.host))]) : _vm._e(), _vm._v(" "), (_vm.newContent.verifiername) ? _c('span', [_vm._v(" 审:" + _vm._s(_vm.newContent.verifiername))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 20,
      "sm": 20,
      "md": 12,
      "lg": 10
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newContent.cover),
      expression: "newContent.cover"
    }],
    staticClass: "box-image",
    attrs: {
      "src": _vm.newContent.cover
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('p', {
    staticClass: "box-text fs-text"
  }, [_vm._v(_vm._s(_vm.newContent.content))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-source fs-text"
  }, [_c('span', [_vm._v("新闻来源:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatSourcefrom))])]), _vm._v(" "), _c('div', {
    staticClass: "box-origin fs-text"
  }, [_c('span', [_vm._v("原文地址:")]), _c('a', {
    attrs: {
      "href": _vm.newContent.sourceurl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "link-url"
  }, [_vm._v(_vm._s(_vm.newContent.sourceurl))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-foot fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatLabels2))])])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itoolbar"
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": "工作统计",
      "visible": _vm.dialogTableVisible,
      "modal-append-to-body": false,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "工作数据",
      "name": "first"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dialogTableLoading),
      expression: "dialogTableLoading"
    }],
    staticClass: "echarts-wrap",
    attrs: {
      "id": "salesTime",
      "element-loading-text": "拼命加载中..."
    }
  })]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "驳回信息",
      "name": "second"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dialogTableLoading),
      expression: "dialogTableLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中...",
      "data": _vm.newstats.fallback,
      "height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "标题"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.title))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "驳回原因"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.tip))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "prop": "time",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "标题",
      "prop": "title",
      "min-width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "驳回原因",
      "prop": "tip",
      "min-width": "250"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false;
        _vm.dialogTableLoading = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false;
        _vm.dialogTableLoading = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "toolbar-nav",
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "toolbar-log-box",
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 5,
      "lg": 3
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.handlelogoclick(_vm.type)
      }
    }
  }, [_c('img', {
    staticClass: "toolbar-logo",
    attrs: {
      "src": __webpack_require__(283)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fs-text",
    staticStyle: {
      "color": "#E5E9F2"
    }
  }, [_vm._v(" · " + _vm._s(_vm.ComputerRouterName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 13,
      "sm": 14,
      "md": 12,
      "lg": 8
    }
  }, [_c('el-menu', {
    staticClass: "toolbar-menu",
    attrs: {
      "theme": "dark",
      "default-active": _vm.activeIndex,
      "unique-opened": true,
      "mode": "horizontal",
      "router": true
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.headernav), function(item, index) {
    return [(item.child) ? [_c('el-submenu', {
      attrs: {
        "index": item.type
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(_vm.readMenuItemName))]), _vm._v(" "), _vm._l((item.child), function(childitem) {
      return [_c('el-menu-item', {
        attrs: {
          "index": childitem.url
        }
      }, [_vm._v(_vm._s(childitem.name))])]
    })], 2)] : [_c('el-menu-item', {
      attrs: {
        "index": item.type
      }
    }, [_vm._v(_vm._s(item.name))])]]
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 5,
      "md": 5,
      "lg": 4
    }
  }, [_c('div', {
    staticClass: "toolbar-features"
  }, [_c('el-button', {
    staticClass: "feat-button",
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.handleAddClick
    }
  }, [((_vm.keypath === 'list' || _vm.keypath === 'review') && _vm.type === 'ieditor') ? _c('i', {
    staticClass: "el-icon-plus fs-text"
  }) : _vm._e()]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('div', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "iconfont icon-user fs-text"
  }), _vm._v(" "), _c('span', {
    staticClass: "features-name fs-text"
  }, [_vm._v(_vm._s(_vm.account))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'press' && _vm.type !== 'stats'),
      expression: "type!=='press'&&type!=='stats'"
    }],
    staticClass: "iconfont icon-menu fs-text"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "fs-text",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'press' && _vm.type !== 'stats'),
      expression: "type!=='press'&&type!=='stats'"
    }]
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "workstats"
    }
  }, [_vm._v("工作统计")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "outLogin",
      "divided": _vm.type !== 'press' && _vm.type !== 'stats'
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(761),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 760:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "press"
    }
  }, [_c('headernav', {
    attrs: {
      "type": "press"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 761:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingStatus),
      expression: "loadingStatus"
    }],
    staticClass: "empty-content",
    attrs: {
      "element-loading-text": "玩命加载中..."
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "content-text"
  }, [_c('h2', [_c('p', [_vm._v("暂无内容")])])])])], 1)])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 762:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "stats"
    }
  }, [_c('headernav', {
    attrs: {
      "type": "stats"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "ieditorlist"
    }
  }, [_c('el-form', {
    staticClass: "head-form",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 7,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.filters.category),
      callback: function($$v) {
        _vm.$set(_vm.filters, "category", $$v)
      },
      expression: "filters.category"
    }
  }, _vm._l((_vm.formatCategory), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 15,
      "lg": 10
    }
  })], 1)], 1), _vm._v(" "), _c('emptyCont', {
    attrs: {
      "show": !_vm.getNewsdataLen
    }
  }), _vm._v(" "), _c('contentList', {
    attrs: {
      "newsdata": _vm.formatNewsData,
      "goUrl": _vm.goEdit,
      "limit": _vm.limit,
      "total": _vm.newstotal,
      "tipshow": "tipshow",
      "handlePageChange": _vm.handlePageChange,
      "urladdr": _vm.linkpath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-pagin"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "el-item shadow",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.page,
      "page-size": _vm.limit,
      "total": _vm.newstotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "statsedit"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 14,
      "lg": 10
    }
  }, [(_vm.editForm.edittime) ? _c('span', {
    staticClass: "header-tips fs-label"
  }, [_vm._v("上次保存于 " + _vm._s(_vm.editForm.edittime))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 8,
      "lg": 4
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelForm
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('editForm')
      }
    }
  }, [_vm._v("保存")])], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "editor-content"
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.rules,
      "label-width": "5rem"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类",
      "required": ""
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "start",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.editForm.category),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "category", $$v)
      },
      expression: "editForm.category"
    }
  }, _vm._l((_vm.formatCategory), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 2
    }
  }, [_vm._v("热度")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hotindex"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "热度"
    },
    on: {
      "change": _vm.handleHotChange
    },
    model: {
      value: (_vm.editForm.hotindex),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotindex", $$v)
      },
      expression: "editForm.hotindex"
    }
  }, _vm._l((_vm.formatHotlist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入标题",
      "icon": "circle-cross",
      "on-icon-click": _vm.handleTitleIconClick
    },
    model: {
      value: (_vm.editForm.title),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "title", $$v)
      },
      expression: "editForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 10,
        maxRows: 20
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.editForm.content),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "content", $$v)
      },
      expression: "editForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容来源",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sourcefrom"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "multiple-limit": 1,
      "filterable": "",
      "allow-create": "",
      "placeholder": "请选择内容来源"
    },
    on: {
      "change": _vm.handleSfChange
    },
    model: {
      value: (_vm.editForm.sourcefrom),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sourcefrom", $$v)
      },
      expression: "editForm.sourcefrom"
    }
  }, _vm._l((_vm.formatSourcefromlist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 2
    }
  }, [_vm._v("  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sourceurl"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "详细网址",
      "trigger-on-focus": false,
      "icon": "circle-cross",
      "on-icon-click": _vm.handleSourceurlChange
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.editForm.sourceurl),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sourceurl", $$v)
      },
      expression: "editForm.sourceurl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面图片",
      "prop": "cover"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "封面图片链接",
      "icon": "circle-cross",
      "on-icon-click": _vm.handleCoverChange
    },
    model: {
      value: (_vm.editForm.cover),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cover", $$v)
      },
      expression: "editForm.cover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签",
      "prop": "labels"
    }
  }, [_c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.editForm.labels), function(tag) {
    return _c('el-tag', {
      key: tag.id,
      staticClass: "editor-content-tags",
      attrs: {
        "type": "gray",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleLabelClose(tag)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tag) + "\n              ")])
  }), _vm._v(" "), _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.reqRcmdLabels
    }
  }, [_vm._v("获取推荐标签")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "newlabels"
    }
  }, [_c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.editForm.newlabels), function(newtag) {
    return _c('el-tag', {
      key: newtag.id,
      staticClass: "editor-content-tags",
      attrs: {
        "type": "gray",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(newtag)
        }
      }
    }, [_vm._v("\n              " + _vm._s(newtag) + "\n              ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ 新标签")])], 2)], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "statsif"
    }
  }, [_c('el-form', {
    staticClass: "head-form",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "event"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "change": _vm.handleEventChange
    },
    model: {
      value: (_vm.filters.event),
      callback: function($$v) {
        _vm.$set(_vm.filters, "event", $$v)
      },
      expression: "filters.event"
    }
  }, _vm._l((_vm.formatEvent), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions2
    },
    on: {
      "change": _vm.handleDateRangeChange
    },
    model: {
      value: (_vm.filters.daterange),
      callback: function($$v) {
        _vm.$set(_vm.filters, "daterange", $$v)
      },
      expression: "filters.daterange"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "el-item shadow",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-card', {
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatsDataLen),
      expression: "getStatsDataLen"
    }],
    ref: "ifcharts",
    staticClass: "ifchart-wrap",
    attrs: {
      "id": "ifcharts",
      "element-loading-text": "玩命加载中..."
    }
  })]), _vm._v(" "), _c('el-card', {
    staticStyle: {
      "margin-top": ".3rem"
    },
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getLoadingStatus),
      expression: "getLoadingStatus"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formatEventData,
      "element-loading-text": "玩命加载中...",
      "stripe": "",
      "max-height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "日期",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appid",
      "label": "appid",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "list",
      "label": "list",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "search",
      "label": "search",
      "min-width": "100"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ieditoredit"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 14,
      "lg": 10
    }
  }, [(_vm.editForm.edittime) ? _c('span', {
    staticClass: "header-tips fs-label"
  }, [_vm._v("上次保存于 " + _vm._s(_vm.editForm.edittime))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 8,
      "lg": 4
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelForm
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('editForm')
      }
    }
  }, [_vm._v("保存")])], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "editor-content"
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.rules,
      "label-width": "5rem"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类",
      "required": ""
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "start",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.editForm.category),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "category", $$v)
      },
      expression: "editForm.category"
    }
  }, _vm._l((_vm.formatCategory), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 2
    }
  }, [_vm._v("热度")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hotindex"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "热度"
    },
    on: {
      "change": _vm.handleHotChange
    },
    model: {
      value: (_vm.editForm.hotindex),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotindex", $$v)
      },
      expression: "editForm.hotindex"
    }
  }, _vm._l((_vm.formatHotlist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入标题",
      "icon": "circle-cross",
      "on-icon-click": _vm.handleTitleIconClick
    },
    model: {
      value: (_vm.editForm.title),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "title", $$v)
      },
      expression: "editForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 10,
        maxRows: 20
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.editForm.content),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "content", $$v)
      },
      expression: "editForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容来源",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sourcefrom"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "multiple-limit": 1,
      "filterable": "",
      "allow-create": "",
      "placeholder": "请选择内容来源"
    },
    on: {
      "change": _vm.handleSfChange
    },
    model: {
      value: (_vm.editForm.sourcefrom),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sourcefrom", $$v)
      },
      expression: "editForm.sourcefrom"
    }
  }, _vm._l((_vm.formatSourcefromlist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 2
    }
  }, [_vm._v("  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sourceurl"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "详细网址",
      "trigger-on-focus": false,
      "icon": "circle-cross",
      "on-icon-click": _vm.handleSourceurlChange
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.editForm.sourceurl),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sourceurl", $$v)
      },
      expression: "editForm.sourceurl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面图片",
      "prop": "cover"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "封面图片链接",
      "icon": "circle-cross",
      "on-icon-click": _vm.handleCoverChange
    },
    model: {
      value: (_vm.editForm.cover),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cover", $$v)
      },
      expression: "editForm.cover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签",
      "prop": "labels"
    }
  }, [_c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.editForm.labels), function(tag) {
    return _c('el-tag', {
      key: tag.id,
      staticClass: "editor-content-tags",
      attrs: {
        "type": "gray",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleLabelClose(tag)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tag) + "\n              ")])
  }), _vm._v(" "), _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.reqRcmdLabels
    }
  }, [_vm._v("获取推荐标签")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "newlabels"
    }
  }, [_c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.editForm.newlabels), function(newtag) {
    return _c('el-tag', {
      key: newtag.id,
      staticClass: "editor-content-tags",
      attrs: {
        "type": "gray",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(newtag)
        }
      }
    }, [_vm._v("\n              " + _vm._s(newtag) + "\n              ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ 新标签")])], 2)], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "auditlist"
    }
  }, [_c('el-form', {
    staticClass: "head-form",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.filters.category),
      callback: function($$v) {
        _vm.$set(_vm.filters, "category", $$v)
      },
      expression: "filters.category"
    }
  }, _vm._l((_vm.formatCategory), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 10
    }
  })], 1)], 1), _vm._v(" "), _c('emptyCont', {
    attrs: {
      "show": !_vm.getNewsdataLen
    }
  }), _vm._v(" "), _c('contentList', {
    attrs: {
      "newsdata": _vm.formatNewsData,
      "labelname": _vm.label,
      "goUrl": _vm.goEdit,
      "limit": _vm.limit,
      "total": _vm.newstotal,
      "handlePageChange": _vm.handlePageChange,
      "urladdr": _vm.linkpath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-pagin"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "el-item shadow",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.page,
      "page-size": _vm.limit,
      "total": _vm.newstotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 768:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "irecordlist"
    }
  }, [_c('el-form', {
    staticClass: "head-form",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.filters.category),
      callback: function($$v) {
        _vm.$set(_vm.filters, "category", $$v)
      },
      expression: "filters.category"
    }
  }, _vm._l((_vm.formatCategory), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 16,
      "lg": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "editor"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "选择编辑"
    },
    on: {
      "change": _vm.handleUserChange
    },
    model: {
      value: (_vm.filters.editor),
      callback: function($$v) {
        _vm.$set(_vm.filters, "editor", $$v)
      },
      expression: "filters.editor"
    }
  }, _vm._l((_vm.formatUsers), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('emptyCont', {
    attrs: {
      "show": !_vm.getNewsdataLen
    }
  }), _vm._v(" "), _c('contentList', {
    attrs: {
      "newsdata": _vm.formatNewsData,
      "labelname": _vm.label,
      "goUrl": _vm.goEdit,
      "limit": _vm.limit,
      "total": _vm.newstotal,
      "tipshow": "tipshow",
      "handlePageChange": _vm.handlePageChange,
      "urladdr": _vm.linkpath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-pagin"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "el-item shadow",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.page,
      "page-size": _vm.limit,
      "total": _vm.newstotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 769:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ieditor"
    }
  }, [_c('headernav', {
    attrs: {
      "type": "ieditor"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "statslist"
    }
  }, [_c('el-form', {
    staticClass: "head-form",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "state"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "change": _vm.handleStateChange
    },
    model: {
      value: (_vm.filters.state),
      callback: function($$v) {
        _vm.$set(_vm.filters, "state", $$v)
      },
      expression: "filters.state"
    }
  }, _vm._l((_vm.formatState), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 5,
      "sm": 5,
      "md": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions1
    },
    on: {
      "change": _vm.handleDateChange
    },
    model: {
      value: (_vm.filters.fsdate),
      callback: function($$v) {
        _vm.$set(_vm.filters, "fsdate", $$v)
      },
      expression: "filters.fsdate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 8,
      "sm": 8,
      "md": 7,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "searchterm"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入关键词",
      "icon": "circle-cross",
      "on-icon-click": _vm.handleClearClick
    },
    model: {
      value: (_vm.filters.searchterm),
      callback: function($$v) {
        _vm.$set(_vm.filters, "searchterm", $$v)
      },
      expression: "filters.searchterm"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 3,
      "sm": 3,
      "md": 3,
      "lg": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "searchbutton"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "search"
    },
    on: {
      "click": _vm.handleSearchClick
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('emptyCont', {
    attrs: {
      "show": !_vm.getStatsDataLen
    }
  }), _vm._v(" "), _c('contentList', {
    attrs: {
      "newsdata": _vm.formatNewsData,
      "goUrl": _vm.goEdit,
      "limit": _vm.limit,
      "total": _vm.statstotal,
      "handlePageChange": _vm.handlePageChange,
      "urladdr": _vm.linkpath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-pagin"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "el-item shadow",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.page,
      "page-size": _vm.limit,
      "total": _vm.statstotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "statslist"
    }
  }, [_c('el-form', {
    staticClass: "head-form",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "event"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "change": _vm.handleEventChange
    },
    model: {
      value: (_vm.filters.event),
      callback: function($$v) {
        _vm.$set(_vm.filters, "event", $$v)
      },
      expression: "filters.event"
    }
  }, _vm._l((_vm.formatEvent), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 6,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "user"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "选择用户"
    },
    on: {
      "change": _vm.handleUserChange
    },
    model: {
      value: (_vm.filters.user),
      callback: function($$v) {
        _vm.$set(_vm.filters, "user", $$v)
      },
      expression: "filters.user"
    }
  }, _vm._l((_vm.formatUsers), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 10,
      "sm": 10,
      "md": 10,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions1
    },
    on: {
      "change": _vm.handleDateRangeChange
    },
    model: {
      value: (_vm.filters.daterange),
      callback: function($$v) {
        _vm.$set(_vm.filters, "daterange", $$v)
      },
      expression: "filters.daterange"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getLoadingStatus),
      expression: "getLoadingStatus"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formatEventData,
      "element-loading-text": "玩命加载中...",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "日期",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "event",
      "label": "事件类型",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "detail",
      "label": "详细信息",
      "min-width": "460"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-pagin"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    staticClass: "el-item shadow",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next, jumper",
      "current-page": _vm.page,
      "page-size": _vm.limit,
      "total": _vm.eventtotal
    },
    on: {
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 772:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "irecord"
    }
  }, [_c('headernav', {
    attrs: {
      "type": "irecord"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 773:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "irecordedit"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 8
    }
  }, [_c('el-col', {
    staticClass: "header-tips",
    attrs: {
      "xs": 16,
      "sm": 14,
      "md": 14,
      "lg": 9
    }
  }, [_c('audio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.mediaurl),
      expression: "editForm.mediaurl"
    }],
    ref: "audioTag",
    staticClass: "header-tips-audio",
    attrs: {
      "id": "audioTag",
      "src": _vm.editForm.mediaurl,
      "controls": "controls",
      "controlsList": "nodownload",
      "oncontextmenu": "return false"
    }
  }, [_vm._v("\n      您的浏览器不支持 audio 标签。\n      ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 8,
      "lg": 5
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.editForm.done
    },
    on: {
      "click": function($event) {
        _vm.handleAuditFormEdit(_vm.newContent)
      }
    }
  }, [_vm._v("驳回")]), _vm._v(" "), _c('el-upload', {
    ref: "uploadTag",
    attrs: {
      "action": _vm.postUrl,
      "data": _vm.editForm.data,
      "multiple": false,
      "show-file-list": false,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "before-upload": _vm.handleBeforeUpload,
      "file-list": _vm.showMusicFileList
    }
  }, [(_vm.editForm.mediaurl) ? _c('el-button', {
    attrs: {
      "type": "info",
      "loading": _vm.editForm.uploadloading,
      "disabled": _vm.editForm.done
    }
  }, [_vm._v("重新上传")]) : _c('el-button', {
    attrs: {
      "type": "info",
      "loading": _vm.editForm.uploadloading,
      "disabled": _vm.editForm.done
    }
  }, [_vm._v("上传录音")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editForm.mediaurl),
      expression: "editForm.mediaurl"
    }],
    attrs: {
      "type": "success",
      "disabled": _vm.editForm.done
    },
    on: {
      "click": function($event) {
        _vm.releaseNews(_vm.newContent.id)
      }
    }
  }, [_vm._v("发布")])], 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('div', {
    staticClass: "editor-content"
  }, [_c('div', {
    staticClass: "news-box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('span', {
    staticClass: "new-type fs-label"
  }, [_vm._v(_vm._s(_vm.formatCategory))]), _vm._v(" "), _c('span', {
    staticClass: "hot-level fs-label"
  }, [_vm._v(_vm._s(_vm.formatHotIndex))])]), _vm._v(" "), _c('div', {
    staticClass: "box-title"
  }, [_c('h1', {
    staticClass: "fs-title"
  }, [_vm._v(_vm._s(_vm.newContent.title))])]), _vm._v(" "), _c('div', {
    staticClass: "box-author fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.newContent.date) + " ")]), _vm._v(" "), (_vm.newContent.editorname) ? _c('span', [_vm._v(" 编:" + _vm._s(_vm.newContent.editorname))]) : _vm._e(), _vm._v(" "), (_vm.newContent.hostname) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.hostname))]) : (_vm.newContent.host) ? _c('span', [_vm._v(" 播:" + _vm._s(_vm.newContent.host))]) : _vm._e(), _vm._v(" "), (_vm.newContent.verifiername) ? _c('span', [_vm._v(" 审:" + _vm._s(_vm.newContent.verifiername))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 20,
      "sm": 20,
      "md": 12,
      "lg": 10
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newContent.cover),
      expression: "newContent.cover"
    }],
    staticClass: "box-image",
    attrs: {
      "src": _vm.newContent.cover
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('p', {
    staticClass: "box-text fs-text"
  }, [_vm._v(_vm._s(_vm.newContent.content))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-source fs-text"
  }, [_c('span', [_vm._v("新闻来源:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatSourcefrom))])]), _vm._v(" "), _c('div', {
    staticClass: "box-origin fs-text"
  }, [_c('span', [_vm._v("原文地址:")]), _c('a', {
    attrs: {
      "href": _vm.newContent.sourceurl,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "link-url"
  }, [_vm._v(_vm._s(_vm.newContent.sourceurl))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-foot fs-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatLabels2))])])])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.auditFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.auditFormVisible),
      callback: function($$v) {
        _vm.auditFormVisible = $$v
      },
      expression: "auditFormVisible"
    }
  }, [_c('el-form', {
    ref: "auditForm",
    attrs: {
      "model": _vm.auditForm,
      "rules": _vm.auditFormRules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "移动至",
      "prop": "state"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.auditForm.state),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "state", $$v)
      },
      expression: "auditForm.state"
    }
  }, _vm._l((_vm.formatAuditType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原因",
      "prop": "tip"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 60
      },
      "placeholder": "请输入驳回理由，可选。"
    },
    model: {
      value: (_vm.auditForm.tip),
      callback: function($$v) {
        _vm.$set(_vm.auditForm, "tip", $$v)
      },
      expression: "auditForm.tip"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.auditFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.auditFormBtn))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 774:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ieditorquery"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "header-tips",
    attrs: {
      "xs": 16,
      "sm": 16,
      "md": 14,
      "lg": 10
    }
  }, [(_vm.editForm.edittime) ? _c('span', [_vm._v("上次保存于 " + _vm._s(_vm.editForm.edittime))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 8,
      "lg": 4
    }
  }, [_c('span', {
    staticClass: "header-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('editForm')
      }
    }
  }, [_vm._v("保存")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "editor-content"
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "background": "white",
      "padding": "1.2rem 0"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 14
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分类",
      "required": ""
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.editForm.category),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "category", $$v)
      },
      expression: "editForm.category"
    }
  }, _vm._l((_vm.formatCategory), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 3
    }
  }, [_vm._v("  热度")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hotindex"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "热度"
    },
    on: {
      "change": _vm.handleHotChange
    },
    model: {
      value: (_vm.editForm.hotindex),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotindex", $$v)
      },
      expression: "editForm.hotindex"
    }
  }, _vm._l((_vm.formatHotlist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入标题",
      "icon": "circle-cross",
      "on-icon-click": _vm.handleTitleIconClick
    },
    model: {
      value: (_vm.editForm.title),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "title", $$v)
      },
      expression: "editForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 10,
        maxRows: 20
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.editForm.content),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "content", $$v)
      },
      expression: "editForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容来源",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sourcefrom"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "multiple-limit": 1,
      "filterable": "",
      "allow-create": "",
      "placeholder": "请选择内容来源"
    },
    on: {
      "change": _vm.handleSfChange
    },
    model: {
      value: (_vm.editForm.sourcefrom),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sourcefrom", $$v)
      },
      expression: "editForm.sourcefrom"
    }
  }, _vm._l((_vm.formatSourcefromlist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 2
    }
  }, [_vm._v("  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sourceurl"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "详细网址",
      "trigger-on-focus": false,
      "icon": "circle-cross",
      "on-icon-click": _vm.handleSourceurlChange
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.editForm.sourceurl),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sourceurl", $$v)
      },
      expression: "editForm.sourceurl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面图片",
      "prop": "cover"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "封面图片链接",
      "icon": "circle-cross",
      "on-icon-click": _vm.handleCoverChange
    },
    model: {
      value: (_vm.editForm.cover),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cover", $$v)
      },
      expression: "editForm.cover"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签",
      "prop": "labels"
    }
  }, [_c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.editForm.labels), function(tag) {
    return _c('el-tag', {
      key: tag.id,
      staticClass: "editor-content-tags",
      attrs: {
        "type": "gray",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleLabelClose(tag)
        }
      }
    }, [_vm._v("\n                " + _vm._s(tag) + "\n                ")])
  }), _vm._v(" "), _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.reqRcmdLabels
    }
  }, [_vm._v("获取推荐标签")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "newlabels"
    }
  }, [_c('el-col', {
    staticClass: "el-item",
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.editForm.newlabels), function(newtag) {
    return _c('el-tag', {
      key: newtag.id,
      staticClass: "editor-content-tags",
      attrs: {
        "type": "gray",
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(newtag)
        }
      }
    }, [_vm._v("\n                " + _vm._s(newtag) + "\n                ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ 新标签")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1px",
      "height": "80%",
      "background": "#939393"
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22,
      "lg": 9
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "rules": _vm.rules,
      "label-width": "40px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原文",
      "prop": "origintext"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": true,
      "autosize": {
        minRows: 10,
        maxRows: 26
      }
    },
    model: {
      value: (_vm.newContent.origintext),
      callback: function($$v) {
        _vm.$set(_vm.newContent, "origintext", $$v)
      },
      expression: "newContent.origintext"
    }
  })], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 815:
/***/ (function(module, exports) {

module.exports = {"name":"ibroadcast","version":"2.3.3","description":"摘闻","author":"LIPan <panlee@qq.com>","private":true,"scripts":{"dev":"node build/dev-server.js","build":"node build/build.js","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","deploy":"fis3 release sbox","analyz":"NODE_ENV=production npm_config_report=true npm run build"},"dependencies":{"crypto-js":"^3.1.8","axios":"^0.15.3","echarts":"^3.4.0","element-ui":"^1.2.3","react-cookie":"^1.0.4","vue":"^2.2.2","vue-router":"^2.2.0","vuex":"^2.2.1","vuex-router-sync":"^4.0.2"},"devDependencies":{"axios-mock-adapter":"^1.7.1","mockjs":"^1.0.1-beta3","autoprefixer":"^6.7.2","babel-preset-es2015":"^6.22.0","babel-core":"^6.22.1","babel-eslint":"^7.1.1","babel-loader":"^6.2.10","babel-plugin-istanbul":"^3.1.2","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.2.1","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chai":"^3.5.0","chalk":"^1.1.3","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","cross-env":"^3.1.4","cross-spawn":"^5.0.1","css-loader":"^0.26.1","eslint":"^3.14.1","eslint-config-standard":"^6.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.0","eslint-plugin-promise":"^3.4.0","eslint-plugin-standard":"^2.0.1","eventsource-polyfill":"^0.9.6","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.10.0","friendly-errors-webpack-plugin":"^1.1.3","function-bind":"^1.1.0","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.3","inject-loader":"^2.0.1","karma":"^1.4.1","karma-coverage":"^1.1.1","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.2","karma-sinon-chai":"^1.2.4","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.26","karma-webpack":"^2.0.2","lolex":"^1.5.2","mocha":"^3.2.0","nightwatch":"^0.9.12","node-sass":"^4.5.0","opn":"^4.0.2","optimize-css-assets-webpack-plugin":"^1.3.0","ora":"^1.1.0","phantomjs-prebuilt":"^2.1.14","rimraf":"^2.6.0","sass-loader":"^6.0.3","selenium-server":"^3.0.1","semver":"^5.3.0","sinon":"^2.1.0","sinon-chai":"^2.8.0","url-loader":"^0.5.7","vue-loader":"^11.1.4","vue-style-loader":"^2.0.0","vue-template-compiler":"^2.2.4","webpack":"^2.2.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.16.1","webpack-merge":"^2.6.1"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(759),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[348]);


// WEBPACK FOOTER //
// static/js/app.7d5f77857af7345d411d.js